import React, { Component } from "react";
import { connect } from "react-redux";
import { ActionCreators } from "redux-undo";
import { Container, Col, Row, Modal } from "react-bootstrap";
import {
  extractFontsFromState,
  generateGoogleFontsLink,
  checkFontsAvailability,
  isSupportedGoogleFont,
  isLocalFont,
} from "../../common/font_extractor.es6";
import {
  updateDefaultTextsToContentLanguage,
  blurCKEditor,
  TEXT_FORMAT_CSS_PROP,
  forceHtmlCssProperty,
  TEXT_TOGGLE_KEYS,
  toggleHtmlCssProperty,
  stripHtmlCssProperty,
  materializeTextDecorations,
  deriveTextFormatState,
  getBoxContentEl,
  previewCssOnBox,
} from "../../common/common_tools";
import {
  addNavItem,
  selectNavItem,
  expandNavItem,
  deleteNavItem,
  reorderNavItem,
  toggleNavItem,
  updateNavItemExtraFiles,
  addBox,
  addBoxThunk,
  selectBox,
  moveBox,
  changeStartAnimation,
  changeMiddleAnimation,
  changeEndAnimation,
  changeFinalAnimation,
  changeAnimationPositionNumber,
  changeShowAnimation,
  resizeBox,
  rotateBox,
  updateBox,
  updateBoxTimeline,
  updateBoxExitAnimation,
  deleteBoxExitAnimation,
  deleteBox,
  reorderSortableContainer,
  dropBox,
  increaseBoxLevel,
  resizeSortableContainer,
  deleteSortableContainer,
  changeCols,
  changeRows,
  changeBackground,
  changeSortableProps,
  reorderBoxes,
  verticallyAlignBox,
  selectIndex,
  duplicateNavItem,
  duplicateNavItemByPayload,
  toggleTextEditor,
  pasteBox,
  changeBoxLayer,
  configScore,
  exportStateAsync,
  importStateAsync,
  importState,
  IMPORT_STATE,
  changeGlobalConfig,
  uploadVishResourceAsync,
  importEdi,
  deleteContainedView,
  selectContainedView,
  addRichMark,
  editRichMark,
  moveRichMark,
  deleteRichMark,
  setCorrectAnswer,
  updateViewToolbar,
  updatePluginToolbar,
  applyImageUrlMap,
  addNavItems,
  deleteRemoteFileVishAsync,
  setBusy,
  uploadTemplate,
  deleteTemplate,
  addSound,
  deleteSound,
  editSound,
  setSceneAudioRowOrders,
  addAnimation,
  saveAnimation,
  deleteAnimation,
  updateTextAnimation,
  updateBoxAnimation,
  deleteTextAnimation,
  deleteBoxAnimation,
  selectBoxAll,
  selectBoxToggle,
  ttsGenerateSoundFile,
  ttiGenerateImageFile,
  ttsGetSoundMetaFile,
  syncSceneSuccess,
  changeNavItemDuration,
  batchUpdateMandatoryDefaults,
  batchUpdateSceneDuration,
  batchSetSceneFont,
  repairMediaTimelines,
  migrateLegacyGuides,
  migrateLegacySoundLists,
  pasteScene,
  removeInteractiveItem,
  selectInteractiveItem,
  setInteractiveMode,
  selectScene,
  addScene,
  removeScene,
  selectScenarioElement,
  addScenarioElement,
  removeScenarioElement,
  updateScenarioElement,
  updateScene,
} from "../../common/actions";
import { createEmptyTrainingState } from "../../core/store/state.es6";
import {
  setContentLanguage,
  normalizeContentLanguage,
  getProfileContentLanguage,
  getContentLanguage,
} from "../../common/content_language";
import { sceneTimeBus } from "../../common/scene_clock.es6";
import { migrateBoxesForRatio } from "../../common/aspect_ratio_migration.es6";
import {
  createAudioSyncState,
  driveAudioSync,
  resetAudioSync,
  seekAudioSync,
  setAudioSyncRate,
} from "../../common/audio_sync.es6";
import {
  isRouted,
  openTimelineAudio,
  unrouteAudio,
  wakeAudioGraph,
} from "../../common/audio_graph.es6";
import { elementHolder } from "../../common/media_holders.es6";
import { alignBoxes } from "../components/canvas/multi_select_shortcuts/alignBoxes";
import EditorCanvas from "../components/canvas/editor_canvas/EditorCanvas";
import CanvasTopToolbar from "../components/canvas/canvas_overlay/CanvasTopToolbar";
import CanvasAlignToolbar from "../components/canvas/canvas_overlay/CanvasAlignToolbar";
import StyleClipboardBar from "../components/canvas/canvas_overlay/StyleClipboardBar";
import {
  buildStylePayload,
  clearStyleClipboard,
  copyStyle,
  eligibleStyleTargets,
  getStyleClipboard,
  subscribeStyleClipboard,
} from "../utils/styleClipboard";
import { applyStyleToBoxes } from "../utils/applyStyleToBoxes";
import { addMotionSceneBox } from "../utils/motionSceneBox";
import { tabInDialog } from "../utils/tabInDialog";
import CanvasZoomControl from "../components/canvas/canvas_overlay/CanvasZoomControl";
import AnimateAvatarsButton from "../components/avatar_animate/AnimateAvatarsButton";
import LeftPanelTab from "../components/canvas/canvas_overlay/LeftPanelTab";
import { editorLayerTimes } from "../../plugins/AtomicBoxPlugin/contexts/editorLayerTimes";
// === Task 25 === Floating workflow FAB (visible only for InteractivePlugin
// boxes with items); mounted inside the canvas area below.
import WorkflowFAB from "../components/workflow/WorkflowFAB";
// === Interactivity Studio mount === Single modal that hosts the Workflow
// editor, Suggestions rail, and Flow Viewer tabs. Replaces the legacy
// WorkflowOverlay + FlowViewer mounts.
import InteractivityStudio from "../components/interactivity_studio/InteractivityStudio";
// === Phase B Task 4 === Docked Workflow panel — sits as a third column in
// mainRow, beside the workspace. Self-gated on canvasWorkflow.docked + the
// presence of an InteractivePlugin box on the active scene; renders null
// otherwise so the flex layout collapses cleanly.
import CanvasWorkflowPanel from "../components/canvas_workflow/CanvasWorkflowPanel";
import {
  defaultForScene,
  defaultForElement,
  emptyScenario,
  ELEMENT_TYPES,
} from "../../plugins/InteractivePlugin/schema";
import ElementPropertyEditor from "../../plugins/InteractivePlugin/components/ElementPropertyEditor";
import ContainedCanvas from "../components/rich_plugins/contained_canvas/ContainedCanvas";
import LeftPanel from "./LeftPanel";
import { LEFT_PANEL_EXPANDED_WIDTH_PX } from "../components/carousel/editor_carousel/EditorCarousel";
import {
  canEditInDirector,
  isDirectorVideo,
} from "../components/carousel/audio/video-director/edl";
import PluginRibbon from "../components/nav_bar/plugin_ribbon/PluginRibbon";
import AudioPlugin from "../components/nav_bar/audio_plugin/AudioPlugin";
import ActionsRibbon from "../components/nav_bar/actions_ribbon/ActionsRibbon";
import EditorNavBar from "../components/nav_bar/editor_nav_bar/EditorNavBar";
import { exportClmZip } from "../components/nav_bar/export/clm/clmZipBuilder";
import { validateClmState } from "../components/nav_bar/export/clm/clmResolvers";
import { sceneChoices } from "../../core/visor/sceneScormState";
import ServerFeedback from "../components/server_feedback/ServerFeedback";
import Toolbar from "../components/toolbar/toolbar/Toolbar";
import EditorModals from "../components/EditorModals";
import MotionAiEditHost from "../components/add_image_modal/MotionAiEdit";

import { createFontLoader } from "../hooks/useEditorFonts";
import { loadOrgBrandFonts } from "../utils/brandFonts";

import {
  CANVAS_ZOOM_MIN,
  CANVAS_ZOOM_MAX,
  CANVAS_ZOOM_STEP,
  LEFT_PANEL_WIDTH,
  LEFT_PANEL_OVERLAY_WIDTH,
  TIMELINE,
  CANVAS_AREA_BOTTOM_PADDING,
  RIGHT_RAIL,
} from "../../common/layout_constants";
// Opt-in, session-scoped autosave. 2 minutes bounds how much work a crash/
// closed-tab can lose without saving so often it hammers the endpoint or
// (even in quiet mode, see ideaEnvSaveState) shows up as constant network
// activity. Same tick also recomputes the unsaved-changes pulse next to
// Save, so the dot and the actual save stay in lockstep.
const AUTOSAVE_INTERVAL_MS = 2 * 60 * 1000;
import { createLmsExporter } from "../hooks/useLmsExport";
import { createGlobalDragDrop } from "../hooks/useGlobalDragDrop";
import { createKeyboardListener } from "../hooks/useKeyboardListener";
import { createUnsavedChangesGuard } from "../hooks/useUnsavedChangesGuard";
import TimelineSection from "../components/timeline/TimelineSection";
import IdeaTimeline from "../components/timeline/IdeaTimeline";
import { buildLayersFromBoxes } from "../components/timeline/IdeaTimeline/utils/buildLayers";
import AnimationPanel from "../components/timeline/IdeaTimeline/components/AnimationPanel";
import { setNestedAnimation } from "../../plugins/AtomicBoxPlugin/animations/setNestedAnimation";
import { decodeAtomicText } from "../../plugins/AtomicBoxPlugin/atomic_box_plugin_config";
import {
  isTextLeafPath,
  getAtomicElementUiType,
} from "../../plugins/AtomicBoxPlugin/animations/atomicAnimationSchema";
import { humanizeFieldPath } from "../components/timeline/IdeaTimeline/utils/humanizeFieldPath";
import { selectedSubFieldPaths } from "../components/timeline/IdeaTimeline/utils/subFieldSelection";
import KnollingView from "../components/timeline/IdeaTimeline/components/KnollingView";
import { ImageAnimatorModal } from "../components/merlin/ImageAnimatorModal";
import AreaOpsModal from "../components/merlin/area_ops/AreaOpsModal";
import VideoMerlinDrawer from "../components/merlin/VideoMerlinDrawer";
import AnimatorPanel from "../components/merlin/AnimatorPanel";
import { decomposeBoxWithAideaSmartElements } from "../../common/aideaSmartElements.es6";
import { applyExtractedTextLayers } from "../../common/extractTextLayers.es6";
import { waitForJob } from "../../common/job_poll.es6";
import { markMotionAutoApply } from "../utils/motionAutoApply";
import { applyMotionResult } from "../utils/applyMotionPlan";
import { applyAnimationResult } from "../utils/applyAnimationResult.es6";
import {
  collectMediaTimelinePatches,
  findLegacyMediaBoxes,
} from "../utils/mediaTimelineRepair.es6";
import { getMediaDuration } from "../components/timeline/IdeaTimeline/utils/buildLayers";
import { markEditorLoaded } from "../utils/authRequired";
import { getUndoRedoIntent, isContentEditableFocus } from "../utils/undoRedoShortcut";
import {
  getUndoSignature,
  hasUndoSignatureChanged,
  shouldShowUnsavedPulse,
  shouldAutosaveTick,
} from "../utils/autosaveDecision.es6";
import { ungroupAideaSmartElement } from "../../common/actions.es6";
import { withFreshSoundIds } from "../../common/sound_id.es6";
import { notifyInsufficientBalance } from "../utils/insufficientBalance";
import { runMotionDirector } from "../components/ai-chat/runMotionDirector";
import {
  applyAnswerRemoval,
  applyDragDropAnswerRemoval,
  applyAnswerMove,
  applyMatchingRightSwap,
  applyMatchingAnswerRemoval,
  TEXT_FORMAT_KEYS,
} from "../components/canvas/editor_shortcuts/answerReflow";
import ThemePaletteModal from "../components/nav_bar/scene_theme_palette/ThemePaletteModal";
import HtmlEditModal from "../components/common/html_edit_modal/HtmlEditModal";
import AutoSave from "../components/autosave/AutoSave";
import Alert from "../components/common/alert/Alert";
import EditorAlerts from "../components/EditorAlerts";
import ToggleSwitch from "@trendmicro/react-toggle-switch";
import i18n from "i18next";
import { syncScene } from "../services/syncSceneService";
import {
  parsePluginContainers,
  parsePluginContainersReact,
  hasExerciseBox,
} from "../../common/plugins_inside_plugins";
import IdealStudio from "../../core/editor/main";
import printToPDF from "../../core/editor/print";
import {
  isSortableBox,
  isSection,
  isSlide,
  isPage,
  isContainedView,
  getDescendantLinkedBoxes,
  isBox,
  getDescendantBoxes,
  getDescendantBoxesFromContainer,
  isSortableContainer,
  withSidecarSuffix,
} from "../../common/utils";
import { resolveBoxEndFrame } from "../../common/resolveBoxTiming.es6";
import "typeface-ubuntu";
import "typeface-source-sans-pro";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import {
  ID_PREFIX_BOX,
  ID_PREFIX_PAGE,
  PAGE_TYPES,
  MATCHING_RIGHT_OFFSET,
} from "../../common/constants";
import { createBox } from "../../common/common_tools";
const html2json = require("html2json").html2json;
import {
  addDefaultSceneHeader,
  migrateLegacySceneHeaders,
} from "../components/canvas/scene_header_factory";
import IdealStudioTour from "../components/joyride/IdealStudioTour";
import { serialize } from "../../reducers/serializer";
import { applyCourseFontToToolbars } from "../../reducers/plugin_toolbars_by_id";
import screen from "../components/joyride/pantalla.svg";
import help from "../components/joyride/help.svg";
import Cookies from "universal-cookie";
import ExitModal from "../components/exit_modal/ExitModal";
import UnsavedChangesGuardModal from "../components/unsaved_changes_guard/UnsavedChangesGuardModal";
import SaveBeforeSyncModal from "../components/unsaved_changes_guard/SaveBeforeSyncModal";
import SaveConflictModal from "../components/save_conflict/SaveConflictModal";
import StaleTrainingBanner from "../components/common/StaleTrainingBanner";
import LegacyTimelineRepairModal from "../components/legacy_timeline/LegacyTimelineRepairModal";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import {
  applyBoxAnimation,
  applyBoxExitAnimation,
  previewBoxAnimation,
  resetElementAnimationState,
  resetAllEditorAnimations,
  getBoxAnimationPresets,
  getBoxExitAnimationPresets,
} from "../utils/animationHelpers";
import {
  createAnimationScene,
  interpolateAnimationFrame,
  resetAnimationPositions,
} from "../utils/editorAnimationControls";
import OneClickEditModal from "../components/rich_plugins/oneclick_edit_modal/OneClickEditModal";
import { file } from "jszip";
import {
  renderMandatoryPopup,
  setMandatoryPopupForceUpdate,
} from "../../core/editor/accordion_provider";
import {
  _LSCheckLmsStatus,
  _saveAs,
  fetchVoiceProfile,
  fetchSubtitleLanguages,
  fetchAllSubtitlesForLanguage,
  ideaEnvSaveState,
} from "../../common/server_utils.es6";
import { getLoginBaseUrl, getUserId, whenEnvironmentReady } from "../../common/environment_config";
import { setBaseUpdatedAt } from "../../common/saveConflict.es6";
import { narrationVolume } from "../../common/sceneTimeline.es6";
import {
  LOCAL_DRAFT_NOTICE_EVENT,
  createDraftScheduler,
  decideDraftPrompt,
  deleteDraft,
  getContentSignature,
  getDraft,
  purgeOldDrafts,
  putDraft,
  saveDraftFromState,
  takeLegacyDraft,
} from "../../common/localDraftStore.es6";
import ChatPanel from "../components/ai-chat/ChatPanel"; // B1 — agentic-chat UI (assistant-ui + scoped Tailwind)
import BuildChat, { BuildThread } from "../components/ai-chat/BuildChat";
import { BuildCanvasOverlay } from "../components/ai-chat/BuildGhosts";
import {
  isBuildLocked,
  readBuildParams,
  replaceBuildJob,
  restoredBuildState,
  setBuildLocked,
  stripBuildParams,
  withBuildParams,
} from "../components/ai-chat/buildMode";
import { fetchActiveBuild } from "../components/ai-chat/buildApi";
import HelpHub from "../components/help/HelpHub"; // in-editor feature guides (opens on aidea:openHelpHub)
import KeyboardShortcutsOverlay from "../components/help/KeyboardShortcutsOverlay";
import { MdTune, MdAnimation } from "react-icons/md";
import {
  LuSparkles,
  LuLayers,
  LuCopy,
  LuCopyPlus,
  LuPaintbrush,
  LuPen,
  LuReplace,
  LuUpload,
  LuClapperboard,
  LuUngroup,
  LuTrash2,
  LuSettings2,
  LuMaximize,
  LuMaximize2,
  LuPlus,
  LuMove,
  LuMic,
  LuAArrowUp,
  LuAArrowDown,
  LuLayoutList,
  LuWrench,
  LuCrop,
  LuSquare,
  LuImageOff,
  LuPipette,
} from "react-icons/lu";
import RightIconStrip, { SceneIconButton } from "../components/right_panel/RightIconStrip";
import { pillDismissalForTab, isPillDismissalStale } from "../utils/rightDrawerPill";
import { animationDrawerStackFloors, DRAWER_STACK_GAP } from "../utils/animationDrawerStack";
import { sceneMandatoryPayloads, questionSceneIds } from "../../common/sceneDefaults.es6";
import LayersPanel from "../components/timeline/LayersPanel";
import RightPanelShell, {
  HEADER_HEIGHT as RIGHT_PANEL_HEADER_HEIGHT,
} from "../components/right_panel/RightPanelShell";
import ToolsPanel from "../components/right_panel/ToolsPanel";
const cookies = new Cookies();
// Live Motion Build chat-only mode (?chat=1&draft=&job=): read once — the code
// exchange strips only `code`/`token` from the URL.
const BUILD_PARAMS = typeof window !== "undefined" ? readBuildParams() : null;

function applyMandatoryToAllScenes(state, mandatory) {
  if (!mandatory) return state;
  const { scene, question } = sceneMandatoryPayloads(mandatory);
  const questionIds = questionSceneIds(state);
  const next = { ...state.viewToolbarsById };
  for (const id of Object.keys(next)) {
    next[id] = { ...next[id], ...(questionIds.includes(id) ? question : scene) };
  }
  return { ...state, viewToolbarsById: next };
}

function applyDurationToAllScenes(state, duration) {
  // duration lives on navItemsById (per Task 4 fix) — apply to non-root nav items only.
  const next = { ...state.navItemsById };
  for (const id of Object.keys(next)) {
    if (String(id) === "0" || next[id].type === "root") continue;
    next[id] = { ...next[id], duration };
  }
  return { ...state, navItemsById: next };
}

// Plugins that render from the timeline playhead rather than a clock of their
// own. Both read the box-relative time off the event below; keeping the list
// here means a new time-driven plugin is one entry, not a new event.
const TIME_DRIVEN_PLUGINS = ["Character", "MotionScene"];

// Image urls the AI Wizard (Görseli Düzenle / ImageAnimatorModal) can't edit.
const MERLIN_UNSUPPORTED_EXT = /\.(webp|webm|mp4|gif|svg)(\?.*)?$/;
// An image box already turned into an animation (webp). Its AI Wizard is the
// animation popup (ImageAnimatorModal), not Görseli Düzenle — see
// _openAnimationWizard.
const ANIMATED_IMAGE_EXT = /\.webp(\?.*)?$/;
// A box url that is an animation/video, not a still: a still edited for a
// re-animate must not be written onto it (see _editAnimationSource).
const ANIMATION_URL_EXT = /\.(webp|gif|mp4|webm|mov|m4v)(\?.*)?$/;

// Feed a time-driven plugin the timeline playhead (box-relative seconds) each
// tick so its motion follows the timeline instead of a free clock. No-op for
// every other box. The event name is historical — CharacterPlayback and
// MotionScenePlayback both listen for it.
function emitCharacterTime(present, layerId, animationInfo) {
  const tb = present?.pluginToolbarsById?.[layerId];
  if (!tb || TIME_DRIVEN_PLUGINS.indexOf(tb.pluginId) === -1) return;
  const inRange = animationInfo.inRange !== false;
  const t =
    typeof animationInfo.layerRelativeTime === "number" ? animationInfo.layerRelativeTime : 0;
  try {
    window.dispatchEvent(new CustomEvent("aidea:char-time", { detail: { layerId, t, inRange } }));
  } catch (_) {
    /* older browsers: ignore */
  }
}

const COMPONENT_CATEGORIES = ["Assessments", "Icons", "Animations", "Characters", "Youtube"];
function resolveReplaceTarget(componentType, url, accept) {
  if (COMPONENT_CATEGORIES.includes(componentType)) {
    return { leftPanel: "elementsLibrary", assessmentCategory: componentType };
  }
  if (componentType === "OrgFiles") {
    return { leftPanel: "library", libraryCategory: "Organization Files" };
  }
  if (componentType === "MyFiles") {
    return { leftPanel: "library", libraryCategory: "My Files" };
  }

  const acc = (accept || "").toLowerCase();
  if (acc.includes("video") || acc.includes("audio")) {
    return { leftPanel: "library", libraryCategory: "My Files" };
  }
  const u = url || "";
  // Component-category markers (legacy items without a componentType) win first.
  const inferred = /youtube\.com|youtu\.be/i.test(u)
    ? "Youtube"
    : /\/Animasyon\//i.test(u)
      ? "Animations"
      : /\/KKarakter\//i.test(u)
        ? "Characters"
        : null;
  if (inferred) return { leftPanel: "elementsLibrary", assessmentCategory: inferred };
  // Media (video/audio/pdf) is a Library file → My Files, even when its URL sits
  // under /library/ (e.g. /library/Video/*.mp4) which the rule below would
  // otherwise mis-read as an Icon. Type comes from the plugin's accept.
  if (/video|audio|pdf/.test((accept || "").toLowerCase())) {
    return { leftPanel: "library", libraryCategory: "My Files" };
  }
  if (/\/library\//i.test(u)) {
    return { leftPanel: "elementsLibrary", assessmentCategory: "Icons" };
  }
  return { leftPanel: "library", libraryCategory: "My Files" };
}

// Plugin'in "style" akordeonundaki default kutu stillerini (padding, arka plan,
// kenarlık, köşe yarıçapı vb.) türetir. Panelden ekleme (common_tools.createBox)
// bu stilleri toolbar.main.accordions.style.buttons üzerinden uygular; AI üretim
// yolu bunu atlayıp API'nin ham box.style'ını kullandığı için değerlendirme
// kutularının beyaz kart sarmalayıcısı (zemin + padding) kaybolup içerik kayıyordu.
// Default'lar taban, API'nin gönderdiği style üzerine yazılır (createBox ile aynı sıra).
function derivePluginBoxStyle(pluginId, pluginState) {
  try {
    const plugin = IdealStudio?.Plugins?.get(pluginId);
    if (!plugin?.getToolbar) return {};
    const tb = plugin.getToolbar(pluginState || plugin.getInitialState?.() || {});
    const styleButtons = tb?.main?.accordions?.style?.buttons;
    if (!styleButtons) return {};
    const styles = {};
    Object.keys(styleButtons).forEach((k) => {
      styles[k] = styleButtons[k].value;
    });
    return styles;
  } catch {
    return {};
  }
}

/**
 * Görsel Ekle'nin iki üretken sekmesi (3B obje / hareketli görsel): backend
 * hazır kutuyu döndürüyor — hangi plugin, hangi state, (motionda) hangi
 * timeline uzunluğu — burada yerleştirmekten başka iş yok.
 *
 * İKİSİ DE sahneye eklenen bir ÖĞE: kendi ölçüsüyle gelir, istenen yere
 * sürüklenir, boyutlandırılır. Tam ekran isteyen, kutu seçiliyken çıkan
 * pill'den "Ekrana Sığdır"a basar. (Motionize akışının kutusu bunun tersine
 * tam ekran ve sabit gelir — orada motion SAHNENİN KENDİSİ.)
 *
 * İki yerden çağrılır: modalın onay kartı ve iş widget'ının "Sahneye ekle"si
 * (JobWidgetHost) — ikisi ayrı kopyalar olsaydı biri diğerinden kopardı.
 */
function insertSceneVisualBox(dispatch, result, targetNavId) {
  if (!result?.box || !result?.toolbar || !targetNavId) return false;
  const { box, toolbar } = result;
  const boxId = result.boxId || box.id;
  const structure = toolbar.structure || {};

  dispatch(
    addBox(
      { id: boxId, parent: targetNavId, container: 0 },
      // addBox(ids, draggable, resizable, …)
      true,
      true,
      "",
      toolbar.style || {},
      toolbar.state || {},
      toolbar.structure,
      {
        name: toolbar.pluginId,
        position: box.position || { x: "0%", y: "0%", type: "absolute" },
        width: structure.width ?? 70,
        height: structure.height ?? 70,
        widthUnit: "%",
        heightUnit: "%",
      }
    )
  );
  // Motion kutusu süresini taşır (endFrame); 3B objede timeline yok.
  if (box.timeline) dispatch(updateBoxTimeline(boxId, box.timeline));
  return true;
}

class EditorApp extends Component {
  constructor(props) {
    super(props);
    this.index = 0;
    this.severalBoxes = 0;
    this.unsavedWorkRestored = false; // Flag to track if unsaved work was restored
    this._subtitleBundleCache = null;
    this._subtitleBundleCacheKey = null;
    // Baseline redux-undo signature the unsaved-changes pulse and the nav
    // guard diff against — updated by every successful save (manual Save,
    // ExitModal, the nav guard's "Save and leave", post-import,
    // AnimatorPanel's onSaved, and the autosave tick's own success). See
    // _autosaveTick() and autosaveDecision.es6.
    this._autosaveLastSignature = null;
    // Plain in-flight guard for the autosave tick (not state — doesn't
    // drive render, mirrors window.bulkAnimateApplying/animatorPanelSaving).
    this._autosaveSaving = false;
    // Set immediately before a timeline-originated dispatch(selectBox(...))
    // so the next componentDidUpdate can skip auto-opening a right panel —
    // canvas-originated selection still auto-opens. Read-and-cleared at the
    // top of componentDidUpdate.
    this._suppressAutoPanelOnce = false;
    // One-shot canvas preview started by AnimationPanel's onApplyEntry/
    // onApplyExit (previewBoxAnimation's own RAF loop, plus the setTimeout
    // that lands the playhead once it finishes) — cancelled by
    // _cancelBoxAnimPreview() whenever the user seeks the timeline or
    // deselects the box, so it can't keep fighting the new position.
    this._boxAnimPreviewCancel = null;
    this._boxAnimPreviewTimeout = null;
    this._boxAnimPreviewBoxId = null;
    this.remotionTimelineRef = React.createRef();
    this.ideaTimelineRef = React.createRef();
    this.clipboardRef = React.createRef();
    // Recorder/render-mode is handled at the top of index.jsx by
    // redirecting to /index_visor.html. By the time we get here, we're
    // a regular editor mount — no special URL handling needed.
    this.state = {
      alert: null,
      // navId → { jobId, kind: "motion" | "extract" } while a Sync with AI job runs: that scene is locked
      motionBusy: {},
      // navId → "syncing" | "extracting" | "motionizing" | "success" while that scene's Sync with AI
      // runs (sync, then its job): one loading overlay on that scene only, from click to result
      syncByScene: {},
      pluginTab: "",
      hideTab: "show",
      leftPanel: "layers",
      rightControlsHover: false,
      visorVisible: false,
      // Opt-in, session-scoped autosave (never persisted — see
      // _setAutosaveEnabled). autosavePulseVisible is recomputed by every
      // _autosaveTick, not persisted across ticks on its own.
      autosaveEnabled: false,
      // True after an autosave failure (including a 409 conflict) — ticking
      // is paused until a manual save succeeds, the conflict is resolved, or
      // the checkbox is re-toggled. See _autosaveTick/_setAutosaveEnabled.
      autosaveSuspended: !!BUILD_PARAMS, // build mode: the server writes the training until the build ends
      // Live build (BuildChat): the URL params, replaced by a Continue (new job) or restored on an ?id-only open (R10).
      buildParams: BUILD_PARAMS,
      buildResumed: false, // true = BuildChat starts docked (the editor is already revealed)
      autosavePromptDismissed: false,
      autosavePulseVisible: false,
      // Save-button status color: true = doc differs from last saved baseline
      // (yellow), false = in sync (green). Recomputed reactively in
      // componentDidUpdate against _autosaveLastSignature.
      hasUnsavedChanges: false,
      richMarksVisible: false,
      addAnimationVisible: false,
      saveAsVisible: false,
      ratioReproduceVisible: false,
      uploadTemplateVisible: false,
      addSoundVisible: false,
      markCreatorVisible: false,
      currentRichMark: null,
      carouselShow: true,
      carouselFull: false,
      rightActiveTab: "scene",
      // Which right-rail tab the author opened ON TOP of a selected element.
      // While that tab is the open one, the element's over-box pill is hidden
      // — see the body-class sync in componentDidUpdate.
      pillHiddenForTab: null,
      animPanHost: null,
      animPanActive: false,
      animPanCollapsed: false,
      serverModal: false,
      serverModalTitle: "",
      serverModalMessage: "",
      serverModalSuccess: false,
      localDraftPrompt: null,
      catalogModal: false,
      grid: false,
      pluginConfigModal: false,
      publishing: false,
      showGlobalConfig: false, // cookies.get("idealStudio_visitor"),
      // {videos, audios, scenes} opens the pre-timeline repair dialog; null keeps it closed.
      legacyTimelineRepair: null,
      globalConfigMode: "edit",
      globalConfigForced: false,
      saveAsPreparedState: null,
      saveAsTitleSuggestion: "",
      blockDrag: false,
      showFileUpload: false,
      fileUploadTab: 0,
      showExitModal: false,
      showUnsavedChangesGuard: false,
      unsavedChangesGuardSaving: false,
      unsavedChangesGuardError: null,
      // Save-before-sync prompt: null, or { saving, error } while open
      saveBeforeSync: null,
      // 409 from api/ideal-studio/training/save-state: { currentUpdatedAt, phase }
      // where phase is null | "overwriting" | "reloading". See
      // _openSaveConflict/_overwriteSaveConflict/_reloadServerCopy below.
      saveConflict: null,
      showTour: false,
      showHelpButton: false,
      showAddImageModal: false,
      showAddVideoModal: false,
      showAddSoundModal: false,
      showInfographicSceneModal: false,
      showQuestionGeneratorModal: false,
      onAddSoundModalSelected: null,
      fileModalResult: { id: undefined, value: undefined },
      initModal: cookies.get("idealStudio_visitor") === undefined,
      addSoundIndex: -1,
      timelineVisible: false,
      remotionTimelineVisible: false,
      timelineHeight: 180,
      ideaTimelineVisible: true,
      ideaTimelineHeight: TIMELINE.defaultHeight,
      knollingViewVisible: false,
      soundPlaying: false,
      openTextEditor: false,
      baseUrl: "",
      trainingId: -1,
      trainingName: "",
      informationText: "",
      aiOutput: null,
      createdWithAI: false,
      lmsContentId: null,
      createdAt: null,
      isLmsConnect: false,
      lmsLogCreatedAt: null,
      voiceProfile: null,
      lmsExporting: false,
      lmsOverwriteDialog: false,
      lmsExportResult: null,
      oneClickEditVisible: false,
      aiStudioOpen: false,
      libraryCategory: null,
      // Separate from libraryCategory so the Library tab stays untouched.
      assessmentCategory: null,
      animationResetTriggered: 0,
      fontModalVisible: false,
      fontModalFontName: "",
      fontModalFontUrl: "",
      pendingFonts: [],
      fontLinkModalVisible: false,
      pendingFontLinks: [],
      failedFontLinks: [],
      fontLinkModalLoading: false,
      fontLinkModalResult: null,
      canvasZoom: 1,
      activeAccordionKey: null,
      deleteAlsoCv: false,
      timelineMerlinBoxId: null,
      timelineMerlinImageUrl: "",
      merlinInitialFeatureId: null,
      merlinInitialSettings: null,
      // ImageAnimatorModal is fading out (show=false) and is unmounted on its
      // onExited — not torn out in one frame, which flashed the canvas.
      merlinLeaving: false,
      // Opened/closed as half of a crossfade with Görseli Düzenle: no slide.
      merlinHandoff: false,
      showThemeModal: false,
      showEditModal: false,
      selectedAtomicSubField: null,
    };
    this._setAutosaveEnabled = this._setAutosaveEnabled.bind(this);
    this._autosaveTick = this._autosaveTick.bind(this);
    this.onTextEditorToggled = this.onTextEditorToggled.bind(this);
    this.onRichMarkUpdated = this.onRichMarkUpdated.bind(this);
    this.toolbarUpdated = this.toolbarUpdated.bind(this);
    this.addAnswerToBox = this.addAnswerToBox.bind(this);
    this.removeAnswerFromBox = this.removeAnswerFromBox.bind(this);
    this.addAssessmentArea = this.addAssessmentArea.bind(this);
    this.reorderAnswersForBox = this.reorderAnswersForBox.bind(this);
    this.handleCanvasZoom = this.handleCanvasZoom.bind(this);
    this.onBoxDeleted = this.onBoxDeleted.bind(this);
    this.onSortableContainerDeleted = this.onSortableContainerDeleted.bind(this);
    this.keyListener = this.keyListener.bind(this);
    this.beforeUnloadAlert = this.beforeUnloadAlert.bind(this);
    this.duplicateNavItem = this.duplicateNavItem.bind(this);
    this.playAnimation = this.playAnimation.bind(this);
    this.pauseAnimation = this.pauseAnimation.bind(this);
    this.resetAnimation = this.resetAnimation.bind(this);
    this.currentPage = this.currentPage.bind(this);

    this.createInitModal = this.createInitModal.bind(this);
    this.showTour = this.showTour.bind(this);
    this._setAnimPanHost = this._setAnimPanHost.bind(this);
    this._onAnimPanStateChange = this._onAnimPanStateChange.bind(this);
    this._backFromPanSettings = this._backFromPanSettings.bind(this);
    this.exitListener = (ev) => {
      alert("Please press the Logout button to logout.");
    };

    // Scene narration playback: one Audio element per soundList entry so
    // overlapping sounds can play together (same behavior as the Visor).
    this.sceneAudioPool = new Map();
    // Start/seek state of each pool element (see common/audio_sync.es6).
    this.sceneAudioSync = new Map();

    this.animationScene = null;

    // Synchronous sound-playing flag — used in setCurrentTime to avoid
    // the stale-state bug where setState({ soundPlaying: false }) hasn't
    // been applied yet when setCurrentTime(0) fires during stop.
    this._soundPlaying = false;

    // Timeline preview rate (1 = real time)
    this._previewSpeed = 1;

    this.fontLoader = createFontLoader({
      getPluginToolbars: () => this.props.pluginToolbars,
      getState: () => ({
        fontLinkModalVisible: this.state.fontLinkModalVisible,
        pendingFontLinks: this.state.pendingFontLinks,
        fontModalVisible: this.state.fontModalVisible,
        fontModalFontName: this.state.fontModalFontName,
        fontModalFontUrl: this.state.fontModalFontUrl,
        pendingFonts: this.state.pendingFonts,
        failedFontLinks: this.state.failedFontLinks,
        fontLinkModalLoading: this.state.fontLinkModalLoading,
        fontLinkModalResult: this.state.fontLinkModalResult,
      }),
      setState: (patch) => this.setState(patch),
    });

    this.lmsExporter = createLmsExporter({
      getStoreState: () => this.props.store.getState(),
      setState: (patch) => this.setState(patch),
      getTrainingId: () => this.state.trainingId,
    });

    this.globalDragDrop = createGlobalDragDrop({
      onDrop: (ev) => {
        if (!(ev.target.tagName === "INPUT" && ev.target.type === "file")) {
          ev.preventDefault();
        }
        this.setState({ blockDrag: false });
      },
      onDragOver: (ev) => {
        // Bir modal (Generate Video / görsel / ses upload vb.) açıkken kendi
        // dropzone'unu yönetir — dosya sürüklemesini sol "Upload Files" paneline
        // kaçırma; aksi halde modal'ın dropzone'una bırakılamıyor.
        const overModal =
          ev.target &&
          ev.target.closest &&
          ev.target.closest(".modal, .modal-backdrop, [data-local-dropzone]");

        if (!overModal && !this.state.blockDrag) {
          this.setState({
            leftPanel: "library",
            libraryCategory: "Upload Files",
            fileModalResult: { id: undefined, value: undefined },
            aiPanel: null,
          });
        }

        ev.preventDefault();
        if (ev.target.parentNode && ev.target.parentNode.classList.contains("fileInput")) {
          ev.target.parentNode.classList.add("dragging");
        }
      },
      onDragLeave: (ev) => {
        ev.preventDefault();
        if (ev.target.parentNode && ev.target.parentNode.classList.contains("fileInput")) {
          ev.target.parentNode.classList.remove("dragging");
        }
      },
      onDragStart: () => {
        this.setState({ blockDrag: true });
      },
    });

    this.keyboardListener = createKeyboardListener({ handler: this.keyListener });

    // Back-navigation / tab-close guard — reuses the autosave feature's own
    // change-detection baseline (_autosaveLastSignature), kept up to date by
    // every successful save (manual save, ExitModal, this guard's own "Save
    // and leave", post-import, AnimatorPanel's onSaved, and the autosave
    // tick's own successful saves).
    this._unsavedChangesGuard = createUnsavedChangesGuard({
      store: this.props.store,
      getTrainingId: () => window.idealStudioTrainingId,
      getLastSavedSignature: () => this._autosaveLastSignature,
      onBlockedBack: () => {
        // No popup over a popup: ExitModal already asks the same "leave?"
        // question, so don't stack a second dialog on top of it.
        if (this.state.showExitModal) return;
        this.setState({ showUnsavedChangesGuard: true, unsavedChangesGuardError: null });
      },
    });
  }

  _setAnimPanHost(node) {
    if (node !== this.state.animPanHost) {
      this.setState({ animPanHost: node });
    }
  }

  // Child (AnimationPanel) → parent notification of pan-preset state. Guarded
  // against no-op setState — an earlier inline-ref setState loop froze the
  // tab, so every write here is compared against current state first.
  _onAnimPanStateChange(payload) {
    const next = { animPanActive: !!payload.isPan };
    if (!payload.isPan || payload.reopen) next.animPanCollapsed = false;
    const changed = Object.keys(next).some((key) => next[key] !== this.state[key]);
    if (changed) this.setState(next);
  }

  _backFromPanSettings() {
    if (!this.state.animPanCollapsed) this.setState({ animPanCollapsed: true });
  }

  // AI Wizard on an image opens "Görseli Düzenle" (AreaOpsModal) straight away —
  // there is no intermediate drawer any more. `token` grows on every open so a
  // re-open re-runs the modal's initial-feature effect.
  _openAreaOps = (boxId) => {
    const imageUrl = this.props.pluginToolbars?.[boxId]?.state?.url || "";
    this.setState((s) => ({
      rightActiveTab: null,
      areaOps: {
        boxId,
        imageUrl,
        featureId: undefined,
        token: ((s.areaOps && s.areaOps.token) || 0) + 1,
      },
    }));
  };

  // Is boxId an image box whose url is an animation (webp)? Those get the AI
  // Wizard too — as the animation popup (_openAnimationWizard).
  _isAnimatedImageBox = (boxId) => {
    const tb = this.props.pluginToolbars?.[boxId];
    const pluginId = (tb?.pluginId || "").toLowerCase();
    const isImage =
      pluginId.includes("image") || pluginId.includes("photo") || pluginId.includes("hotspot");
    return isImage && ANIMATED_IMAGE_EXT.test((tb?.state?.url || "").toLowerCase());
  };

  // Open our animation popup (ImageAnimatorModal, animate) on boxId. By default
  // on the box's own url; opts.imageUrl opens it on a still instead (the one
  // just fixed in Görseli Düzenle) so Setup → Start animates that still, with
  // opts.settings (the previous animation's prompt/provider/süre/döngü)
  // prefilled. Applying the result replaces the box's animation
  // (acceptAnimation → applyAnimationResult).
  _openAnimationWizard = (boxId, opts = {}) => {
    const tb = this.props.pluginToolbars?.[boxId];
    if (!tb) return;
    this.setState({
      rightActiveTab: null,
      timelineMerlinBoxId: boxId,
      timelineMerlinImageUrl: opts.imageUrl || tb.state?.url || "",
      merlinInitialFeatureId: "animate",
      merlinInitialSettings: opts.settings || null,
      merlinLeaving: false,
      merlinHandoff: !!opts.handoff,
    });
  };

  // Close ImageAnimatorModal with its own fade; _onMerlinExited unmounts it.
  // handoff: the other half of a crossfade (Görseli Düzenle opening over it) —
  // fade in place, no slide.
  _closeMerlin = (handoff = false) => {
    if (!this.state.timelineMerlinBoxId) return;
    this.setState({ merlinLeaving: true, merlinHandoff: handoff });
  };

  _onMerlinExited = () => {
    if (!this.state.merlinLeaving) return;
    this.setState({
      timelineMerlinBoxId: null,
      timelineMerlinImageUrl: "",
      merlinInitialFeatureId: null,
      merlinInitialSettings: null,
      merlinLeaving: false,
      merlinHandoff: false,
    });
  };

  // "Görseli Düzenle" in the animation popup: close it and open the latest still
  // in Görseli Düzenle (AreaOpsModal) — one popup at a time. returnToAnimate
  // brings the user back to the animation popup afterwards (_closeAreaOps, or
  // the Animate Image card / an animation row in its History —
  // _openWizardFromAreaOps). A box that shows an animation keeps it: the fixed
  // still is held here (holdEdit), not written onto the box. boxId comes from
  // the canvas pill's popup (EditorShortcuts, aidea:editAnimationSource); this
  // file's own popup has it in state.
  _editAnimationSource = ({ boxId: givenBoxId, sourceUrl, settings }) => {
    const boxId = givenBoxId || this.state.timelineMerlinBoxId;
    if (!boxId || !sourceUrl) return;
    const tb = this.props.pluginToolbars?.[boxId];
    const holdEdit =
      tb?.pluginId === "EnrichedPlayer" ||
      ANIMATION_URL_EXT.test((tb?.state?.url || "").toLowerCase());
    // Crossfade: Görseli Düzenle fades in on top while the animation popup
    // fades out under it (unmounted on its onExited).
    this.setState((s) => ({
      ...(s.timelineMerlinBoxId ? { merlinLeaving: true, merlinHandoff: true } : {}),
      areaOps: {
        boxId,
        imageUrl: sourceUrl,
        featureId: undefined,
        token: ((s.areaOps && s.areaOps.token) || 0) + 1,
        returnToAnimate: { sourceUrl, settings: settings || null, editedUrl: null, holdEdit },
      },
    }));
  };

  // Where the animation popup reopens after a Görseli Düzenle round trip: on the
  // fixed still when an edit landed, else on the box as it was — settings kept
  // either way.
  _animationReturnOpts = (ret) => {
    const edited = ret.editedUrl && ret.editedUrl !== ret.sourceUrl ? ret.editedUrl : null;
    return edited ? { imageUrl: edited, settings: ret.settings } : { settings: ret.settings };
  };

  // AreaOpsModal closed. Opened from the animation popup: go back to it so the
  // user isn't dropped out of the flow — unless a hand-off already opened it, or
  // the balance popup is next (no popup over it).
  _closeAreaOps = (reason) => {
    const ret = this.state.areaOps?.returnToAnimate;
    const boxId = this.state.areaOps?.boxId;
    this.setState({ areaOps: null });
    if (!ret || !boxId || (this.state.timelineMerlinBoxId && !this.state.merlinLeaving)) return;
    if (reason && reason.reason === "insufficient-balance") return;
    this._openAnimationWizard(boxId, this._animationReturnOpts(ret));
  };

  // A wizard-only card in AreaOpsModal (Metni Ayır, Aidea Akıllı Öğeler, Görseli
  // Canlandır, Benzer Oluştur): open ImageAnimatorModal on the operation. The
  // AreaOpsModal stays mounted just long enough to fade out over it, then
  // closes itself through onClose — a crossfade, not a popup over a popup. The
  // box's live url, not the one the modal opened with — an edit applied there
  // has already swapped it.
  _openWizardFromAreaOps = (featureId) => {
    const boxId = this.state.areaOps?.boxId;
    if (!boxId) return;
    // Back from a "Görseli Düzenle" round trip: animate the fixed still, with
    // the previous animation's settings.
    const ret = this.state.areaOps?.returnToAnimate;
    if (ret && featureId === "animate") {
      this._openAnimationWizard(boxId, { ...this._animationReturnOpts(ret), handoff: true });
      return;
    }
    this.setState({
      timelineMerlinBoxId: boxId,
      timelineMerlinImageUrl: this.props.pluginToolbars?.[boxId]?.state?.url || "",
      merlinInitialFeatureId: featureId,
      merlinLeaving: false,
      merlinHandoff: true,
    });
  };

  // Stop an in-flight entry/exit animation preview (started by AnimationPanel
  // applying a preset, e.g. Pan) and the pending seek that lands the playhead
  // once it finishes. Called on timeline seek/scrub and on box deselect so a
  // click elsewhere doesn't leave the preview's RAF loop fighting the new
  // playhead position.
  _cancelBoxAnimPreview() {
    const wasRunning = !!this._boxAnimPreviewCancel;
    if (this._boxAnimPreviewCancel) {
      this._boxAnimPreviewCancel();
      this._boxAnimPreviewCancel = null;
    }
    if (this._boxAnimPreviewTimeout) {
      clearTimeout(this._boxAnimPreviewTimeout);
      this._boxAnimPreviewTimeout = null;
    }
    // Interrupted mid-flight — the element is left holding whatever partial
    // transform/opacity the preview last painted. Strip it back to its base
    // state (same helper onAnimationReset uses) instead of leaving
    // it frozen there. A subsequent timeline seek (if that's what triggered
    // the cancel) re-applies the correct frame right after this runs anyway.
    if (wasRunning && this._boxAnimPreviewBoxId) {
      const el = document.getElementById(`box-${this._boxAnimPreviewBoxId}`);
      if (el) resetElementAnimationState(el);
    }
    this._boxAnimPreviewBoxId = null;
  }

  getElementHeightPercent(elementid) {
    let elementt = document.getElementById(elementid);
    let divHeight = elementt.style.height.replace("%", "");
    if (elementt.style.height === "auto") {
      let maincontentHeight = 0;
      let maincontentdiv = document.getElementById("maincontent");
      if (maincontentdiv.offsetHeight) {
        maincontentHeight = maincontentdiv.offsetHeight;
      } else if (maincontentdiv.style.pixelHeight) {
        maincontentHeight = maincontentdiv.style.pixelHeight;
      }

      if (elementt.offsetHeight) {
        divHeight = elementt.offsetHeight;
      } else if (elementt.style.pixelHeight) {
        divHeight = elementt.style.pixelHeight;
      }
      divHeight = (divHeight / maincontentHeight) * 100.0;
    }
    return divHeight;
  }

  handleCanvasZoom(direction) {
    if (direction === "reset") {
      this.setState({ canvasZoom: 1 });
      return;
    }
    if (direction !== "in" && direction !== "out") return;
    const delta = direction === "in" ? CANVAS_ZOOM_STEP : -CANVAS_ZOOM_STEP;
    this.setState((s) => ({
      canvasZoom: Math.max(CANVAS_ZOOM_MIN, Math.min(CANVAS_ZOOM_MAX, (s.canvasZoom || 1) + delta)),
    }));
  }

  // Apply an accepted animation / Video-Director render onto its source box.
  acceptAnimation(animationData) {
    const {
      dispatch,
      boxes,
      pluginToolbars,
      containedViewSelected,
      containedViews,
      navItems,
      navItemSelected,
    } = this.props;
    // Apply the edited/animated image back onto its box. Without
    // this handler the modal's accept path falls through to
    // "No handler to apply result". Prefer the boxId the modal
    // pinned on open (survives selection changes mid-job).
    const targetBoxId = animationData?.boxId || this.state.timelineMerlinBoxId;
    const url = animationData?.url;
    if (!targetBoxId || !url) return;

    // The target was deleted while the Director was open: keep the render as a new
    // video box on the current scene instead of dropping it.
    if (!boxes[targetBoxId]) {
      const cv =
        containedViewSelected &&
        containedViews[containedViewSelected] &&
        isContainedView(containedViewSelected);
      const navItem = cv ? containedViews[containedViewSelected] : navItems[navItemSelected];
      if (!navItem || !IdealStudio.Plugins.get("EnrichedPlayer")) return;
      const inASlide = isSlide(navItem.type);
      createBox(
        {
          parent: inASlide ? navItem.id : navItem.boxes && navItem.boxes[0],
          container: 0,
          name: "EnrichedPlayer",
          page: cv ? containedViewSelected : navItem.id || navItemSelected || 0,
          position: { x: 20, y: 20, type: "absolute" },
          id: ID_PREFIX_BOX + Date.now(),
          url,
          ...(animationData.videoProjectId ? { videoProjectId: animationData.videoProjectId } : {}),
        },
        "EnrichedPlayer",
        inASlide,
        (...args) => dispatch(addBoxThunk(...args)),
        boxes
      );
      window.dispatchEvent(
        new CustomEvent(LOCAL_DRAFT_NOTICE_EVENT, { detail: { kind: "targetRemoved" } })
      );
      return;
    }

    // extract-text: sonuç düz bir görsel değil — temizlenmiş arka plan
    // (url) + tespit edilen her metin için bir bölge (textBoxes).
    // Genel "url'i box'a yaz" davranışı yerine kaynağı temiz arka planla
    // değiştir VE her bölge için düzenlenebilir BasicText kutusu oluştur.
    if (animationData?.operation === "extract-text" && Array.isArray(animationData?.textBoxes)) {
      dispatch(
        applyExtractedTextLayers(
          { url, textBoxes: animationData.textBoxes },
          targetBoxId,
          navItemSelected
        )
      );
      return;
    }

    const decision = applyAnimationResult({
      boxId: targetBoxId,
      url,
      boxes,
      pluginToolbars,
      containedViewSelected,
      containedViews,
      navItems,
      navItemSelected,
      loop: animationData.loop,
      videoProjectId: animationData.videoProjectId,
    });

    if (decision.kind === "boxSwap" && IdealStudio.Plugins.get(decision.newBox.name)) {
      // decision.newBox.name is "EnrichedPlayer" for the forward
      // (image→video) swap and "HotspotImages" for the reverse
      // (video→image) swap — applyAnimationResult decides which,
      // this call site just instantiates whichever it picked.
      // Timeline satır sırası / canvas z-order'ı gerçek kaynağı
      // navItemsById[parent].boxes (veya contained view'sa
      // containedViewsById[parent].boxes) dizisi — ADD_BOX yeni
      // kutuyu her zaman dizinin SONUNA ekler, DELETE_BOX eskiyi
      // nereden olursa olsun çıkarır. Bu swap'ı yapmadan ÖNCEKİ
      // sırayı burada yakalıyoruz ki eski kutunun index'ini yeni
      // kutuya devredebilelim (aksi halde video her zaman en sona/
      // en başa zıplar).
      const srcParentIsCv = isContainedView(decision.parent);
      const parentBoxesBefore = srcParentIsCv
        ? containedViews[decision.parent]?.boxes
        : navItems[decision.parent]?.boxes;

      createBox(
        decision.newBox,
        decision.newBox.name,
        decision.inASlide,
        (...args) => dispatch(addBoxThunk(...args)),
        boxes
      );
      this.onBoxDeleted(decision.oldBoxId, decision.parent, decision.container, decision.page);
      if (Array.isArray(parentBoxesBefore)) {
        const restoredOrder = parentBoxesBefore.map((id) =>
          id === targetBoxId ? decision.newBoxId : id
        );
        dispatch(changeBoxLayer(decision.newBoxId, decision.parent, 0, "reorder", restoredOrder));
      }
      return;
    }

    this.toolbarUpdated(targetBoxId, "main", "state", "url", url);
    // Video Director render onto an already-video box: keep the project link + loop with the new url.
    if (animationData.videoProjectId) {
      this.toolbarUpdated(
        targetBoxId,
        "main",
        "state",
        "videoProjectId",
        animationData.videoProjectId
      );
      if (typeof animationData.loop === "boolean")
        this.toolbarUpdated(targetBoxId, "main", "state", "loop", animationData.loop);
    }
  }

  // opts.importFromBox: "Edit in Director" — the box's current video is imported into a new project.
  // opts.projectId: open that project from the library; Finish adds the video to the current scene.
  // opts.importUrl | opts.blank (+ imageUrl, aspect) | opts.latest: library / scene / top-bar entry points,
  // all landing on the Edit step; Finish adds the video to the current scene.
  openDirectorVideoModal(id, opts) {
    if (opts?.projectId || opts?.importUrl || opts?.blank || opts?.latest) {
      this.setState({
        showAddVideoModal: true,
        addVideoModalTitle: i18n.t("AddVideo"),
        addVideoImportUrl: opts.importUrl || null,
        addVideoPromptProfile: opts.promptProfile || null,
        addVideoProjectId: opts.projectId || null,
        addVideoDirect: opts.blank
          ? { blank: true, imageUrl: opts.imageUrl, aspect: opts.aspect }
          : opts.latest
            ? { latest: true }
            : null,
        // targetBoxId: the rendered video replaces that box (Edit as video from the animate popup).
        onAddVideoModalSelected: opts.targetBoxId
          ? (url, extra) =>
              this.acceptAnimation({
                url,
                boxId: opts.targetBoxId,
                loop: opts.loop,
                videoProjectId: extra?.videoProjectId,
              })
          : null,
      });
      return;
    }
    const dispatch = this.props.dispatch || (this.props.store && this.props.store.dispatch);
    const importUrl = opts?.importFromBox
      ? this.props.store.getState().undoGroup.present.pluginToolbarsById[id]?.state?.url
      : null;
    this.setState({
      showAddVideoModal: true,
      addVideoModalTitle: i18n.t("AddVideo"),
      addVideoImportUrl: importUrl || null,
      addVideoPromptProfile: null,
      addVideoProjectId: null,
      addVideoDirect: null,
      onAddVideoModalSelected: (url, extra) => {
        this.setState({
          fileModalResult: { id, value: url },
        });
        if (extra?.videoProjectId) {
          const { containedViewSelected, navItemSelected } = this.props;
          const targetScene =
            containedViewSelected && containedViewSelected !== 0
              ? containedViewSelected
              : navItemSelected;
          dispatch(
            updatePluginToolbar(
              id,
              "main",
              "state",
              "videoProjectId",
              extra.videoProjectId,
              [],
              targetScene
            )
          );
        }
      },
    });
  }

  getEditorCanvasProps({
    dispatch,
    boxes,
    boxSelected,
    boxLevelSelected,
    marks,
    navItems,
    navItemSelected,
    containedViews,
    containedViewSelected,
    exercises,
    viewToolbars,
    pluginToolbars,
    title,
    lastActionDispatched,
    canvasRatio,
    globalConfig,
  }) {
    const { syncByScene, grid, markCreatorVisible } = this.state;
    const animationsById = this.props.store.getState().undoGroup.present.animationsById;
    const currentAnimations = animationsById[boxSelected];

    return {
      syncingScene: !!syncByScene[navItemSelected],
      syncSceneStatus: syncByScene[navItemSelected],
      store: this.props.store,
      boxes,
      grid,
      canvasRatio,
      boxSelected,
      boxSelectedAll: this.props.boxSelectedAll,
      boxLevelSelected,
      marks,
      navItems,
      navItemSelected: navItems[navItemSelected],
      containedViews,
      containedViewSelected: containedViews[containedViewSelected] || 0,
      showCanvas: navItemSelected !== 0,
      pluginToolbars,
      viewToolbars,
      globalConfig,
      title,
      onToolbarUpdated: this.toolbarUpdated,
      onAddAnswer: this.addAnswerToBox,
      onRemoveAnswer: this.removeAnswerFromBox,
      onReorderAnswers: this.reorderAnswersForBox,
      // Inline assessment question editor (DragDrop / FillInBlank): "+ area"
      // adds a slot/blank, and FIB per-blank correct answers.
      onAddDragArea: this.addAssessmentArea,
      getFibAnswers: (rootId) => {
        const root = boxes[rootId];
        const page = root && root.parent;
        const pageEx = page != null && exercises ? exercises[page] : null;
        const entry = pageEx && pageEx.exercises ? pageEx.exercises[rootId] : null;
        return entry && Array.isArray(entry.correctAnswer) ? entry.correctAnswer : [];
      },
      onSetFibAnswer: (rootId, idx, value) => {
        const page = boxes[rootId] ? boxes[rootId].parent : navItems[navItemSelected];
        dispatch(setCorrectAnswer(rootId, value, page, false, true, idx));
      },
      onRichMarkMoved: (mark, value) => dispatch(moveRichMark(mark, value)),
      markCreatorId: markCreatorVisible,
      onBoxAdded: (ids, draggable, resizable, content, style, state, structure, initialParams) => {
        dispatch(
          addBoxThunk(ids, draggable, resizable, content, style, state, structure, initialParams)
        );
        document.body.scrollTo(0, 0);
      },
      setCorrectAnswer: (id, correctAnswer, page) => {
        dispatch(setCorrectAnswer(id, correctAnswer, page));
      },
      setCorrectAnswerForDnd: (id, correctAnswer, page, dndIndex) => {
        dispatch(setCorrectAnswer(id, correctAnswer, page, true, false, -1, dndIndex));
      },
      setCorrectAnswerForFib: (id, correctAnswer, page, fibIndex) => {
        dispatch(setCorrectAnswer(id, correctAnswer, page, false, true, fibIndex));
      },
      addMarkShortcut: (mark) => {
        const toolbar = pluginToolbars[boxSelected];
        const state = JSON.parse(JSON.stringify(toolbar.state));
        state.__marks[mark.id] = JSON.parse(JSON.stringify(mark));
        if (mark.connection.id) {
          state.__marks[mark.id].connection = mark.connection.id;
        }
        dispatch(addRichMark(boxSelected, mark, state));
      },
      deleteMarkCreator: () => this.setState({ markCreatorVisible: false }),
      exercises,
      openConfigModal: (id) => {
        this.setState({ pluginConfigModal: id });
      },
      lastActionDispatched,
      onBoxSelected: (id) => {
        if (id !== -1) this.setState({ rightActiveTab: "scene" });
        else this._cancelBoxAnimPreview();
        dispatch(selectBox(id, boxes[id]));
      },
      onBoxSelectedToggle: (id, current) => dispatch(selectBoxToggle(id, current)),
      onBoxSelectedAll: (ids) => dispatch(selectBoxAll(ids)),
      onBoxesAligned: (type) => {
        const state = this.props.store.getState().undoGroup.present;
        const ids = state.boxSelectedAll;
        if (!Array.isArray(ids) || ids.length < 2) return;
        alignBoxes(type, ids, state.boxes, state.pluginToolbarsById, dispatch);
      },
      onMultiFontScale: (delta) => {
        const state = this.props.store.getState().undoGroup.present;
        const ids = state.boxSelectedAll;
        if (!Array.isArray(ids)) return;
        ids.forEach((id) => {
          const tb = state.pluginToolbarsById[id];
          if (!tb || tb.pluginId !== "AtomicBoxPlugin") return;
          const cur = tb.state.fontScale || 1;
          const next = Math.min(Math.max(parseFloat((cur + delta).toFixed(2)), 0.4), 2.0);
          this.toolbarUpdated(id, "main", "state", "fontScale", next);
        });
      },
      onBoxLevelIncreased: () => dispatch(increaseBoxLevel()),
      onBoxMoved: (id, x, y, position, parent, container) => {
        dispatch(moveBox(id, x, y, position, parent, container));
      },
      onBoxRotate: (id, rotatedegree) => {
        dispatch(rotateBox(id, { rotation: rotatedegree }));
      },
      onBoxResized: (id, structure) => dispatch(resizeBox(id, structure)),
      onAddNewAnimation: (id, positionx, positiony, width, height, duration) =>
        dispatch(
          addAnimation(id, {
            positionx,
            positiony,
            width,
            height,
            duration: duration || this._timelineTimeSec || 1,
          })
        ),
      onTextAnimationApplied: (id, animation, duration, delay) => {
        dispatch(deleteTextAnimation(id));
        dispatch(updateBoxAnimation(id, { name: animation }, duration, delay));
      },
      onTextAnimationDeleted: (id) => {
        dispatch(deleteTextAnimation(id));
        dispatch(deleteBoxAnimation(id));
      },
      onBoxAnimationApplied: (id, animation, duration, delay) =>
        dispatch(updateBoxAnimation(id, animation, duration, delay)),
      onBoxAnimationDeleted: (id) => {
        dispatch(deleteBoxAnimation(id));
      },
      animationById: currentAnimations,
      onBoxStartAnimation: (
        id,
        firstpositionx,
        firstpositiony,
        firstwidth,
        firstheight,
        parent,
        container
      ) =>
        dispatch(
          changeStartAnimation(
            id,
            firstpositionx,
            firstpositiony,
            firstwidth,
            firstheight,
            parent,
            container
          )
        ),
      onBoxMiddleAnimation: (
        id,
        middlepositionx,
        middlepositiony,
        middlewidth,
        middleheight,
        parent,
        container
      ) =>
        dispatch(
          changeMiddleAnimation(
            id,
            middlepositionx,
            middlepositiony,
            middlewidth,
            middleheight,
            parent,
            container
          )
        ),
      onBoxEndAnimation: (
        id,
        lastpositionx,
        lastpositiony,
        lastwidth,
        lastheight,
        parent,
        container
      ) =>
        dispatch(
          changeEndAnimation(
            id,
            lastpositionx,
            lastpositiony,
            lastwidth,
            lastheight,
            parent,
            container
          )
        ),
      onSortableContainerResized: (id, parent, height) =>
        dispatch(resizeSortableContainer(id, parent, height)),
      onSortableContainerDeleted: (id, parent) => this.onSortableContainerDeleted(id, parent),
      moveRichMark: (id, value) => dispatch(moveRichMark(id, value)),
      onSortableContainerReordered: (ids, parent) =>
        dispatch(reorderSortableContainer(ids, parent)),
      onBoxDropped: (id, row, col, parent, container, oldParent, oldContainer, position, index) =>
        dispatch(
          dropBox(id, row, col, parent, container, oldParent, oldContainer, position, index)
        ),
      onBoxDeleted: this.onBoxDeleted,
      onContainedViewSelected: (id) => dispatch(selectContainedView(id)),
      onVerticallyAlignBox: (id, verticalAlign) => dispatch(verticallyAlignBox(id, verticalAlign)),
      onTextEditorToggled: this.onTextEditorToggled,
      onBoxesInsideSortableReorder: (parent, container, order) => {
        dispatch(reorderBoxes(parent, container, order));
      },
      onRichMarksModalToggled: (value, boxId = -1) => {
        this.setState({
          richMarksVisible: !this.state.richMarksVisible,
          markCursorValue: value,
        });
        if (this.state.richMarksVisible) {
          this.setState({ currentRichMark: null, value: null });
        }
        dispatch(selectBox(boxId, boxes[boxId]));
      },
      onOneClickEditModalToggled: () => {
        this.setState({
          oneClickEditVisible: !this.state.oneClickEditVisible,
        });
        if (this.state.oneClickEditVisible) {
          this.setState({ currentRichMark: null });
        }
      },
      onRichMarkEditPressed: (mark) => {
        this.setState({ currentRichMark: mark });
      },
      onAddNewAnimationModalToggled: (value, boxId = -1) => {
        this.setState({
          addAnimationVisible: !this.state.addAnimationVisible,
          markCursorValue: value,
        });
        if (this.state.addAnimationVisible) {
          this.setState({ currentRichMark: null, value: null });
        }
        dispatch(selectBox(boxId, boxes[boxId]));
      },
      onViewTitleChanged: (id, titles) => {
        dispatch(updateViewToolbar(id, titles));
      },
      onTitleChanged: (id, titleStr) => {
        dispatch(changeGlobalConfig("title", titleStr));
      },
      fileModalResult: this.state.fileModalResult,
      openFileModal: (id, accept, opts) => {
        const _st =
          this.props.store?.getState?.()?.undoGroup?.present?.pluginToolbarsById?.[id]?.state || {};
        if (opts?.importFromBox || isDirectorVideo(_st)) {
          return this.openDirectorVideoModal(id, opts);
        }
        this.setState({
          fileModalResult: { id, value: undefined, accept },
          carouselShow: true,
          carouselFull: false,
          ...resolveReplaceTarget(_st.componentType, _st.url || "", accept),
          aiPanel: null,
        });
      },
      onMarkCreatorToggled: (id) => this.setState({ markCreatorVisible: id }),
      uploadFunction: (query, keywords, callback) =>
        dispatch(uploadFunction(query, keywords, callback)),
    };
  }

  getContainedCanvasProps({
    dispatch,
    boxes,
    boxSelected,
    boxLevelSelected,
    marks,
    navItems,
    navItemSelected,
    containedViews,
    containedViewSelected,
    exercises,
    viewToolbars,
    pluginToolbars,
    title,
    lastActionDispatched,
    canvasRatio,
  }) {
    const { grid, markCreatorVisible } = this.state;
    const animationsById = this.props.store.getState().undoGroup.present.animationsById;
    const currentAnimations = animationsById[boxSelected];

    return {
      boxes,
      grid,
      boxSelected,
      canvasRatio,
      marks,
      onToolbarUpdated: this.toolbarUpdated,
      onAddAnswer: this.addAnswerToBox,
      onRemoveAnswer: this.removeAnswerFromBox,
      onReorderAnswers: this.reorderAnswersForBox,
      onAddDragArea: this.addAssessmentArea,
      getFibAnswers: (rootId) => {
        const root = boxes[rootId];
        const page = root && root.parent;
        const pageEx = page != null && exercises ? exercises[page] : null;
        const entry = pageEx && pageEx.exercises ? pageEx.exercises[rootId] : null;
        return entry && Array.isArray(entry.correctAnswer) ? entry.correctAnswer : [];
      },
      onSetFibAnswer: (rootId, idx, value) => {
        const page = boxes[rootId] ? boxes[rootId].parent : containedViews[containedViewSelected];
        dispatch(setCorrectAnswer(rootId, value, page, false, true, idx));
      },
      exercises,
      boxLevelSelected,
      navItems,
      navItemSelected: navItems[navItemSelected],
      containedViews,
      setCorrectAnswer: (id, correctAnswer, page) => {
        dispatch(setCorrectAnswer(id, correctAnswer, page));
      },
      containedViewSelected: containedViews[containedViewSelected] || 0,
      markCreatorId: markCreatorVisible,
      openConfigModal: (id) => {
        this.setState({ pluginConfigModal: id });
      },
      addMarkShortcut: (mark) => {
        const toolbar = pluginToolbars[boxSelected];
        const state = JSON.parse(JSON.stringify(toolbar.state));
        state.__marks[mark.id] = JSON.parse(JSON.stringify(mark));
        if (mark.connection.id) {
          state.__marks[mark.id].connection = mark.connection.id;
        }
        dispatch(addRichMark(boxSelected, mark, state));
      },
      onBoxAdded: (ids, draggable, resizable, content, style, state, structure, initialParams) =>
        dispatch(
          addBoxThunk(ids, draggable, resizable, content, style, state, structure, initialParams)
        ),
      deleteMarkCreator: () => this.setState({ markCreatorVisible: false }),
      title,
      onRichMarksModalToggled: (value, boxId = -1) => {
        this.setState({
          richMarksVisible: !this.state.richMarksVisible,
          markCursorValue: value,
        });
        if (this.state.richMarksVisible) {
          this.setState({ currentRichMark: null, value: null });
        }
        dispatch(selectBox(boxId, boxes[boxId]));
      },
      pluginToolbars,
      onRichMarkMoved: (mark, value) => dispatch(moveRichMark(mark, value)),
      viewToolbars,
      moveRichMark: (id, value) => dispatch(moveRichMark(id, value)),
      lastActionDispatched,
      onContainedViewSelected: (id) => dispatch(selectContainedView(id)),
      onBoxSelected: (id) => {
        if (id !== -1) this.setState({ rightActiveTab: "scene" });
        else this._cancelBoxAnimPreview();
        dispatch(selectBox(id, boxes[id]));
      },
      onBoxSelectedToggle: (id, current) => dispatch(selectBoxToggle(id, current)),
      onBoxSelectedAll: (ids) => dispatch(selectBoxAll(ids)),
      onBoxesAligned: (type) => {
        const state = this.props.store.getState().undoGroup.present;
        const ids = state.boxSelectedAll;
        if (!Array.isArray(ids) || ids.length < 2) return;
        alignBoxes(type, ids, state.boxes, state.pluginToolbarsById, dispatch);
      },
      onMultiFontScale: (delta) => {
        const state = this.props.store.getState().undoGroup.present;
        const ids = state.boxSelectedAll;
        if (!Array.isArray(ids)) return;
        ids.forEach((id) => {
          const tb = state.pluginToolbarsById[id];
          if (!tb || tb.pluginId !== "AtomicBoxPlugin") return;
          const cur = tb.state.fontScale || 1;
          const next = Math.min(Math.max(parseFloat((cur + delta).toFixed(2)), 0.4), 2.0);
          this.toolbarUpdated(id, "main", "state", "fontScale", next);
        });
      },
      onBoxLevelIncreased: () => dispatch(increaseBoxLevel()),
      onBoxMoved: (id, x, y, position, parent, container) =>
        dispatch(moveBox(id, x, y, position, parent, container)),
      onBoxRotate: (id, rotatedegree) => {
        dispatch(rotateBox(id, { rotation: rotatedegree }));
      },
      onBoxResized: (id, structure) => dispatch(resizeBox(id, structure)),
      onSortableContainerResized: (id, parent, height) =>
        dispatch(resizeSortableContainer(id, parent, height)),
      onSortableContainerDeleted: (id, parent) => {
        this.onSortableContainerDeleted(id, parent);
      },
      onSortableContainerReordered: (ids, parent) =>
        dispatch(reorderSortableContainer(ids, parent)),
      onBoxDropped: (id, row, col, parent, container, oldParent, oldContainer, position, index) =>
        dispatch(
          dropBox(id, row, col, parent, container, oldParent, oldContainer, position, index)
        ),
      onBoxDeleted: this.onBoxDeleted,
      onVerticallyAlignBox: (id, verticalAlign) => dispatch(verticallyAlignBox(id, verticalAlign)),
      onMarkCreatorToggled: (id) => this.setState({ markCreatorVisible: id }),
      onOneClickEditModalToggled: () => {
        this.setState({
          oneClickEditVisible: !this.state.oneClickEditVisible,
        });
        if (this.state.oneClickEditVisible) {
          this.setState({ currentRichMark: null });
        }
      },
      onRichMarkEditPressed: (mark) => {
        this.setState({ currentRichMark: mark });
      },
      uploadFunction: (query, keywords, callback) =>
        dispatch(uploadFunction(query, keywords, callback)),
      onTitleChanged: (id, titleStr) => {
        dispatch(changeGlobalConfig("title", titleStr));
      },
      fileModalResult: this.state.fileModalResult,
      openFileModal: (id, accept, opts) => {
        // Route to the same place the right menu's "Replace File" does: the
        // matching Components section for animation/icon/character/Youtube items,
        // otherwise the Library "My Files" tab.
        const _st =
          this.props.store?.getState?.()?.undoGroup?.present?.pluginToolbarsById?.[id]?.state || {};
        if (opts?.importFromBox || isDirectorVideo(_st)) {
          return this.openDirectorVideoModal(id, opts);
        }
        this.setState({
          fileModalResult: { id, value: undefined, accept },
          carouselShow: true,
          carouselFull: false,
          ...resolveReplaceTarget(_st.componentType, _st.url || "", accept),
          aiPanel: null,
        });
      },
      onAddImageModalToggle: (callback) => {
        this.setState({
          showAddImageModal: !this.state.showAddImageModal,
          onAddImageModalSelected: typeof callback === "function" ? callback : null,
        });
      },
      showCanvas: containedViewSelected !== 0,
      onAddNewAnimation: (id, positionx, positiony, width, height, duration) =>
        dispatch(
          addAnimation(id, {
            positionx,
            positiony,
            width,
            height,
            duration: duration || this._timelineTimeSec || 1,
          })
        ),
      onTextAnimationApplied: (id, animation, duration, delay) => {
        dispatch(deleteTextAnimation(id));
        dispatch(updateBoxAnimation(id, { name: animation }, duration, delay));
      },
      onTextAnimationDeleted: (id) => {
        dispatch(deleteTextAnimation(id));
        dispatch(deleteBoxAnimation(id));
      },
      onBoxAnimationApplied: (id, animation, duration, delay) =>
        dispatch(updateBoxAnimation(id, animation, duration, delay)),
      onBoxAnimationDeleted: (id) => {
        dispatch(deleteBoxAnimation(id));
      },
      animationById: currentAnimations,
      onBoxStartAnimation: (
        id,
        firstpositionx,
        firstpositiony,
        firstwidth,
        firstheight,
        parent,
        container
      ) =>
        dispatch(
          changeStartAnimation(
            id,
            firstpositionx,
            firstpositiony,
            firstwidth,
            firstheight,
            parent,
            container
          )
        ),
      onBoxMiddleAnimation: (
        id,
        middlepositionx,
        middlepositiony,
        middlewidth,
        middleheight,
        parent,
        container
      ) =>
        dispatch(
          changeMiddleAnimation(
            id,
            middlepositionx,
            middlepositiony,
            middlewidth,
            middleheight,
            parent,
            container
          )
        ),
      onBoxEndAnimation: (
        id,
        lastpositionx,
        lastpositiony,
        lastwidth,
        lastheight,
        parent,
        container
      ) =>
        dispatch(
          changeEndAnimation(
            id,
            lastpositionx,
            lastpositiony,
            lastwidth,
            lastheight,
            parent,
            container
          )
        ),
      onAddNewAnimationModalToggled: (value, boxId = -1) => {
        this.setState({
          addAnimationVisible: !this.state.addAnimationVisible,
          markCursorValue: value,
        });
        if (this.state.addAnimationVisible) {
          this.setState({ currentRichMark: null, value: null });
        }
        dispatch(selectBox(boxId, boxes[boxId]));
      },
    };
  }

  setAddSoundVisibleWithIndex = async (index) => {
    let targetTab = "ai";
    const currentSceneId =
      this.props.containedViewSelected && this.props.containedViewSelected !== 0
        ? this.props.containedViewSelected
        : this.props.navItemSelected;
    const currentSoundList =
      this.props.store.getState().undoGroup.present.soundList[currentSceneId] || [];
    const soundObj = currentSoundList[index];

    if (soundObj) {
      let hasText =
        soundObj.narrationText ||
        soundObj.voiceData ||
        (soundObj.metadata && (soundObj.metadata.VoiceName || soundObj.metadata.VoiceProvider));

      if (!hasText && soundObj.file) {
        if (window.audioCache) {
          const targetFileName = soundObj.file.split("/").pop().split("?")[0];
          const matchedAudio = window.audioCache.find((a) => {
            if (!a.filePath) return false;
            return a.filePath.split("/").pop().split("?")[0] === targetFileName;
          });
          if (matchedAudio && matchedAudio.narrationTextOriginal) {
            hasText = true;
          }
        }

        if (!hasText) {
          try {
            const metaUrl = withSidecarSuffix(soundObj.file, ".txt");
            const response = await fetch(metaUrl, { method: "HEAD", credentials: "include" });
            if (response.ok) {
              hasText = true;
            }
          } catch (e) {
            console.error(e);
          }
        }
      }

      if (!hasText) {
        targetTab = "library";
      }
    }

    this.setState({
      showAddSoundModal: true,
      addSoundModalTab: targetTab,
      addSoundInitialIndex: index,
      addSoundInitialText: null,
      addSoundInitialTextNavId: null,
    });
  };

  getToolbarProps({
    dispatch,
    boxes,
    boxSelected,
    containedViews,
    containedViewSelected,
    navItemSelected,
    navItems,
    globalConfig,
    ribbonHeight,
    pluginToolbars,
    viewToolbars,
    carouselShow,
    isBusy,
    marks,
    exercises,
    animationsById,
    soundList,
    uploadFunction,
    currentViewOrContained,
  }) {
    return {
      globalConfig,
      top: 60 + ribbonHeight + "px",
      pluginToolbars,
      openConfigModal: (id) => {
        this.setState({ pluginConfigModal: id });
      },
      // Assessment popover "Stil ve renkler" → reveal the selected box's style
      // accordions in the right-rail properties panel (eval plugins have no
      // getConfigTemplate, so the PluginConfigModal path is not applicable).
      onOpenSettings: () => {
        this.setState({ rightActiveTab: "properties", activeAccordionKey: null });
      },
      viewToolbars,
      box: boxes[boxSelected],
      boxSelected,
      containedViews,
      containedViewSelected,
      navItemSelected: containedViewSelected !== 0 ? containedViewSelected : navItemSelected,
      navItems: containedViewSelected !== 0 ? containedViews : navItems,
      carouselShow,
      isBusy,
      marks,
      exercises,
      boxes,
      animationsById,
      soundList,
      store: this.props.store,
      activeAccordionKey: this.state.activeAccordionKey,
      onContainedViewNameChanged: (id, titleStr) => dispatch(updateViewToolbar(id, titleStr)),
      onBackgroundChanged: (id, background) => dispatch(changeBackground(id, background)),
      onNavItemToggled: (id) => dispatch(toggleNavItem(navItemSelected)),
      onNavItemSelected: (id) => dispatch(selectNavItem(id)),
      onNavItemNameChanged: (id, titleStr) => dispatch(changeNavItemName(id, titleStr)),
      onContainedViewSelected: (id) => dispatch(selectContainedView(id)),
      onColsChanged: (id, parent, distribution, boxesAffected) =>
        dispatch(changeCols(id, parent, distribution, boxesAffected)),
      onRowsChanged: (id, parent, column, distribution, boxesAffected) =>
        dispatch(changeRows(id, parent, column, distribution, boxesAffected)),
      onBoxResized: (id, structure) => dispatch(resizeBox(id, structure)),
      onBoxMoved: (id, x, y, position, parent, container) =>
        dispatch(moveBox(id, x, y, position, parent, container)),
      onBoxRotate: (id, rotatedegree) => {
        dispatch(rotateBox(id, { rotation: rotatedegree }));
      },
      onVerticallyAlignBox: (id, verticalAlign) => dispatch(verticallyAlignBox(id, verticalAlign)),
      onTextEditorToggled: this.onTextEditorToggled,
      onSortableContainerResized: (id, parent, height) =>
        dispatch(resizeSortableContainer(id, parent, height)),
      onSortableContainerDeleted: (id, parent) => {
        this.onSortableContainerDeleted(id, parent);
      },
      onSortablePropsChanged: (id, parent, prop, value) =>
        dispatch(changeSortableProps(id, parent, prop, value)),
      onToolbarUpdated: this.toolbarUpdated,
      onScoreConfig: (id, button, value, page) => {
        dispatch(configScore(id, button, value, page));
      },
      onBoxDeleted: this.onBoxDeleted,
      onRichMarksModalToggled: () => {
        this.setState({ richMarksVisible: !this.state.richMarksVisible });
        if (this.state.richMarksVisible) {
          this.setState({ currentRichMark: null });
        }
      },
      onOneClickEditModalToggled: () => {
        this.setState({
          oneClickEditVisible: !this.state.oneClickEditVisible,
        });
        if (this.state.oneClickEditVisible) {
          this.setState({ currentRichMark: null });
        }
      },
      onRichMarkEditPressed: (mark) => {
        this.setState({ currentRichMark: mark });
      },
      onRichMarkDeleted: (id) => {
        let cvid = marks[id].connection;
        if (isContainedView(cvid)) {
          let thiscv = containedViews[cvid];
          if (Object.keys(thiscv.parent).length === 1) {
            let confirmText =
              i18n.t("messages.confirm_delete_CV_also_1") +
              viewToolbars[cvid].viewName +
              i18n.t("messages.confirm_delete_CV_also_2");
            this.setState({
              richMarkDeleteInfo: { markId: id, cvid, confirmText, mark: marks[id] },
              deleteAlsoCv: false,
            });
            return;
          }
        }
        dispatch(deleteRichMark(marks[id]));
      },
      fileModalResult: this.state.fileModalResult,
      openFileModal: (id, accept, opts) => {
        if (typeof accept === "string" && accept.includes("video")) {
          this.openDirectorVideoModal(id, opts);
          return;
        }
        const _st =
          this.props.store?.getState?.()?.undoGroup?.present?.pluginToolbarsById?.[id]?.state || {};
        this.setState({
          fileModalResult: { id, value: undefined, accept },
          carouselShow: true,
          carouselFull: false,
          ...resolveReplaceTarget(_st.componentType, _st.url || "", accept),
          aiPanel: null,
        });
      },
      onAddImageModalToggle: (callback, titleRefStr = null) => {
        this.setState({
          showAddImageModal: !this.state.showAddImageModal,
          onAddImageModalSelected: typeof callback === "function" ? callback : null,
          addImageModalTitle: titleRefStr,
        });
      },
      onAddVideoModalToggle: (callback, titleRefStr = null) => {
        this.setState({
          showAddVideoModal: !this.state.showAddVideoModal,
          onAddVideoModalSelected: typeof callback === "function" ? callback : null,
          addVideoImportUrl: null,
          addVideoDirect: null,
          addVideoModalTitle: titleRefStr,
        });
      },
      onAddSoundModalToggle: (callback, titleRefStr = null) => {
        this.setState({
          showAddSoundModal: !this.state.showAddSoundModal,
          addSoundModalTab: "ai",
          addSoundInitialIndex: "__new__",
          onAddSoundModalSelected: typeof callback === "function" ? callback : null,
        });
      },
      uploadFunction: (query, keywords, callback) =>
        dispatch(uploadFunction(query, keywords, callback)),
      updateViewToolbar: (id, toolbar) => dispatch(updateViewToolbar(id, toolbar)),
      onBoxFinalAnimation: (
        id,
        firstopacity,
        middleopacity,
        lastopacity,
        firstduration,
        middleduration,
        lastduration,
        parent,
        container
      ) =>
        dispatch(
          changeFinalAnimation(
            id,
            firstopacity,
            middleopacity,
            lastopacity,
            firstduration,
            middleduration,
            lastduration,
            parent,
            container
          )
        ),
      onBoxStartAnimation: (
        id,
        firstpositionx,
        firstpositiony,
        firstwidth,
        firstheight,
        parent,
        container
      ) =>
        dispatch(
          changeStartAnimation(
            id,
            firstpositionx,
            firstpositiony,
            firstwidth,
            firstheight,
            parent,
            container
          )
        ),
      onBoxMiddleAnimation: (
        id,
        middlepositionx,
        middlepositiony,
        middlewidth,
        middleheight,
        parent,
        container
      ) =>
        dispatch(
          changeMiddleAnimation(
            id,
            middlepositionx,
            middlepositiony,
            middlewidth,
            middleheight,
            parent,
            container
          )
        ),
      onBoxEndAnimation: (
        id,
        lastpositionx,
        lastpositiony,
        lastwidth,
        lastheight,
        parent,
        container
      ) =>
        dispatch(
          changeEndAnimation(
            id,
            lastpositionx,
            lastpositiony,
            lastwidth,
            lastheight,
            parent,
            container
          )
        ),
      onBoxAnimationPositionNumber: (id, positionNumber, parent, container) =>
        dispatch(changeAnimationPositionNumber(id, positionNumber, parent, container)),
      onBoxShowAnimation: (id, showAnimation, parent, container) =>
        dispatch(changeShowAnimation(id, showAnimation, parent, container)),
      setUploadTemplateVisible: () => this.setState({ uploadTemplateVisible: true }),
      setSoundRecorderVisible: () =>
        this.setState({
          showAddSoundModal: true,
          addSoundModalTab: "record",
        }),
      setAddSoundVisible: () => this.setState({ addSoundVisible: true }),
      pageSoundList:
        this.props.store.getState().undoGroup.present.soundList[currentViewOrContained] || [],
      deleteSound: (key) => {
        if (boxSelected != -1) {
          this.toolbarUpdated(
            boxSelected,
            "main",
            "state",
            "soundList",
            this.props.store
              .getState()
              .undoGroup.present.pluginToolbarsById[
                boxSelected
              ].state.soundList.filter((r) => this.props.store.getState().undoGroup.present.pluginToolbarsById[boxSelected].state.soundList.indexOf(r) != key)
          );
        } else {
          dispatch(deleteSound(currentViewOrContained, key));
        }
      },
      setAddSoundVisibleWithIndex: (index) => this.setAddSoundVisibleWithIndex(index),
      onServerModal: (title, message, isSuccess) =>
        this.setState({
          serverModalTitle: title,
          serverModalMessage: message,
          serverModalSuccess: isSuccess,
          serverModal: true,
        }),
    };
  }

  // Fills a missing contentLanguage from the voice profile (else the editor
  // language) without marking the training unsaved.
  seedContentLanguage = () => {
    if (!this._serverStateImported || !this._voiceProfileSettled) return;
    const { store, dispatch } = this.props;
    const present = store.getState().undoGroup.present;
    if (normalizeContentLanguage(present.globalConfig && present.globalConfig.contentLanguage)) {
      return;
    }
    const wasClean = !hasUndoSignatureChanged(
      this._autosaveLastSignature,
      getUndoSignature(store.getState().undoGroup)
    );
    const lang = getProfileContentLanguage() || getContentLanguage();
    setContentLanguage(lang);
    dispatch(changeGlobalConfig("contentLanguage", lang));
    updateDefaultTextsToContentLanguage(
      store.getState().undoGroup.present.pluginToolbarsById,
      dispatch,
      updatePluginToolbar
    );
    if (wasClean) {
      this._autosaveLastSignature = getUndoSignature(store.getState().undoGroup);
    }
  };

  render() {
    const {
      dispatch,
      boxes,
      boxSelected,
      boxSelectedAll,
      boxLevelSelected,
      navItemsIds,
      navItems,
      navItemSelected,
      containedViews,
      containedViewSelected,
      filesUploaded,
      indexSelected,
      exercises,
      undoDisabled,
      redoDisabled,
      displayMode,
      isBusy,
      pluginToolbars,
      viewToolbars,
      marks,
      lastActionDispatched,
      globalConfig,
      uploadedTemplates,
      animationsById,
      soundList,
    } = this.props;
    // Read by quiz plugins through contentT().
    setContentLanguage(globalConfig && globalConfig.contentLanguage);
    // Ask-on-load autosave prompt: only where a save is actually meaningful
    // (real training id, not the in-editor Preview overlay) and only once
    // per session (never re-asks after the user answers).
    // Held while a Live Motion Build runs (it would cover the chat rail);
    // _onBuildFinished re-renders, so it shows afterwards if still due.
    const autosavePromptVisible =
      !this.state.autosavePromptDismissed &&
      !this.state.visorVisible &&
      !isBuildLocked() &&
      window.idealStudioTrainingId != null &&
      window.idealStudioTrainingId !== "";
    let ribbonHeight = this.state.hideTab === "hide" ? 0 : 50;
    const isScenesPanel = this.state.leftPanel === "layers";
    const _narrowRail =
      this.state.leftPanel === "elementsLibrary" || this.state.leftPanel === "library";
    const leftPanelExpandedWidth = isScenesPanel
      ? LEFT_PANEL_WIDTH.scenes
      : _narrowRail
        ? LEFT_PANEL_WIDTH.narrowRail
        : LEFT_PANEL_WIDTH.default;
    // An InteractivePlugin box being selected dims the left rails and keeps
    // their overlay closed, so it must not reserve the overlay's width either.
    const _interactiveBoxSelected =
      !!boxSelected &&
      !!pluginToolbars &&
      !!pluginToolbars[boxSelected] &&
      pluginToolbars[boxSelected].pluginId === "InteractivePlugin";
    const overlayOpen =
      !_interactiveBoxSelected &&
      ((this.state.leftPanel === "library" && this.state.libraryCategory) ||
        this.state.leftPanel === "audio" ||
        (this.state.leftPanel === "elementsLibrary" && this.state.assessmentCategory));
    // Shift the scene right so the overlay sits beside the canvas, not over it.
    const canvasSceneLeft = this.state.carouselShow
      ? leftPanelExpandedWidth + (overlayOpen ? LEFT_PANEL_OVERLAY_WIDTH : 0)
      : 0;
    let title = globalConfig.title || "---";
    let status = this.props.status;
    let everPublished = this.props.everPublished;
    let canvasRatio = globalConfig.canvasRatio;
    const timelineEnabled = globalConfig.enableTimeline !== false;
    const ideaTimelineVisible = timelineEnabled && this.state.ideaTimelineVisible;
    // Vertical space the timeline dock takes at the bottom of #mainRow.
    // #canvasArea reserves exactly this, so anything that wants to sit "in the
    // middle of the canvas" has to subtract it — centring on the row itself
    // lands on top of the timeline as soon as it is open.
    const timelineDockHeight = ideaTimelineVisible
      ? this.state.ideaTimelineHeight
      : timelineEnabled
        ? TIMELINE.collapsedHeight
        : CANVAS_AREA_BOTTOM_PADDING;
    // Centre of the canvas area, floored so a timeline dragged taller than the
    // row itself can never push the tab off the top edge (half the tab is 32px).
    const canvasCenterTop = `max(48px, calc(50% - ${timelineDockHeight / 2}px))`;
    let disabled =
      (navItemSelected === 0 && containedViewSelected === 0) ||
      (!IdealStudio.Config.sections_have_content && navItemSelected && isSection(navItemSelected));

    // Resim vb. materyallerin yüklenmesini sağlayan ve silen fonksiyonlar
    let uploadFunction =
      process.env.NODE_ENV === "production" && process.env.DOC !== "doc"
        ? uploadVishResourceAsync
        : uploadVishResourceAsync;
    let deleteFunction =
      process.env.NODE_ENV === "production" && process.env.DOC !== "doc"
        ? deleteRemoteFileVishAsync
        : deleteRemoteFileVishAsync;

    // İnfografik "Sesten Görsel" (generate-images) sonucunu MEVCUT sahneye ekler.
    // İki giriş noktası ortak kullanır: (1) modal "Onayla"
    // (onImagesFromSoundGenerated) ve (2) job widget "Onayla"
    // (JobWidgetHost onInfographicApprove). Yeni sahne oluşturma "Sahne Üret"
    // tab'ının ayrı API'siyle (onInfographicSceneGenerated) yapılır.
    // opts.targetNavId: widget'tan gelen job'ın sahnesi; yoksa seçili sahne.
    const applyInfographicImagesResult = (sceneData, opts = {}) => {
      if (!sceneData?.boxesById) return;
      const { boxesById: sceneBoxes, pluginToolbarsById: sceneToolbars } = sceneData;
      const targetNavId =
        (opts.targetNavId && navItems[opts.targetNavId] ? opts.targetNavId : null) ||
        navItemSelected;

      Object.entries(sceneBoxes || {}).forEach(([boxId, box]) => {
        const toolbar = sceneToolbars?.[boxId];
        if (!toolbar?.pluginId) return;
        const rawPos = box.position || {};
        const posX = rawPos.x !== undefined && rawPos.x !== null ? rawPos.x : 0;
        const posY = rawPos.y !== undefined && rawPos.y !== null ? rawPos.y : 0;
        dispatch(
          addBox(
            { id: boxId, parent: targetNavId, container: 0 },
            box.draggable !== false,
            true,
            "",
            {
              ...derivePluginBoxStyle(toolbar.pluginId, toolbar.state),
              ...(box.style || {}),
            },
            toolbar.state || {},
            toolbar.structure,
            {
              name: toolbar.pluginId,
              position: {
                x: posX === 0 ? "0%" : posX,
                y: posY === 0 ? "0%" : posY,
                type: rawPos.type || "absolute",
              },
              width: toolbar.structure?.width ?? box.width ?? 100,
              height: toolbar.structure?.height ?? box.height ?? 100,
              widthUnit: toolbar.structure?.widthUnit ?? "%",
              heightUnit: toolbar.structure?.heightUnit ?? "%",
              url: toolbar.state?.url || "",
            }
          )
        );
        if (box.timeline) dispatch(updateBoxTimeline(boxId, box.timeline));
        if (box.boxAnimation)
          dispatch(
            updateBoxAnimation(
              boxId,
              box.boxAnimation.animation,
              box.boxAnimation.duration,
              box.boxAnimation.delay ?? 0
            )
          );
        if (box.boxExitAnimation)
          dispatch(
            updateBoxExitAnimation(
              boxId,
              box.boxExitAnimation.animation,
              box.boxExitAnimation.duration
            )
          );
      });
    };

    // İnfografik "Sahne Üret" (generate) sonucunu YENİ sahne (n+1) olarak ekler.
    // İki giriş noktası ortak: (1) modal "Onayla" (onSceneGenerated) ve (2) job
    // widget "Onayla" (onInfographicSceneApprove). opts.targetNavId: widget'tan
    // gelen job'ın sahnesi (yeni sahne bunun ARDINA eklenir); yoksa seçili sahne.
    const applyInfographicSceneResult = (sceneData, opts = {}) => {
      const {
        navItem,
        boxesById: sceneBoxes,
        pluginToolbarsById: sceneToolbars,
        soundList: sceneSounds,
      } = sceneData || {};
      if (!navItem?.id) return;
      const afterNavId =
        (opts.targetNavId && navItems[opts.targetNavId] ? opts.targetNavId : null) ||
        navItemSelected;
      const parentId = navItems[afterNavId]?.parent;
      if (parentId === undefined || parentId === null) return;

      const inASlide = (navItem.type || "slide") === "slide";
      const insertPosition = navItemsIds.indexOf(afterNavId) + 1;

      dispatch(
        addNavItem(
          navItem.id,
          navItem.name || i18n.t("InfographicScene") || "İnfografik Sahne",
          parentId,
          navItem.type || "slide",
          insertPosition,
          navItem.background,
          navItem.customSize,
          true,
          true,
          navItem.sortable_id,
          afterNavId
        )
      );

      Object.entries(sceneBoxes || {}).forEach(([boxId, box]) => {
        const toolbar = sceneToolbars?.[boxId];
        if (!toolbar?.pluginId) return;
        const rawPos = box.position || {};
        const posX = rawPos.x !== undefined && rawPos.x !== null ? rawPos.x : 0;
        const posY = rawPos.y !== undefined && rawPos.y !== null ? rawPos.y : 0;
        dispatch(
          addBox(
            { id: boxId, parent: navItem.id, container: 0 },
            box.draggable !== false,
            inASlide,
            "",
            {
              ...derivePluginBoxStyle(toolbar.pluginId, toolbar.state),
              ...(box.style || {}),
            },
            toolbar.state || {},
            toolbar.structure,
            {
              name: toolbar.pluginId,
              position: {
                x: posX === 0 ? "0%" : posX,
                y: posY === 0 ? "0%" : posY,
                type: rawPos.type || "absolute",
              },
              width: toolbar.structure?.width ?? box.width ?? 100,
              height: toolbar.structure?.height ?? box.height ?? 100,
              widthUnit: toolbar.structure?.widthUnit ?? "%",
              heightUnit: toolbar.structure?.heightUnit ?? "%",
              url: toolbar.state?.url || "",
            }
          )
        );
        if (box.timeline) dispatch(updateBoxTimeline(boxId, box.timeline));
        if (box.boxAnimation)
          dispatch(
            updateBoxAnimation(
              boxId,
              box.boxAnimation.animation,
              box.boxAnimation.duration,
              box.boxAnimation.delay ?? 0
            )
          );
        if (box.boxExitAnimation)
          dispatch(
            updateBoxExitAnimation(
              boxId,
              box.boxExitAnimation.animation,
              box.boxExitAnimation.duration
            )
          );
      });

      dispatch(selectNavItem(navItem.id));

      const sounds = sceneSounds?.[navItem.id];
      if (Array.isArray(sounds)) {
        sounds.forEach((sound) => dispatch(addSound(navItem.id, sound)));
      }
    };

    // Gözüken sahnenin yada işaret-tıklama içeriğini döndürür.
    let currentViewOrContained =
      containedViewSelected != 0 ? containedViewSelected : navItemSelected;

    return (
      <DndProvider backend={HTML5Backend}>
        <Container
          id="app"
          fluid
          style={{
            height: "100%",
            overflow: "hidden",
            position: "relative",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Row className="navBar" style={{ flex: "0 0 auto" }}>
            {this.state.showTour ? (
              <IdealStudioTour
                toggleTour={(showTour) => {
                  this.setState({ showTour });
                }}
                showTour={this.state.showTour}
              />
            ) : null}

            {/* {this.createInitModal()} */}
            {this.state.richMarkDeleteInfo && (
              <Alert
                className="pageModal"
                show
                hasHeader
                title={
                  <span>
                    <i style={{ fontSize: "14px", marginRight: "5px" }} className="material-icons">
                      delete
                    </i>
                    {i18n.t("messages.confirm_delete_cv")}
                  </span>
                }
                cancelButton
                acceptButtonText={i18n.t("messages.OK")}
                cancelButtonText={i18n.t("messages.Cancel")}
                onClose={(accepted) => {
                  const info = this.state.richMarkDeleteInfo;
                  if (accepted && info) {
                    const deleteAlso = this.state.deleteAlsoCv || false;
                    if (deleteAlso) {
                      let boxesRemoving = [];
                      (containedViews[info.cvid]?.boxes || []).forEach((boxId) => {
                        boxesRemoving.push(boxId);
                        boxesRemoving = boxesRemoving.concat(
                          getDescendantBoxes(boxes[boxId], boxes)
                        );
                      });
                      dispatch(
                        deleteContainedView(
                          [info.cvid],
                          boxesRemoving,
                          containedViews[info.cvid]?.parent
                        )
                      );
                    }
                    dispatch(deleteRichMark(info.mark));
                  }
                  this.setState({ richMarkDeleteInfo: null, deleteAlsoCv: false });
                }}
              >
                <span>{this.state.richMarkDeleteInfo?.confirmText}</span>
                <br />
                <ToggleSwitch
                  id="deleteAlsoCv"
                  style={{ margin: "10px" }}
                  checked={this.state.deleteAlsoCv || false}
                  onChange={() => this.setState({ deleteAlsoCv: !this.state.deleteAlsoCv })}
                />
                {i18n.t("messages.confirm_delete_cv_as_well")}
              </Alert>
            )}
            {renderMandatoryPopup(globalConfig)}
            <EditorNavBar
              hideTab={this.state.hideTab}
              boxes={boxes}
              activeLeftPanel={this.state.leftPanel}
              isBusy={isBusy}
              autosaveEnabled={this.state.autosaveEnabled}
              autosavePulseVisible={this.state.autosavePulseVisible}
              hasUnsavedChanges={this.state.hasUnsavedChanges}
              autosavePromptVisible={autosavePromptVisible}
              onAutosaveChange={this._setAutosaveEnabled}
              onBoxSelected={(id) => dispatch(selectBox(id, boxes[id]))}
              showGlobalConfig={this.state.showGlobalConfig}
              globalConfigMode={this.state.globalConfigMode || "edit"}
              globalConfigForced={this.state.globalConfigForced || false}
              batchUpdateMandatoryDefaults={(mandatory) => {
                const { scene, question } = sceneMandatoryPayloads(mandatory);
                const present = this.props.store.getState().undoGroup.present;
                this.props.dispatch(
                  batchUpdateMandatoryDefaults(scene, {
                    mandatory: question,
                    sceneIds: questionSceneIds(present),
                  })
                );
              }}
              batchUpdateSceneDuration={(duration) =>
                this.props.dispatch(batchUpdateSceneDuration(duration))
              }
              batchSetSceneFont={(fontFamily) => this.props.dispatch(batchSetSceneFont(fontFamily))}
              onCreateNewTraining={(mergedGlobalConfig) => {
                const emptyPresent = createEmptyTrainingState(mergedGlobalConfig);
                const wrappedState = {
                  undoGroup: { present: emptyPresent },
                  filesUploaded: emptyPresent.filesUploaded || {},
                  status: emptyPresent.status || "draft",
                  everPublished: emptyPresent.everPublished || false,
                };
                _saveAs(
                  mergedGlobalConfig.title || "Untitled",
                  mergedGlobalConfig.description || "",
                  wrappedState
                );
                this.setState({
                  showGlobalConfig: false,
                  globalConfigMode: "edit",
                  globalConfigForced: false,
                });
              }}
              onRequestSaveAs={({
                mergedGlobalConfig,
                oldRatio,
                newRatio,
                applyMandatoryToAll,
                applyDurationToAll,
                applyFontToAll,
              }) => {
                const storeState = this.props.store.getState();
                const present = storeState.undoGroup.present;
                let nextPresent = migrateBoxesForRatio(present, oldRatio, newRatio);
                nextPresent = { ...nextPresent, globalConfig: mergedGlobalConfig };
                if (applyMandatoryToAll) {
                  nextPresent = applyMandatoryToAllScenes(
                    nextPresent,
                    mergedGlobalConfig.defaultSceneMandatory
                  );
                }
                if (applyDurationToAll) {
                  nextPresent = applyDurationToAllScenes(
                    nextPresent,
                    mergedGlobalConfig.defaultSceneDuration
                  );
                }
                if (applyFontToAll) {
                  nextPresent = {
                    ...nextPresent,
                    pluginToolbarsById: applyCourseFontToToolbars(
                      nextPresent.pluginToolbarsById,
                      applyFontToAll
                    ),
                  };
                }
                const preparedWrapped = {
                  undoGroup: { present: nextPresent },
                  filesUploaded: storeState.filesUploaded,
                  status: storeState.status,
                  everPublished: storeState.everPublished,
                };
                this.setState({
                  saveAsVisible: true,
                  saveAsPreparedState: preparedWrapped,
                  saveAsTitleSuggestion:
                    `${mergedGlobalConfig.title || ""} (${mergedGlobalConfig.ratio || ""})`.trim(),
                });
              }}
              toggleGlobalConfig={() => {
                this.setState({
                  showGlobalConfig: !this.state.showGlobalConfig,
                  globalConfigForced: false,
                  globalConfigMode: "edit",
                });
              }}
              openNewTraining={() => {
                this.setState({
                  showGlobalConfig: true,
                  globalConfigMode: "newTraining",
                  globalConfigForced: false,
                });
              }}
              onBoxAdded={this.handleBoxAdded}
              globalConfig={{ ...globalConfig, status, everPublished }}
              changeGlobalConfig={(prop, value) => {
                dispatch(changeGlobalConfig(prop, value));
              }}
              onIndexSelected={(id) => dispatch(selectIndex(id))}
              onNavItemSelected={(id) => dispatch(selectNavItem(id))}
              onNavItemAdded={(
                id,
                name,
                parent,
                type,
                position,
                background,
                customSize,
                hideTitles,
                hasContent,
                sortable_id
              ) => {
                if (isBuildLocked()) return; // Live Motion Build: no structural edits
                // Guard: when the user asks for a new blank slide and an empty
                // one already exists in the training, just focus the existing
                // empty slide instead of stacking duplicates. Triggered for
                // type === "slide" only — sections, documents and template
                // imports always get a fresh nav item.
                if (type === "slide") {
                  const existingEmpty = this.findExistingEmptySlide();
                  if (existingEmpty) {
                    dispatch(selectIndex(existingEmpty));
                    dispatch(selectNavItem(existingEmpty));
                    return;
                  }
                }
                dispatch(
                  addNavItem(
                    id,
                    name,
                    parent,
                    type,
                    position,
                    background,
                    customSize,
                    hideTitles,
                    type !== "section" ||
                      (type === "section" && IdealStudio.Config.sections_have_content),
                    sortable_id
                  )
                );
              }}
              onNavItemsAdded={(navs, parent) =>
                !isBuildLocked() && dispatch(addNavItems(navs, parent))
              }
              onToolbarUpdated={this.onToolbarUpdated}
              onConfigScore={(id, button, value, page) =>
                dispatch(configScore(id, button, value, page))
              }
              exercises={exercises}
              pluginToolbars={pluginToolbars}
              onTitleChanged={(id, titleStr) => {
                dispatch(changeGlobalConfig("title", titleStr));
              }}
              undoDisabled={undoDisabled}
              redoDisabled={redoDisabled}
              navItemsIds={navItemsIds}
              navItems={navItems}
              containedViews={containedViews}
              containedViewSelected={containedViewSelected}
              navItemSelected={navItemSelected}
              boxSelected={boxSelected}
              undo={() => {
                dispatch(ActionCreators.undo());
              }}
              redo={() => {
                dispatch(ActionCreators.redo());
              }}
              visor={() => {
                this.remotionTimelineRef.current?.handleStop();
                this.setState({ visorVisible: true });
              }}
              publishing={() => this.setState({ publishing: true })}
              openExitModal={() => {
                this.setState({ showExitModal: true });
              }}
              openTour={() => {
                this.setState({ showHelpButton: true });
              }}
              onAIStudioToggle={() => {
                this.setState({ aiStudioOpen: !this.state.aiStudioOpen });
              }}
              showAddImageModal={this.state.showAddImageModal}
              onAddImageModalToggle={(callback) => {
                this.setState({
                  showAddImageModal: !this.state.showAddImageModal,
                  onAddImageModalSelected: typeof callback === "function" ? callback : null,
                  addImageModalTitle: null,
                });
              }}
              showAddVideoModal={this.state.showAddVideoModal}
              onAddVideoModalToggle={(callback, titleStr = null) => {
                this.setState({
                  showAddVideoModal: !this.state.showAddVideoModal,
                  onAddVideoModalSelected: typeof callback === "function" ? callback : null,
                  addVideoImportUrl: null,
                  addVideoDirect: null,
                  addVideoModalTitle: titleStr,
                });
              }}
              showAddSoundModal={this.state.addSoundVisible}
              onAddSoundModalToggle={() => {
                this.setState({ addSoundVisible: !this.state.addSoundVisible });
              }}
              showAddSoundModalNew={this.state.showAddSoundModal}
              onAddSoundModalNewToggle={() => {
                this.setState({
                  showAddSoundModal: !this.state.showAddSoundModal,
                  addSoundModalTab: "ai",
                });
              }}
              onAddAvatarModalToggle={() => {
                this.setState({
                  showAddSoundModal: !this.state.showAddSoundModal,
                  addSoundModalTab: "avatar",
                });
              }}
              showInfographicSceneModal={this.state.showInfographicSceneModal}
              onInfographicSceneModalToggle={() => {
                this.setState({
                  showInfographicSceneModal: !this.state.showInfographicSceneModal,
                });
              }}
              showQuestionGeneratorModal={this.state.showQuestionGeneratorModal}
              onQuestionGeneratorModalToggle={() => {
                this.setState({
                  showQuestionGeneratorModal: !this.state.showQuestionGeneratorModal,
                });
              }}
              onLeftPanelChange={(panelKey) => {
                this.setState({
                  leftPanel: panelKey,
                  carouselShow: true,
                  carouselFull: false,
                  aiPanel: null,
                  libraryCategory: panelKey === "library" ? null : this.state.libraryCategory,
                  assessmentCategory:
                    panelKey === "elementsLibrary" ? null : this.state.assessmentCategory,
                  pluginTab: "",
                });
              }}
              uploadFunction={(query, keywords, callback) =>
                dispatch(uploadFunction(query, keywords, callback))
              }
              export={(format, callback, options = false, urlVersion) => {
                if (format === "PDF") {
                  printToPDF(this.props.store.getState().undoGroup.present, callback, options);
                } else if (format === "edi") {
                  IdealStudio.Visor.exportsEDI(
                    {
                      ...this.props.store.getState().undoGroup.present,
                      filesUploaded: this.props.store.getState().filesUploaded,
                    },
                    callback
                  );
                } else if (format === "URL") {
                  (async () => {
                    try {
                      const storeState = this.props.store.getState();
                      const present = storeState.undoGroup.present;
                      const filesUploaded = storeState.filesUploaded;
                      const subtitleBundle = await this._loadSubtitleBundleForScormExport();

                      IdealStudio.Visor.exportsURL(
                        {
                          ...present,
                          filesUploaded: filesUploaded,
                          subtitleBundle: subtitleBundle || null,
                        },
                        (url) => {
                          url = url.replace("mw.aideapro.ai", "link.aideapro.ai");
                          this.setState({
                            serverModalTitle: "Link (URL) Oluşturuldu",
                            serverModalMessage:
                              "<div style='display: flex; align-items: center; gap: 10px; flex: 1; padding: 20px;justify-content: center;'>" +
                              "<a style='font-size:1.4em; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; min-width: 0; max-width: 400px;' href='" +
                              url +
                              "' target='_blank' title='" +
                              url +
                              "'>" +
                              url +
                              "</a>" +
                              "<i style='cursor:pointer; cursor:hand; font-size:1.4em; flex-shrink: 0;' onclick='navigator.clipboard.writeText(\"" +
                              url +
                              '"); document.getElementById("p-publish-url-copied-text").style.display="block"\' class=\'material-icons\'>content_copy</i>' +
                              "</div>" +
                              "<p id='p-publish-url-copied-text' style='display:none;'>" +
                              i18n.t("messages.Copied") +
                              "</p>",

                            serverModalSuccess: true,
                            serverModal: true,
                          });
                          callback();
                        },
                        options,
                        this.state.trainingId,
                        urlVersion
                      );
                    } catch (err) {
                      callback(err && err.message ? err.message : err);
                    }
                  })();
                } else {
                  (async () => {
                    try {
                      const storeState = this.props.store.getState();
                      const present = storeState.undoGroup.present;
                      const filesUploaded = storeState.filesUploaded;
                      const subtitleBundle = await this._loadSubtitleBundleForScormExport();

                      IdealStudio.Visor.exportsHTML(
                        {
                          ...present,
                          filesUploaded: filesUploaded,
                          subtitleBundle: subtitleBundle || null,
                        },
                        callback,
                        options
                      );
                    } catch (err) {
                      callback(err && err.message ? err.message : err);
                    }
                  })();
                }
              }}
              isLmsConnect={this.state.isLmsConnect}
              lmsExporting={this.state.lmsExporting}
              exportToLMS={() => {
                if (this.state.lmsLogCreatedAt) {
                  this.setState({ lmsOverwriteDialog: true });
                  return;
                }
                this._doLmsExport(false);
              }}
              baseUrl={this.state.baseUrl}
              getExportScenes={() => sceneChoices(this.props.store.getState().undoGroup.present)}
              scorm={(
                is2004,
                callback,
                selfContained = false,
                perScene = false,
                onProgress,
                sceneId
              ) => {
                (async () => {
                  try {
                    const storeState = this.props.store.getState();
                    const present = storeState.undoGroup.present;
                    const filesUploaded = storeState.filesUploaded;
                    const status = storeState.status;

                    const subtitleBundle = await this._loadSubtitleBundleForScormExport();

                    const scormState = {
                      ...present,
                      filesUploaded: filesUploaded,
                      status: status,
                      subtitleBundle: subtitleBundle || null,
                    };
                    if (perScene) {
                      IdealStudio.Visor.exportScenesScorm(
                        scormState,
                        selfContained,
                        onProgress,
                        callback,
                        sceneId
                      );
                      return;
                    }
                    IdealStudio.Visor.exportScorm(scormState, is2004, callback, selfContained);
                  } catch (err) {
                    callback(err && err.message ? err.message : err);
                  }
                })();
              }}
              exportClm={(zipName, callback) => {
                const storeState = this.props.store.getState();
                exportClmZip(
                  { ...storeState.undoGroup.present, filesUploaded: storeState.filesUploaded },
                  zipName,
                  callback
                );
              }}
              validateClm={() => validateClmState(this.props.store.getState().undoGroup.present)}
              save={() => {
                ideaEnvSaveState(
                  { ...this.props.store.getState() },
                  false,
                  () => {
                    // Also the unsaved-changes guard's baseline — a manual
                    // save leaves nothing pending for beforeunload/back-nav
                    // to warn about.
                    this._autosaveLastSignature = getUndoSignature(
                      this.props.store.getState().undoGroup
                    );
                    this.setState({
                      // Clear the pulse immediately rather than waiting for
                      // the next tick to notice the save. A manual save
                      // succeeding also clears an autosave failure
                      // suspension without requiring the user to re-toggle
                      // the checkbox.
                      autosavePulseVisible: false,
                      autosaveSuspended: isBuildLocked(),
                      serverModalTitle: i18n.t("messages.Success"),
                      serverModalMessage: i18n.t("messages.SuccessMessage"),
                      serverModalSuccess: true,
                      serverModal: true,
                    });
                  },
                  (err) => {
                    if (err && err.isSaveConflict) {
                      this._openSaveConflict(err.currentUpdatedAt);
                    }
                  }
                );
              }}
              saveAs={() => {
                this.setState({ saveAsVisible: !this.state.saveAsVisible });
              }}
              openRatioReproduce={() => {
                this.setState({ ratioReproduceVisible: true });
              }}
              category={this.state.pluginTab}
              opens={() => {
                /* dispatch(importStateAsync()); */
              }}
              serverModalOpen={() => {
                this.setState({ serverModal: true });
              }}
              toggleFileUpload={(id, accept) => {
                this.setState({
                  fileModalResult: { id, value: undefined, accept },
                  leftPanel: "library",
                  libraryCategory: "My Files",
                  aiPanel: null,
                });
              }}
              onExternalCatalogToggled={() => this.setState({ catalogModal: true })}
              setcat={(category) => {
                this.setState({ pluginTab: category, hideTab: "show" });
              }}
              onSelectTopLayer={() => {
                dispatch(selectBox(-1, null));
                this.setState({ rightActiveTab: "properties", activeAccordionKey: null }, () => {
                  setTimeout(() => {
                    this.setState({ activeAccordionKey: "__sound_3" });
                  }, 0);
                });

                const state = this.props.store.getState();
                const soundList = state?.undoGroup?.present?.soundList || {};
                const narrations = soundList[navItemSelected] || [];

                if (Array.isArray(narrations) && narrations.length > 0) {
                  const firstNarration = narrations[0];
                  setTimeout(() => {
                    this.setState({
                      addSoundVisible: true,
                      addSoundIndex: 0,
                      addSoundValues: firstNarration,
                    });
                  }, 500);
                }
              }}
            />
            {IdealStudio.Config.autosave_time > 1000 && (
              <AutoSave
                save={() => {
                  dispatch(
                    exportStateAsync(
                      { ...this.props.store.getState() },
                      null,
                      null,
                      this.state.trainingId || window.idealStudioTrainingId,
                      window.tenantId
                    )
                  );
                }}
                isBusy={isBusy}
                lastAction={lastActionDispatched}
                visorVisible={this.state.visorVisible}
              />
            )}
          </Row>
          {/* flex:1 so the workspace takes whatever the navbar leaves */}
          <div
            id="mainRow"
            style={{
              display: "flex",
              flex: "1 1 0",
              minHeight: 0,
              overflow: "hidden",
              background: "rgb(215, 216, 218)",
              margin: "0 -15px",
              position: "relative",
            }}
          >
            {!this.state.carouselShow && (
              <LeftPanelTab
                open={false}
                onToggle={() => this.setState({ carouselShow: true })}
                style={{ left: 0, top: canvasCenterTop, transform: "translateY(-50%)" }}
              />
            )}
            {/* Animated wrapper — slides in/out as one unit with the close tab */}
            <div
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                height: "100%",
                zIndex: 100,
                transform: this.state.carouselShow
                  ? "translateX(0)"
                  : `translateX(-${leftPanelExpandedWidth}px)`,
                transition: "transform 0.25s ease",
                pointerEvents: this.state.carouselShow ? "auto" : "none",
              }}
            >
              {/* Close tab — sticks out on the right edge at mid-height */}
              {this.state.carouselShow && (
                <LeftPanelTab
                  open
                  onToggle={() => this.setState({ carouselFull: false, carouselShow: false })}
                  style={{ right: -25, top: canvasCenterTop, transform: "translateY(-50%)" }}
                />
              )}
              <div
                id="leftPanelContainer"
                style={{
                  width: `${leftPanelExpandedWidth}px`,
                  height: "100%",
                  overflow: "hidden",
                  boxShadow: "2px 0 8px rgba(0,0,0,0.12)",
                }}
              >
                <LeftPanel
                  activeLeftPanel={this.state.leftPanel}
                  hideTab={this.state.hideTab}
                  category={this.state.pluginTab}
                  aiPanel={this.state.aiPanel}
                  libraryCategory={this.state.libraryCategory}
                  filesUploaded={filesUploaded}
                  pluginToolbars={pluginToolbars}
                  boxSelected={boxSelected}
                  fileModalResult={this.state.fileModalResult}
                  setcat={(category) => {
                    this.setState({ pluginTab: category, hideTab: "show" });
                  }}
                  toggleFileUpload={(id, accept) => {
                    this.setState({
                      fileModalResult: { id, value: undefined, accept },
                      libraryCategory: "My Files",
                      aiPanel: null,
                    });
                  }}
                  boxes={boxes}
                  exercises={exercises}
                  globalConfig={globalConfig}
                  onTitleChanged={(id, titleStr) => {
                    dispatch(changeGlobalConfig(id, titleStr));
                  }}
                  title={title}
                  containedViews={containedViews}
                  containedViewSelected={containedViewSelected}
                  indexSelected={indexSelected}
                  navItemsIds={navItemsIds}
                  navItems={navItems}
                  navItemSelected={navItemSelected}
                  displayMode={displayMode}
                  viewToolbars={viewToolbars}
                  baseUrl={this.state.baseUrl}
                  trainingId={this.state.trainingId}
                  uploadFunction={(query, keywords, callback, percentageCallback) =>
                    dispatch(uploadFunction(query, keywords, callback, percentageCallback))
                  }
                  onNavItemsAdded={(navs, parent) =>
                    !isBuildLocked() && dispatch(addNavItems(navs, parent))
                  }
                  onAddBox={(...args) => dispatch(addBoxThunk(...args))}
                  onNarrationSelect={(narration) => {
                    if (!narration) {
                      return;
                    }

                    const targetNavId = narration.navId || navItemSelected;

                    if (targetNavId && targetNavId !== navItemSelected) {
                      dispatch(selectNavItem(targetNavId));
                    }

                    this.setState({
                      showAddSoundModal: true,
                      addSoundModalTab: "ai",
                    });
                  }}
                  onNarrationDelete={(narration) => {
                    if (!narration) {
                      return;
                    }

                    const targetNavId = narration.navId || navItemSelected;
                    if (!targetNavId) {
                      return;
                    }

                    const state = this.props.store.getState();
                    const soundListByView = state.undoGroup.present.soundList || {};
                    const sceneSounds = soundListByView[targetNavId] || [];

                    const narrationPath = narration.filePath || "";
                    const narrationFileName =
                      typeof narrationPath === "string" && narrationPath.indexOf("/") !== -1
                        ? narrationPath.split("/").pop()
                        : narrationPath;

                    const indexToDelete = sceneSounds.findIndex((s, idx) => {
                      if (!s) return false;

                      const soundFile = s.file || "";
                      if (!soundFile) return false;

                      const soundFileName =
                        typeof soundFile === "string" && soundFile.indexOf("/") !== -1
                          ? soundFile.split("/").pop()
                          : soundFile;

                      const isMatch =
                        narrationFileName &&
                        soundFileName &&
                        soundFileName.indexOf(narrationFileName) !== -1;
                      return isMatch;
                    });

                    if (indexToDelete >= 0) {
                      dispatch(deleteSound(targetNavId, indexToDelete));
                    }
                  }}
                  onSceneOpen={(navId) => {
                    if (navId) {
                      dispatch(selectNavItem(navId));
                    }
                  }}
                  onBoxAdded={this.handleBoxAdded}
                  onIndexSelected={(id) => dispatch(selectIndex(id))}
                  onContainedViewNameChanged={(id, titleStr) =>
                    dispatch(updateViewToolbar(id, titleStr))
                  }
                  onContainedViewSelected={(id) => dispatch(selectContainedView(id))}
                  onContainedViewDeleted={(cvid) => {
                    let boxesRemoving = [];
                    containedViews[cvid].boxes.map((boxId) => {
                      boxesRemoving.push(boxId);
                      boxesRemoving = boxesRemoving.concat(getDescendantBoxes(boxes[boxId], boxes));
                    });

                    dispatch(
                      deleteContainedView([cvid], boxesRemoving, containedViews[cvid].parent)
                    );
                  }}
                  onNavItemNameChanged={(id, titleStr) => dispatch(updateViewToolbar(id, titleStr))}
                  onNavItemAdded={(
                    id,
                    name,
                    parent,
                    type,
                    position,
                    background,
                    customSize,
                    hideTitles,
                    hasContent,
                    sortable_id
                  ) => {
                    if (isBuildLocked()) return;
                    dispatch(
                      addNavItem(
                        id,
                        name,
                        parent,
                        type,
                        position,
                        background,
                        customSize,
                        hideTitles,
                        type !== "section" ||
                          (type === "section" && IdealStudio.Config.sections_have_content),
                        sortable_id,
                        navItemSelected
                      )
                    );
                  }}
                  onNavItemSelected={(id) => dispatch(selectNavItem(id))}
                  onNavItemExpanded={(id, value) => dispatch(expandNavItem(id, value))}
                  onNavItemDuplicated={(id) => {
                    if (!isBuildLocked()) this.duplicateNavItem(id);
                  }}
                  onNavItemDuplicatedByPayload={(index) => {
                    if (!isBuildLocked()) this.duplicateNavItemByPayload(index);
                  }}
                  onNavItemDeleted={(navsel) => {
                    if (isBuildLocked()) return;
                    this.setState({ timelineVisible: false });
                    this.dispatchNavItemDelete(navsel);
                  }}
                  onNavItemsDeleted={(ids) => this.deleteNavItemsBulk(ids)}
                  onNavItemReordered={(id, newParent, oldParent, idsInOrder, childrenInOrder) =>
                    !isBuildLocked() &&
                    dispatch(reorderNavItem(id, newParent, oldParent, idsInOrder, childrenInOrder))
                  }
                  carouselShow={this.state.carouselShow}
                  carouselFull={this.state.carouselFull}
                  onToggleFull={() => {
                    if (this.state.carouselFull) {
                      this.setState({ carouselFull: false });
                    } else {
                      this.setState({ carouselFull: true, carouselShow: true });
                    }
                  }}
                  onToggleWidth={() => {
                    if (this.state.carouselShow) {
                      this.setState({ carouselFull: false, carouselShow: false });
                    } else {
                      this.setState({ carouselShow: true });
                    }
                  }}
                  uploadedTemplates={
                    this.props.store.getState().undoGroup.present.uploadedTemplates
                  }
                  onLibraryCategorySelected={(cat) =>
                    this.setState({
                      libraryCategory: cat,
                      aiPanel: null,
                    })
                  }
                  assessmentCategory={this.state.assessmentCategory}
                  onAssessmentCategorySelected={(cat) =>
                    this.setState({
                      assessmentCategory: cat,
                      aiPanel: null,
                    })
                  }
                  onSetAssessmentCategory={(cat) => this.setState({ assessmentCategory: cat })}
                  onReturnToLayers={() => this.setState({ leftPanel: "layers" })}
                  onSetLibraryCategory={(cat) => this.setState({ libraryCategory: cat })}
                  onReplacePluginFile={(replaceId, url, componentType) => {
                    if (replaceId && replaceId.startsWith("sce-el:")) {
                      const parts = replaceId.split(":");
                      const boxId = parts[1];
                      const sceneId = parts[2];
                      const elementId = parts[3];
                      const fieldName = parts[4];
                      dispatch(updateScenarioElement(boxId, sceneId, elementId, [fieldName], url));
                      this.setState({
                        fileModalResult: { id: undefined, value: undefined },
                      });
                      return;
                    }

                    const targetScene =
                      containedViewSelected && containedViewSelected !== 0
                        ? containedViewSelected
                        : navItemSelected;

                    dispatch(
                      updatePluginToolbar(replaceId, "main", "state", "url", url, [], targetScene)
                    );
                    // Keep the source marker in sync so the next "Replace File"
                    // reopens the new file's section, not the original one.
                    if (componentType) {
                      dispatch(
                        updatePluginToolbar(
                          replaceId,
                          "main",
                          "state",
                          "componentType",
                          componentType,
                          [],
                          targetScene
                        )
                      );
                    }

                    this.setState({
                      fileModalResult: { id: undefined, value: undefined },
                    });
                  }}
                  onShowServerModal={(titleText, messageText, isSuccess) =>
                    this.setState({
                      serverModalTitle: titleText,
                      serverModalMessage: messageText,
                      serverModalSuccess: isSuccess,
                      serverModal: true,
                    })
                  }
                  ttiGenerateImageFile={(payload, callback) =>
                    dispatch(ttiGenerateImageFile(payload, callback))
                  }
                  ttsGenerateSoundFile={(payload, callback) =>
                    dispatch(ttsGenerateSoundFile(payload, callback))
                  }
                  onAddImageModalToggle={(callback) =>
                    this.setState({
                      showAddImageModal: !this.state.showAddImageModal,
                      onAddImageModalSelected: typeof callback === "function" ? callback : null,
                      addImageModalTitle: null,
                    })
                  }
                  onAddAvatarModalToggle={() =>
                    this.setState({
                      showAddSoundModal: !this.state.showAddSoundModal,
                      addSoundModalTab: "avatar",
                    })
                  }
                  onAddSoundModalNewToggle={() =>
                    this.setState({
                      showAddSoundModal: !this.state.showAddSoundModal,
                      addSoundModalTab: "ai",
                    })
                  }
                  onNavItemToggled={(id) => dispatch(toggleNavItem(id))}
                />
              </div>
            </div>

            <div
              id="workspace"
              style={{
                display: "flex",
                flex: "1 1 auto",
                height: "100%",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div
                id="contentColumn"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: "1 1 auto",
                  height: "100%",
                  position: "relative",
                  minHeight: 0,
                }}
              >
                <div
                  id="actionsRibbon"
                  style={{
                    position: "absolute",
                    top: 8,
                    left: 0,
                    right: 0,
                    zIndex: 200,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "transparent",
                    pointerEvents: "none",
                  }}
                >
                  <div
                    id="ribbonRow"
                    style={{
                      top: "-1px",
                      left: 0,
                      height: this.state.pluginTab ? "auto" : "0",
                      maxWidth: 484,
                    }}
                  >
                    <PluginRibbon
                      category={this.state.pluginTab}
                      exercises={exercises}
                      pluginToolbars={pluginToolbars}
                      navItemsIds={navItemsIds}
                      navItemSelected={navItemSelected}
                      viewToolbars={viewToolbars}
                      onToolbarUpdated={this.toolbarUpdated}
                      ttiGenerateImageFile={(payload, callback) =>
                        dispatch(ttiGenerateImageFile(payload, callback))
                      }
                      ttsGenerateSoundFile={(payload, callback) =>
                        dispatch(ttsGenerateSoundFile(payload, callback))
                      }
                    />
                  </div>
                  <ActionsRibbon
                    onCanvasZoom={this.handleCanvasZoom}
                    canvasZoom={this.state.canvasZoom}
                    canvasZoomMin={CANVAS_ZOOM_MIN}
                    canvasZoomMax={CANVAS_ZOOM_MAX}
                    onAddImageModalToggle={(callback, titleRefStr = null) =>
                      this.setState({
                        showAddImageModal: !this.state.showAddImageModal,
                        onAddImageModalSelected: typeof callback === "function" ? callback : null,
                        addImageModalTitle: titleRefStr,
                      })
                    }
                    onContainerToggle={() => {
                      this.setState({ grid: !this.state.grid });
                    }}
                    grid={this.state.grid}
                    undoDisabled={undoDisabled}
                    redoDisabled={redoDisabled}
                    onUndo={() => {
                      dispatch(ActionCreators.undo());
                    }}
                    onRedo={() => {
                      dispatch(ActionCreators.redo());
                    }}
                    onBoxLayerChanged={(id, parent, container, value, boxes_array) =>
                      dispatch(changeBoxLayer(id, parent, container, value, boxes_array))
                    }
                    navItemSelected={navItemSelected}
                    openTextEditor={this.state.openTextEditor}
                    containedViewSelected={containedViewSelected}
                    boxSelected={boxSelected}
                    boxSelectedAll={boxSelectedAll}
                    boxes={boxes}
                    navItems={navItems}
                    marks={marks}
                    globalConfig={globalConfig}
                    exercises={exercises}
                    containedViews={containedViews}
                    pluginToolbars={pluginToolbars}
                    onTextEditorToggled={this.onTextEditorToggled}
                    openConfigModal={(id) => {
                      this.setState({ pluginConfigModal: id });
                    }}
                    onBoxPasted={(ids, box, toolbar, children, index, markList, score) =>
                      dispatch(pasteBox(ids, box, toolbar, children, index, markList, score))
                    }
                    onBoxAdded={this.handleBoxAdded}
                    onBoxDeleted={this.onBoxDeleted}
                    uploadFunction={(query, keywords, callback) =>
                      dispatch(uploadFunction(query, keywords, callback))
                    }
                    ribbonHeight={ribbonHeight + "px"}
                    clipboardRef={this.clipboardRef}
                    viewToolbars={viewToolbars}
                    animations={animationsById}
                    soundList={soundList}
                    onScenePasted={(rekeyed) => dispatch(pasteScene(rekeyed, { navItemSelected }))}
                    onNavItemSelected={(id) => dispatch(selectNavItem(id))}
                    onSave={() =>
                      dispatch(
                        exportStateAsync(
                          { ...this.props.store.getState() },
                          null,
                          null,
                          this.state.trainingId || window.idealStudioTrainingId,
                          window.tenantId
                        )
                      ).then((result) => {
                        if (result && result.conflict) {
                          this._openSaveConflict(result.currentUpdatedAt);
                        }
                      })
                    }
                  />
                </div>

                {/* Reserve exactly the space the timeline dock occupies */}
                <div
                  id="canvasArea"
                  className={this.state.remotionTimelineVisible ? "timeline-visible" : ""}
                  style={{
                    position: "relative",
                    height: `calc(100% - ${timelineDockHeight}px)`,
                    transition: "height 0.3s ease",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: canvasSceneLeft,
                      overflow: "hidden",
                      transition: "left 0.25s ease",
                    }}
                  >
                    <BuildCanvasOverlay selectedId={navItemSelected} realIds={navItemsIds} />
                    {/* invisible: locks the scene's timeline clips (Toolbar.scss) while its job runs;
                        the canvas shows the sync overlay (EditorCanvasSli) for the whole run */}
                    {this.state.motionBusy[navItemSelected] && (
                      <div className="aidea-motion-busy" />
                    )}
                    {containedViewSelected === 0 && (
                      <EditorCanvas
                        slideScale={this.state.canvasZoom || 1}
                        {...this.getEditorCanvasProps({
                          dispatch,
                          boxes,
                          boxSelected,
                          boxLevelSelected,
                          marks,
                          navItems,
                          navItemSelected,
                          containedViews,
                          containedViewSelected,
                          exercises,
                          viewToolbars,
                          pluginToolbars,
                          title,
                          lastActionDispatched,
                          canvasRatio,
                          globalConfig,
                        })}
                      />
                    )}
                    {containedViewSelected !== 0 && (
                      <ContainedCanvas
                        {...this.getContainedCanvasProps({
                          dispatch,
                          boxes,
                          boxSelected,
                          boxLevelSelected,
                          marks,
                          navItems,
                          navItemSelected,
                          containedViews,
                          containedViewSelected,
                          exercises,
                          viewToolbars,
                          pluginToolbars,
                          title,
                          lastActionDispatched,
                          canvasRatio,
                        })}
                      />
                    )}
                  </div>
                  {/* Portal target for EditorShortcuts — outside zoom div, unaffected by scale transform */}
                  <div
                    id="editorBoxIconsRoot"
                    style={{
                      position: "absolute",
                      inset: 0,
                      pointerEvents: "none",
                      zIndex: 99,
                      display: "none",
                    }}
                  />
                  {/* Portal target for EditorShortcuts pill buttons — overlays the
                      canvas without being inside the zoom transform.
                      Above .rightIconStrip (103) and the right drawers (100/102):
                      a full-bleed element pushes its pill/gear popover against the
                      right rail, and it used to be drawn underneath. The layer keeps
                      pointerEvents:none, so only the pill itself takes the clicks,
                      and ToolsPanel/crop still hide it outright (_editorBox.scss). */}
                  <div
                    id="topPillRoot"
                    style={{
                      position: "absolute",
                      inset: 0,
                      pointerEvents: "none",
                      zIndex: 104,
                    }}
                  />

                  {/* Top-left overlays share one row so they never overlap. */}
                  <div
                    className="canvasOverlayRow"
                    hidden={!!this.state.styleCopyMode}
                    style={{
                      left: this.state.carouselShow
                        ? leftPanelExpandedWidth + (overlayOpen ? LEFT_PANEL_OVERLAY_WIDTH : 0) + 16
                        : 16,
                    }}
                  >
                    {/* Floating scene actions (top-left) — undo / redo / grid / theme */}
                    <CanvasTopToolbar
                      onUndo={() => dispatch(ActionCreators.undo())}
                      onRedo={() => dispatch(ActionCreators.redo())}
                      undoDisabled={undoDisabled}
                      redoDisabled={redoDisabled}
                      gridActive={this.state.grid}
                      onToggleGrid={() => this.setState({ grid: !this.state.grid })}
                      onOpenTheme={() => this.setState({ showThemeModal: true })}
                      fontFamily={
                        (viewToolbars[navItemSelected] &&
                          viewToolbars[navItemSelected].fontFamily) ||
                        globalConfig.fontFamily ||
                        ""
                      }
                      onSelectFont={(font, allScenes) => this.applyCanvasFont(font, allScenes)}
                      onPreviewFont={(font) => this.previewCanvasFont(font)}
                    />

                    {/* Alignment bar — appears next to the top-left toolbar
                      while 2+ elements are selected. Left/right anchor to the
                      outermost element, center to the middle one (3+ only). */}
                    <CanvasAlignToolbar
                      selectedCount={Array.isArray(boxSelectedAll) ? boxSelectedAll.length : 0}
                      onAlign={(type) => {
                        const present = this.props.store.getState().undoGroup.present;
                        const ids = present.boxSelectedAll;
                        if (!Array.isArray(ids) || ids.length < 2) return;
                        alignBoxes(
                          type,
                          ids,
                          present.boxesById,
                          present.pluginToolbarsById,
                          dispatch
                        );
                      }}
                      textFormat={this.getMultiTextFormatProps()}
                    />
                  </div>

                  <StyleClipboardBar
                    selectedIds={eligibleStyleTargets(
                      getStyleClipboard(),
                      Array.isArray(boxSelectedAll) && boxSelectedAll.length
                        ? boxSelectedAll
                        : isBox(boxSelected)
                          ? [boxSelected]
                          : [],
                      pluginToolbars
                    )}
                    onApply={(payload, ids) =>
                      applyStyleToBoxes(
                        payload,
                        ids,
                        this.props.store.getState().undoGroup.present,
                        dispatch
                      )
                    }
                  />

                  {/* Floating zoom widget — bottom-right, above the timeline dock */}
                  <CanvasZoomControl
                    zoom={this.state.canvasZoom || 1}
                    min={CANVAS_ZOOM_MIN}
                    max={CANVAS_ZOOM_MAX}
                    onZoom={this.handleCanvasZoom}
                    onReset={() => this.handleCanvasZoom("reset")}
                    style={{ right: 24, bottom: 16 }}
                  />

                  {/* Avatar canlandırma — zoom widget'ının hemen üstü. Kursta
                      hiç AvatarPlayer kutusu yoksa kendini hiç render etmez. */}
                  <AnimateAvatarsButton
                    t={(k, d) => i18n.t(k, { defaultValue: d })}
                    style={{ right: 24, bottom: 68 }}
                  />

                  {/* === Task 25 === Floating workflow FAB — bottom-right, only
                      visible when the selected box is an InteractivePlugin
                      with items[].length > 0. */}
                  <WorkflowFAB />
                  {/* === /Task 25 === */}
                  {/* === Interactivity Studio mount === Single modal that
                      hosts the Workflow, Suggestions, and Flow Viewer tabs.
                      Self-gates on the interactivityStudio.open reducer, so
                      this mount renders nothing unless one of the entry-point
                      buttons (FAB, AI Suggestions, Left-panel branch) has
                      dispatched openInteractivityStudio({tab}). */}
                  <InteractivityStudio />
                  {/* === /Interactivity Studio mount === */}
                </div>

                {timelineEnabled && (
                  <div
                    id="timelineDock"
                    style={{
                      position: "absolute",
                      left: 0,
                      right: 0,
                      bottom: 0,
                      pointerEvents: "auto",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* ── IdeaTimeline panel ── */}
                    <div
                      style={{
                        height: this.state.ideaTimelineVisible
                          ? `${this.state.ideaTimelineHeight}px`
                          : `${TIMELINE.collapsedHeight}px`,
                        overflow: "hidden",
                        transition: "height 0.3s ease, margin-left 0.25s ease",
                        flexShrink: 0,
                        position: "relative",
                        borderTop: "1px solid #e5e7eb",
                        marginLeft: this.state.carouselShow
                          ? `${leftPanelExpandedWidth + (overlayOpen ? LEFT_PANEL_OVERLAY_WIDTH : 0)}px`
                          : "0px",
                      }}
                    >
                      {/* resize handle */}
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          height: "6px",
                          cursor: "ns-resize",
                          background: "transparent",
                          zIndex: 10,
                          opacity: this.state.ideaTimelineVisible ? 1 : 0,
                          pointerEvents: this.state.ideaTimelineVisible ? "auto" : "none",
                        }}
                        onMouseDown={(e) => {
                          if (!this.state.ideaTimelineVisible) return;
                          const startY = e.clientY;
                          const startH = this.state.ideaTimelineHeight;
                          const onMove = (me) => {
                            const newH = Math.max(
                              TIMELINE.minHeight,
                              Math.min(TIMELINE.maxHeight, startH + (startY - me.clientY))
                            );
                            this.setState({ ideaTimelineHeight: newH });
                          };
                          const onUp = () => {
                            document.removeEventListener("mousemove", onMove);
                            document.removeEventListener("mouseup", onUp);
                            document.body.style.cursor = "";
                            document.body.style.userSelect = "";
                          };
                          document.addEventListener("mousemove", onMove);
                          document.addEventListener("mouseup", onUp);
                          document.body.style.cursor = "ns-resize";
                          document.body.style.userSelect = "none";
                          e.preventDefault();
                        }}
                      />
                      {
                        <IdeaTimeline
                          ref={this.ideaTimelineRef}
                          boxes={boxes}
                          store={this.props.store}
                          navItemSelected={navItemSelected}
                          containedViewSelected={containedViewSelected}
                          duration={(() => {
                            const sceneId =
                              containedViewSelected && containedViewSelected !== 0
                                ? containedViewSelected
                                : navItemSelected;
                            const navItem =
                              this.props.store.getState().undoGroup.present.navItemsById?.[sceneId];
                            // Raw persisted value — 0 means "never set", which
                            // lets the timeline run its one-time bootstrap.
                            return navItem?.duration || 0;
                          })()}
                          onDurationChange={(newDuration) => {
                            const sceneId =
                              containedViewSelected && containedViewSelected !== 0
                                ? containedViewSelected
                                : navItemSelected;
                            dispatch(changeNavItemDuration(sceneId, newDuration));
                          }}
                          onPersistLayerEnds={(items) => {
                            // One-time freeze of legacy endFrame-less boxes (see
                            // IdeaTimeline rebuild effect).
                            items.forEach(({ id, endFrame }) =>
                              dispatch(updateBoxTimeline(id, { endFrame }))
                            );
                          }}
                          selectedBoxId={boxSelected}
                          onPlaybackSpeedChange={(rate) => this.setPreviewSpeed(rate)}
                          playAnimation={() => {
                            this._soundPlaying = true;
                            this.setState({ soundPlaying: true });
                            if (this.animationScene) {
                              if (typeof this.animationScene.setPlaySpeed === "function") {
                                this.animationScene.setPlaySpeed(this._previewSpeed);
                              }
                              this.animationScene.play();
                            }
                          }}
                          pauseAnimation={() => {
                            this._soundPlaying = false;
                            this.setState({ soundPlaying: false });
                            if (this.animationScene) this.animationScene.pause();
                            this.pauseSceneAudioPool();
                          }}
                          setCurrentTime={(time, opts) => {
                            this._publishTimelineTime(time);
                            if (this.animationScene) this.animationScene.setTime(time);
                            this.driveSceneNarration(time, opts);
                          }}
                          // Narration alone, for the task the timeline clock starts in.
                          driveNarration={(time) => this.startSceneNarration(time)}
                          narrationHolders={(time, opts) => this.narrationHolders(time, opts)}
                          onTriggerAnimation={(layerId, relativeTime) => {
                            if (!this.animationScene) this.loadAnimation();
                            if (this.animationScene) this.animationScene.setTime(relativeTime);
                          }}
                          onTriggerLayerAnimation={(layerId, currentTime, animationInfo) => {
                            // Atomic boxes need currentTime in Context for field-level scrub.
                            this.updateAtomicLayerCurrentTime(layerId, animationInfo);
                            if (animationInfo && animationInfo.isTimeUpdate) {
                              // CharacterPlayback uses the box-relative timeline time for
                              // its flipbook frames and movement interpolation.
                              emitCharacterTime(
                                this.props.store.getState().undoGroup.present,
                                layerId,
                                animationInfo
                              );
                            }
                            const element = document.getElementById(`box-${layerId}`);
                            if (!element) return;
                            if (animationInfo && animationInfo.isTimeUpdate) {
                              // A timeline click/scrub — cancel any one-shot entry/exit
                              // preview still running (see AnimationPanel's Pan preset)
                              // so its RAF loop doesn't keep overwriting the position
                              // the user just navigated to.
                              this._cancelBoxAnimPreview();
                              if (animationInfo.inRange === false) {
                                // Out of range: hide, or draw a settled ghost in ghost mode.
                                if (animationInfo.ghost) {
                                  resetElementAnimationState(element);
                                  element.style.opacity = "0.35";
                                  element.dataset.aideaGhost = "1";
                                } else {
                                  element.style.opacity = "0";
                                  delete element.dataset.aideaGhost;
                                }
                                element.style.pointerEvents = "none";
                                return;
                              }
                              // Element timeline içinde — görünürlük kontrolü
                              const boxesById =
                                this.props.store.getState().undoGroup.present.boxesById;
                              const pluginToolbarsById =
                                this.props.store.getState().undoGroup.present.pluginToolbarsById;
                              const box = boxesById[layerId];
                              // InteractivePlugin visibility is gate-managed: IdeaTimeline
                              // shows/hides the box via direct DOM when the interactive gate
                              // activates/deactivates. Letting the normal inRange path reset
                              // opacity here would override the gate's hide-on-resume logic.
                              const tb = pluginToolbarsById && pluginToolbarsById[layerId];
                              if (tb && tb.pluginId === "InteractivePlugin") return;
                              const timelineVisible =
                                box?.timeline?.visible !== undefined
                                  ? box.timeline.visible
                                  : box?.visible;
                              if (timelineVisible === false) {
                                element.style.opacity = "0";
                                element.style.pointerEvents = "none";
                                return;
                              }
                              // Reset any hide-state from a previous out-of-range tick.
                              element.style.opacity = "";
                              element.style.pointerEvents = "";
                              delete element.dataset.aideaGhost;
                              const relativeTime = animationInfo.layerRelativeTime || 0;
                              if (box) {
                                resetElementAnimationState(element, true);
                                const effectiveBoxAnim =
                                  box.boxAnimation ?? box.textAnimation ?? null;
                                if (effectiveBoxAnim && effectiveBoxAnim.animation) {
                                  // delay timeline konumunu belirlemek için kullanıldı,
                                  // oynatmada layer başından itibaren animasyon başlamalı
                                  applyBoxAnimation(
                                    element,
                                    { ...effectiveBoxAnim, delay: 0 },
                                    relativeTime
                                  );
                                }
                                if (box.boxExitAnimation && box.boxExitAnimation.animation) {
                                  const layerDuration =
                                    (animationInfo.layerEndFrame - animationInfo.layerStartFrame) /
                                    30;
                                  applyBoxExitAnimation(
                                    element,
                                    box.boxExitAnimation,
                                    relativeTime,
                                    layerDuration
                                  );
                                }
                              }
                              // Ghost mode: an in-window element the animation still
                              // hides also draws as a settled ghost.
                              if (animationInfo.ghost) {
                                const inlineOp = element.style.opacity;
                                const effOp = inlineOp === "" ? 1 : parseFloat(inlineOp) || 0;
                                if (effOp <= 0.05) {
                                  resetElementAnimationState(element);
                                  element.style.opacity = "0.35";
                                  element.style.pointerEvents = "none";
                                  element.dataset.aideaGhost = "1";
                                }
                              }
                              return;
                            }
                            const animationsByLayer =
                              this.props.store.getState().undoGroup.present.animationsById[
                                layerId
                              ] || [];
                            if (
                              animationsByLayer.length > 0 &&
                              animationInfo &&
                              !animationInfo.isTimeUpdate
                            ) {
                              const { startKeyframe, endKeyframe, progress } = animationInfo;
                              if (startKeyframe && endKeyframe) {
                                interpolateAnimationFrame(
                                  element,
                                  startKeyframe,
                                  endKeyframe,
                                  progress
                                );
                              }
                            }
                          }}
                          onLayerUpdate={(id, newStart, newEnd, extra = {}, sourceLayer) => {
                            if (sourceLayer?.type === "scene-audio") {
                              const { sceneId, soundIndex, audioData } = sourceLayer;
                              const sound = audioData || {};
                              // Address by stable id — EDIT_SOUND re-sorts the
                              // list, so the baked soundIndex goes stale.
                              dispatch(
                                editSound(sceneId, sound.id ?? soundIndex, {
                                  ...sound,
                                  startTime: newStart / 30,
                                  endTime: newEnd / 30,
                                  duration: (newEnd - newStart) / 30,
                                  ...(extra.splitGroup ? { splitGroup: extra.splitGroup } : {}),
                                  ...(extra.trackId !== undefined
                                    ? { trackId: extra.trackId }
                                    : {}),
                                  // Head trim ("kes ve sil") moves the sound's
                                  // in-point inside the source file.
                                  ...(extra.audioOffset !== undefined
                                    ? { audioOffset: extra.audioOffset }
                                    : {}),
                                })
                              );
                            } else {
                              dispatch(
                                updateBoxTimeline(id, {
                                  startFrame: newStart,
                                  endFrame: newEnd,
                                  userSetEndFrame: true,
                                  ...extra,
                                })
                              );
                            }
                          }}
                          onLayerTrackChange={(id, trackId, sourceLayer) => {
                            // Membership-only updates must not rewrite timing fields.
                            if (sourceLayer?.type === "scene-audio") {
                              const { sceneId, soundIndex, audioData } = sourceLayer;
                              const sound = audioData || {};
                              dispatch(
                                editSound(sceneId, sound.id ?? soundIndex, {
                                  ...sound,
                                  trackId,
                                })
                              );
                            } else {
                              dispatch(updateBoxTimeline(id, { trackId }));
                            }
                          }}
                          onBatchTimelineUpdate={(updates) => {
                            (updates || []).forEach(({ id, timeline }) =>
                              dispatch(updateBoxTimeline(id, timeline))
                            );
                          }}
                          onSplitLayer={({
                            sourceLayer,
                            startFrame,
                            endFrame,
                            trimStart,
                            trimEnd,
                            splitGroup,
                          }) => {
                            // ── Scene-audio split ─────────────────────────────
                            if (sourceLayer.type === "scene-audio") {
                              const { sceneId, audioData } = sourceLayer;
                              const sound = audioData || {};
                              // audioOffset: ses dosyasında sağ parçanın başladığı pozisyon
                              const splitTimeSec = startFrame / 30;
                              const origOffset = sound.audioOffset || 0;
                              const newAudioOffset =
                                splitTimeSec - (sound.startTime || 0) + origOffset;
                              // Read the shortened source fresh before adding its split sibling.
                              let soundTrackId =
                                typeof sound.trackId === "string" ? sound.trackId : null;
                              if (!soundTrackId) {
                                soundTrackId =
                                  "tr-" +
                                  Date.now().toString(36) +
                                  Math.random().toString(36).slice(2, 6);
                                const presentNow = this.props.store.getState().undoGroup.present;
                                const freshList = presentNow.soundList?.[sceneId] || [];
                                // An id-less legacy sound was just given an id by the
                                // shortening edit, so match it by the slot that edit
                                // wrote to — the stale copy would undo the shortening.
                                const fresh =
                                  (sound.id
                                    ? freshList.find((s) => s && s.id === sound.id)
                                    : freshList[sourceLayer.soundIndex]) || sound;
                                dispatch(
                                  editSound(sceneId, sound.id ?? sourceLayer.soundIndex, {
                                    ...fresh,
                                    trackId: soundTrackId,
                                  })
                                );
                              }
                              dispatch(
                                addSound(sceneId, {
                                  ...sound,
                                  // Never inherit the source piece's id — addSound
                                  // (ensureSoundId) assigns a fresh unique one.
                                  id: undefined,
                                  startTime: splitTimeSec,
                                  endTime: endFrame / 30,
                                  duration: (endFrame - startFrame) / 30,
                                  audioOffset: newAudioOffset,
                                  trackId: soundTrackId,
                                  ...(splitGroup ? { splitGroup } : {}),
                                })
                              );
                              return;
                            }
                            // ── Regular box split ─────────────────────────────
                            const sourceBox = sourceLayer.box;
                            const pluginToolbars =
                              this.props.store.getState().undoGroup.present.pluginToolbarsById;
                            const pluginName =
                              pluginToolbars?.[sourceLayer.id]?.pluginId || sourceBox?.pluginId;
                            if (!pluginName) return;
                            const url = sourceLayer.thumbUrl;
                            const inASlide = isSlide(navItemSelected);
                            // The split piece must be a faithful copy of the source:
                            // carry over its plugin state (controls, autoPlay, volume
                            const sourceState = pluginToolbars?.[sourceLayer.id]?.state;
                            const inheritedState = sourceState ? { ...sourceState } : undefined;
                            // Nudge the split piece to the bottom-right so it
                            // doesn't sit invisibly on top of the source box.
                            const nudge = (v, delta) => {
                              const n = parseFloat(v);
                              if (!Number.isFinite(n)) return v;
                              const isPct = String(v).includes("%");
                              const next = n + (isPct ? delta : delta * 10);
                              return (isPct ? Math.min(next, 90) : next) + (isPct ? "%" : "px");
                            };
                            const srcPos = sourceBox.position || {
                              x: "5%",
                              y: "5%",
                              type: "absolute",
                            };
                            const splitPosition = {
                              ...srcPos,
                              x: nudge(srcPos.x, 3),
                              y: nudge(srcPos.y, 3),
                            };
                            const onBoxAdded = (
                              ids,
                              draggable,
                              resizable,
                              content,
                              style,
                              state,
                              structure,
                              initialParams
                            ) =>
                              dispatch(
                                addBox(
                                  ids,
                                  draggable,
                                  resizable,
                                  content,
                                  style,
                                  state,
                                  structure,
                                  initialParams
                                )
                              );
                            let splitTrackId = sourceBox?.timeline?.trackId;
                            if (!splitTrackId) {
                              splitTrackId =
                                "tr-" +
                                Date.now().toString(36) +
                                Math.random().toString(36).slice(2, 6);
                              dispatch(
                                updateBoxTimeline(sourceLayer.id, { trackId: splitTrackId })
                              );
                            }
                            const splitBoxId = ID_PREFIX_BOX + Date.now();
                            createBox(
                              {
                                id: splitBoxId,
                                parent: sourceBox.parent || navItemSelected,
                                container: 0,
                                name: pluginName,
                                page: navItemSelected,
                                position: splitPosition,
                                url,
                                ...(inheritedState ? { initialState: inheritedState } : {}),
                                timeline: {
                                  startFrame,
                                  endFrame,
                                  trimStart,
                                  ...(trimEnd !== null ? { trimEnd } : {}),
                                  ...(splitGroup ? { splitGroup } : {}),
                                  trackId: splitTrackId,
                                  visible: true,
                                },
                              },
                              pluginName,
                              inASlide,
                              onBoxAdded,
                              boxes,
                              sourceBox.style || {}
                            );
                            // Keep the split piece adjacent to its source in z-order.
                            const orderNow =
                              this.props.store.getState().undoGroup.present.navItemsById?.[
                                navItemSelected
                              ]?.boxes;
                            if (
                              Array.isArray(orderNow) &&
                              orderNow.includes(splitBoxId) &&
                              orderNow.includes(sourceLayer.id)
                            ) {
                              const without = orderNow.filter((bid) => bid !== splitBoxId);
                              const next = [...without];
                              next.splice(without.indexOf(sourceLayer.id) + 1, 0, splitBoxId);
                              dispatch(
                                changeBoxLayer(splitBoxId, navItemSelected, 0, "reorder", next)
                              );
                            }
                            // createBox seeds the new box with the plugin's default
                            // structure — copy the source's resized dimensions over
                            // it so the split piece keeps the same size on canvas.
                            // x/y/position stay out: the piece keeps its nudged spot.
                            const sourceStructure = pluginToolbars?.[sourceLayer.id]?.structure;
                            const splitToolbarCreated =
                              this.props.store.getState().undoGroup.present.pluginToolbarsById?.[
                                splitBoxId
                              ];
                            if (sourceStructure && splitToolbarCreated) {
                              const structureCopy = { ...sourceStructure };
                              delete structureCopy.x;
                              delete structureCopy.y;
                              delete structureCopy.position;
                              dispatch(resizeBox(splitBoxId, structureCopy));
                            }
                          }}
                          onDeleteLayer={(layer) => {
                            if (layer?.type === "scene-audio") {
                              const sceneId =
                                containedViewSelected && containedViewSelected !== 0
                                  ? containedViewSelected
                                  : navItemSelected;
                              const soundId = layer.audioData?.id;
                              if (soundId) {
                                dispatch(deleteSound(sceneId, soundId));
                                return;
                              }
                              const sounds =
                                this.props.store.getState().undoGroup.present.soundList?.[
                                  sceneId
                                ] || [];
                              const idx =
                                layer.soundIndex !== undefined
                                  ? layer.soundIndex
                                  : sounds.findIndex((s) => s.id === layer.id);
                              if (idx !== -1 && idx < sounds.length)
                                dispatch(deleteSound(sceneId, idx));
                            } else if (layer?.id && !layer.id.includes("_")) {
                              this.onBoxDeleted(
                                layer.id,
                                boxes[layer.id]?.parent,
                                boxes[layer.id]?.container,
                                navItemSelected
                              );
                            }
                          }}
                          onOpenMerlin={(layerId) => {
                            const pluginToolbars =
                              this.props.store.getState().undoGroup.present.pluginToolbarsById ||
                              {};
                            const imageUrl = pluginToolbars[layerId]?.state?.url || "";
                            this._suppressAutoPanelOnce = true;
                            dispatch(selectBox(layerId, boxes[layerId]));
                            this.setState({
                              timelineMerlinBoxId: layerId,
                              merlinLeaving: false,
                              merlinHandoff: false,
                              timelineMerlinImageUrl: imageUrl,
                            });
                          }}
                          onOpenAnimation={(layerId) => {
                            this._suppressAutoPanelOnce = true;
                            dispatch(selectBox(layerId, boxes[layerId]));
                            this.setState({ rightActiveTab: "animation" });
                          }}
                          onToggleVideoLoop={(layerId) => {
                            const pluginToolbars =
                              this.props.store.getState().undoGroup.present.pluginToolbarsById ||
                              {};
                            const current = pluginToolbars[layerId]?.state?.loop === true;
                            this.toolbarUpdated(layerId, "main", "state", "loop", !current);
                          }}
                          onLayerDoubleClick={(layer) => {
                            if (layer?.type === "scene-audio") {
                              const sceneId =
                                containedViewSelected && containedViewSelected !== 0
                                  ? containedViewSelected
                                  : navItemSelected;
                              const sounds =
                                this.props.store.getState().undoGroup.present.soundList?.[
                                  sceneId
                                ] || [];
                              // Resolve a FRESH index by id — the baked
                              // soundIndex goes stale after every re-sort.
                              const soundId = layer.audioData?.id;
                              const idx = soundId
                                ? sounds.findIndex((s) => s && s.id === soundId)
                                : layer.soundIndex !== undefined
                                  ? layer.soundIndex
                                  : sounds.findIndex((s) => s.id === layer.id);
                              if (idx !== -1 && idx < sounds.length) {
                                this.setAddSoundVisibleWithIndex(idx);
                              }
                            }
                          }}
                          onLayerVisibilityToggle={(id, visible, layer) => {
                            // Scene audio is not a box — persist visibility on the
                            // soundList entry so playback (editor + visor) can skip it.
                            if (layer?.type === "scene-audio") {
                              const sceneId =
                                containedViewSelected && containedViewSelected !== 0
                                  ? containedViewSelected
                                  : navItemSelected;
                              const sounds =
                                this.props.store.getState().undoGroup.present.soundList?.[
                                  sceneId
                                ] || [];
                              const soundId = layer.audioData?.id;
                              const idx = soundId
                                ? sounds.findIndex((s) => s && s.id === soundId)
                                : layer.soundIndex !== undefined
                                  ? layer.soundIndex
                                  : sounds.findIndex((s) => s.id === layer.id);
                              if (idx !== -1 && sounds[idx]) {
                                dispatch(
                                  editSound(sceneId, sounds[idx].id ?? idx, {
                                    ...sounds[idx],
                                    visible,
                                  })
                                );
                              }
                              return;
                            }
                            dispatch(updateBoxTimeline(id, { visible }));
                            const el = document.getElementById(`box-${id}`);
                            if (el) {
                              el.style.opacity = visible ? "" : "0";
                              el.style.pointerEvents = visible ? "" : "none";
                            }
                          }}
                          onLockToggle={(id, locked, layer) => {
                            // Scene audio is not a box — persist lock on the
                            // soundList entry, mirroring onLayerVisibilityToggle above.
                            if (layer?.type === "scene-audio") {
                              const sceneId =
                                containedViewSelected && containedViewSelected !== 0
                                  ? containedViewSelected
                                  : navItemSelected;
                              const sounds =
                                this.props.store.getState().undoGroup.present.soundList?.[
                                  sceneId
                                ] || [];
                              const soundId = layer.audioData?.id;
                              const idx = soundId
                                ? sounds.findIndex((s) => s && s.id === soundId)
                                : layer.soundIndex !== undefined
                                  ? layer.soundIndex
                                  : sounds.findIndex((s) => s.id === layer.id);
                              if (idx !== -1 && sounds[idx]) {
                                dispatch(
                                  editSound(sceneId, sounds[idx].id ?? idx, {
                                    ...sounds[idx],
                                    locked,
                                  })
                                );
                              }
                              return;
                            }
                            dispatch(updateBoxTimeline(id, { locked }));
                          }}
                          onToggleLoop={(id, layer) => {
                            if (layer?.type !== "scene-audio") return;
                            const sceneId =
                              containedViewSelected && containedViewSelected !== 0
                                ? containedViewSelected
                                : navItemSelected;
                            const sounds =
                              this.props.store.getState().undoGroup.present.soundList?.[sceneId] ||
                              [];
                            const soundId = layer.audioData?.id;
                            const idx = soundId
                              ? sounds.findIndex((s) => s && s.id === soundId)
                              : layer.soundIndex !== undefined
                                ? layer.soundIndex
                                : sounds.findIndex((s) => s.id === layer.id);
                            if (idx !== -1 && sounds[idx]) {
                              const sound = sounds[idx];
                              dispatch(
                                editSound(sceneId, sound.id ?? idx, {
                                  ...sound,
                                  loopScene: !sound.loopScene,
                                })
                              );
                            }
                          }}
                          onLayerReorder={(parentId, orderedIds, draggedId) => {
                            // Same action the canvas "bring to front/back" buttons use —
                            // "reorder" replaces the scene's whole box array at once.
                            dispatch(changeBoxLayer(draggedId, parentId, 0, "reorder", orderedIds));
                          }}
                          onSceneAudioReorder={(sceneId, updates) => {
                            // Timeline row DISPLAY position(s) only — does not touch
                            // any narration's startTime or the soundList array's own
                            // (always chronological) storage order. Batched: a single
                            // row drag (box or narration) can shift more than one
                            // narration row's effective position at once.
                            dispatch(setSceneAudioRowOrders(sceneId, updates));
                          }}
                          onAnimationReset={() => {
                            const boxesById =
                              this.props.store.getState().undoGroup.present.boxesById;
                            resetAllEditorAnimations(boxesById);
                            this.setState({ animationResetTriggered: Date.now() });
                          }}
                          onSelectLayer={(id) => {
                            this._suppressAutoPanelOnce = true;
                            dispatch(selectBox(id, boxes[id]));
                          }}
                          onSelectSubField={(sub) => {
                            // Select the parent atomic box so the panel edits the
                            // clicked sub-field.
                            if (sub && sub.boxId && boxes[sub.boxId]) {
                              this._suppressAutoPanelOnce = true;
                              dispatch(selectBox(sub.boxId, boxes[sub.boxId]));
                            }
                            this.setState(
                              sub
                                ? { selectedAtomicSubField: sub }
                                : { selectedAtomicSubField: null }
                            );
                          }}
                          onSubFieldTimingChange={this.updateAtomicFieldTimings}
                          onSyncScene={(o) =>
                            o && o.extractTexts
                              ? this.handleMotionizeScene({ extractOnly: true })
                              : this.handleSyncScene()
                          }
                          onMotionizeScene={(c) => this.handleMotionizeScene(c)}
                          syncingScene={!!this.state.syncByScene[this.props.navItemSelected]}
                          syncSceneStatus={this.state.syncByScene[this.props.navItemSelected]}
                          collapsed={!this.state.ideaTimelineVisible}
                          onToggleCollapse={() =>
                            this.setState({
                              ideaTimelineVisible: !this.state.ideaTimelineVisible,
                            })
                          }
                          knollingViewVisible={this.state.knollingViewVisible}
                          onToggleKnolling={() =>
                            this.setState({
                              knollingViewVisible: !this.state.knollingViewVisible,
                            })
                          }
                        />
                      }
                    </div>

                    {/* TODO: deprecated — eski TimelineSection (gizli, IdeaTimeline'a geçildi). Kaldırılacak. */}
                    <div style={{ display: "none" }}>
                      <TimelineSection
                        enableTimeline={globalConfig.enableTimeline}
                        remotionTimelineVisible={this.state.remotionTimelineVisible}
                        timelineHeight={this.state.timelineHeight}
                        onToggleVisible={() =>
                          this.setState({
                            remotionTimelineVisible: !this.state.remotionTimelineVisible,
                          })
                        }
                        onResize={(newHeight) => this.setState({ timelineHeight: newHeight })}
                        onSyncScene={() => this.handleSyncScene()}
                        i18n={i18n}
                        remotionTimelineRef={this.remotionTimelineRef}
                        boxes={boxes}
                        store={this.props.store}
                        dispatch={dispatch}
                        changeBoxLayer={(...args) => dispatch(changeBoxLayer(...args))}
                        updateBox={(...args) => dispatch(updateBox(...args))}
                        selectBox={(...args) => dispatch(selectBox(...args))}
                        updateTextAnimation={(...args) => dispatch(updateTextAnimation(...args))}
                        updateBoxAnimation={(...args) => dispatch(updateBoxAnimation(...args))}
                        deleteTextAnimation={(...args) => dispatch(deleteTextAnimation(...args))}
                        deleteBoxAnimation={(...args) => dispatch(deleteBoxAnimation(...args))}
                        saveAnimation={(...args) => dispatch(saveAnimation(...args))}
                        onTriggerAnimation={(layerId, relativeTime) => {
                          const currentTime = relativeTime;
                          if (!this.animationScene) {
                            this.loadAnimation();
                          }
                          if (this.animationScene) {
                            this.animationScene.setTime(currentTime);
                          }
                        }}
                        onTriggerLayerAnimation={(layerId, currentTime, animationInfo) => {
                          const element = document.getElementById(`box-${layerId}`);
                          if (!element) return;

                          if (animationInfo && animationInfo.isTimeUpdate) {
                            // Character plugin drives its flipbook from the timeline
                            // playhead, so feed it the box-relative time each tick.
                            emitCharacterTime(
                              this.props.store.getState().undoGroup.present,
                              layerId,
                              animationInfo
                            );
                            if (animationInfo.inRange === false) {
                              // Same ghost handling as the main handler.
                              if (animationInfo.ghost) {
                                resetElementAnimationState(element);
                                element.style.opacity = "0.35";
                                element.dataset.aideaGhost = "1";
                              } else {
                                element.style.opacity = "0";
                                delete element.dataset.aideaGhost;
                              }
                              element.style.pointerEvents = "none";
                              return;
                            }
                            const boxesById =
                              this.props.store.getState().undoGroup.present.boxesById;
                            const box = boxesById[layerId];
                            const timelineVisible =
                              box?.timeline?.visible !== undefined
                                ? box.timeline.visible
                                : box?.visible;
                            if (timelineVisible === false) {
                              element.style.opacity = "0";
                              element.style.pointerEvents = "none";
                              return;
                            }
                            element.style.pointerEvents = "";
                            delete element.dataset.aideaGhost;
                            const relativeTime = animationInfo.layerRelativeTime || 0;
                            if (box) {
                              resetElementAnimationState(element, true);
                              const effectiveBoxAnim =
                                box.boxAnimation ?? box.textAnimation ?? null;
                              if (effectiveBoxAnim && effectiveBoxAnim.animation) {
                                applyBoxAnimation(
                                  element,
                                  { ...effectiveBoxAnim, delay: 0 },
                                  relativeTime
                                );
                              }
                              if (box.boxExitAnimation && box.boxExitAnimation.animation) {
                                const layerDuration =
                                  (animationInfo.layerEndFrame - animationInfo.layerStartFrame) /
                                  30;
                                applyBoxExitAnimation(
                                  element,
                                  box.boxExitAnimation,
                                  relativeTime,
                                  layerDuration
                                );
                              }
                            }
                            // Same ghost handling as the main handler.
                            if (animationInfo.ghost) {
                              const inlineOp = element.style.opacity;
                              const effOp = inlineOp === "" ? 1 : parseFloat(inlineOp) || 0;
                              if (effOp <= 0.05) {
                                resetElementAnimationState(element);
                                element.style.opacity = "0.35";
                                element.style.pointerEvents = "none";
                                element.dataset.aideaGhost = "1";
                              }
                            }
                            return;
                          }

                          const animationsByLayer =
                            this.props.store.getState().undoGroup.present.animationsById[layerId] ||
                            [];
                          if (
                            animationsByLayer.length > 0 &&
                            animationInfo &&
                            !animationInfo.isTimeUpdate
                          ) {
                            const { startKeyframe, endKeyframe, progress } = animationInfo;
                            if (startKeyframe && endKeyframe) {
                              interpolateAnimationFrame(
                                element,
                                startKeyframe,
                                endKeyframe,
                                progress
                              );
                            }
                          }
                        }}
                        onAnimationReset={() => {
                          const boxesById = this.props.store.getState().undoGroup.present.boxesById;
                          resetAllEditorAnimations(boxesById);
                          this.setState({ animationResetTriggered: Date.now() });
                        }}
                        onAnimationUpdate={(layerId, updatedAnimations) => {
                          const existingAnimations =
                            this.props.store.getState().undoGroup.present.animationsById[layerId] ||
                            [];
                          dispatch(saveAnimation(layerId, updatedAnimations));
                          updatedAnimations.forEach((newAnim, index) => {
                            if (existingAnimations[index]) {
                              const existingAnim = existingAnimations[index];
                              if (existingAnim.type === "text") {
                                dispatch(
                                  updateTextAnimation(
                                    layerId,
                                    existingAnim.animation,
                                    newAnim.duration || newAnim.startTime || existingAnim.duration,
                                    newAnim.delay || existingAnim.delay || 0
                                  )
                                );
                              } else if (existingAnim.type === "box") {
                                dispatch(
                                  updateBoxAnimation(
                                    layerId,
                                    existingAnim.animation,
                                    newAnim.duration || newAnim.startTime || existingAnim.duration,
                                    newAnim.delay || existingAnim.delay || 0
                                  )
                                );
                              }
                            }
                          });
                        }}
                        editAnimation={(animId, startTime, endTime) => {
                          const allAnimations =
                            this.props.store.getState().undoGroup.present.animationsById;
                          Object.keys(allAnimations).forEach((layerId) => {
                            const animations = allAnimations[layerId];
                            animations.forEach((anim) => {
                              if (anim.id === animId) {
                                if (anim.type === "text") {
                                  dispatch(
                                    updateTextAnimation(layerId, anim.animation, endTime, startTime)
                                  );
                                } else {
                                  dispatch(
                                    updateBoxAnimation(layerId, anim.animation, endTime, startTime)
                                  );
                                }
                              }
                            });
                          });
                        }}
                        playAnimation={() => {
                          this._soundPlaying = true;
                          this.setState({ soundPlaying: true });
                          if (this.animationScene) {
                            this.animationScene.play();
                          }
                        }}
                        pauseAnimation={() => {
                          this._soundPlaying = false;
                          this.setState({ soundPlaying: false });
                          if (this.animationScene) {
                            this.animationScene.pause();
                          }
                          this.pauseSceneAudioPool();
                        }}
                        setCurrentTime={(time, opts) => this.onSecondTimelineTime(time, opts)}
                        onTextAnimationUpdate={(layerId, animationProps) => {
                          const box = boxes[layerId];
                          if (box && box.textAnimation) {
                            dispatch(
                              updateTextAnimation(
                                layerId,
                                box.textAnimation.animation,
                                box.textAnimation.duration || 2,
                                animationProps.delay || 0
                              )
                            );
                          }
                        }}
                        onBoxAnimationUpdate={(layerId, animationProps) => {
                          const box = boxes[layerId];
                          if (box && box.boxAnimation) {
                            dispatch(
                              updateBoxAnimation(
                                layerId,
                                box.boxAnimation.animation,
                                box.boxAnimation.duration || 2,
                                animationProps.delay || 0
                              )
                            );
                          }
                        }}
                        onTextAnimationApplied={(id, animation, duration, delay) => {
                          dispatch(deleteTextAnimation(id));
                          dispatch(updateBoxAnimation(id, { name: animation }, duration, delay));
                        }}
                        onTextAnimationDeleted={(id) => {
                          dispatch(deleteTextAnimation(id));
                          dispatch(deleteBoxAnimation(id));
                        }}
                        onBoxAnimationApplied={(id, animation, duration, delay) =>
                          dispatch(updateBoxAnimation(id, animation, duration, delay))
                        }
                        onBoxAnimationDeleted={(id) => {
                          dispatch(deleteBoxAnimation(id));
                        }}
                        onKeyframeDelete={(layerId, keyframeId, keyframeData) => {
                          const animationsByLayer =
                            this.props.store.getState().undoGroup.present.animationsById[layerId] ||
                            [];
                          if (animationsByLayer.length > 0 && keyframeData.animation) {
                            const updatedAnimations = animationsByLayer.filter(
                              (anim, index) => index !== keyframeData.animation.index
                            );
                            dispatch(saveAnimation(layerId, updatedAnimations));
                          }
                        }}
                        onAddNewAnimation={(id, positionx, positiony, width, height, duration) =>
                          dispatch(
                            addAnimation(id, {
                              positionx,
                              positiony,
                              width,
                              height,
                              duration,
                            })
                          )
                        }
                        containedViewSelected={containedViewSelected}
                        navItemSelected={navItemSelected}
                        addAnimation={(...args) => dispatch(addAnimation(...args))}
                      />
                    </div>
                    {/* /display:none */}
                  </div>
                )}
              </div>

              {/* ── CapCut-style right panel ── */}
              {(() => {
                const _box = boxSelected && boxes[boxSelected] ? boxes[boxSelected] : null;
                const hasBox = !!_box;
                const hasEntry = !!_box?.boxAnimation?.animation;
                const hasExit = !!_box?.boxExitAnimation?.animation;
                const rightTab = this.state.rightActiveTab;
                const CARD_TOP = RIGHT_RAIL.cardTop;
                const CARD_RIGHT = RIGHT_RAIL.cardRight;
                const STRIP_W = RIGHT_RAIL.stripWidth;
                const _tlH = ideaTimelineVisible ? this.state.ideaTimelineHeight + 36 : 0;
                // Keep tall right-panel cards clear of the floating zoom widget.
                const _zoomReserve = ideaTimelineVisible ? 0 : RIGHT_RAIL.zoomReserve;
                // 100vh clamp: the calc(100% ...) above resolves against #workspace,
                // whose height can end up taller than the actual browser window on
                // short screens (canvas/workspace min-heights forcing page overflow) —
                // in that case the % alone lets the drawer render past the bottom of
                // the window with no scrollbar. min() anchors it to the real viewport:
                // navbar height + CARD_TOP above the drawer (~101px measured) + ~16px
                // bottom margin, rounded up.
                const MAX_PANEL_H = `min(calc(100% - 32px - ${_tlH}px - ${_zoomReserve}px), calc(100vh - 120px))`;
                // Animation drawer card floors — see utils/animationDrawerStack.js.
                const _animStackFloors = animationDrawerStackFloors({
                  panCardOpen: this.state.animPanActive && !this.state.animPanCollapsed,
                  headerHeight: RIGHT_PANEL_HEADER_HEIGHT,
                });
                const _pluginId = hasBox
                  ? (pluginToolbars[boxSelected]?.pluginId || _box.pluginId || "").toLowerCase()
                  : "";
                // InteractivePlugin: lock the right panel down to Scene / Settings
                // tabs + Duplicate / Delete actions only. No Animation tab, no
                // pointer-events / config / fit-screen / etc.
                const _isInteractive = _pluginId === "interactiveplugin";

                // Plugin config for element actions
                const _tb = hasBox ? pluginToolbars[boxSelected] : null;
                const _api =
                  _tb && _tb.pluginId !== "sortable_container"
                    ? IdealStudio.Plugins.get(_tb.pluginId)
                    : null;
                const _cfg = _api ? _api.getConfig() : {};
                const _si = _cfg.searchIcon;
                const _clf = _cfg.createFromLibrary;
                let _hasURL = false,
                  _hasURLnotextprov = false,
                  _accept = "*",
                  _cbKey = "url";
                if (_si) {
                  if (_si === "type") {
                    _hasURLnotextprov = true;
                  } else {
                    _hasURL =
                      _si instanceof Array && _si.length > 1
                        ? _si
                        : _clf instanceof Array && _clf.length > 1
                          ? _clf
                          : ["*", "url"];
                    _accept = _hasURL[0];
                    _cbKey = _hasURL[1];
                  }
                }
                const _rotation = _tb?.structure?.rotation || 0;
                const _animCount = hasBox
                  ? animationsById[boxSelected]
                    ? animationsById[boxSelected].length
                    : 0
                  : 0;
                const _isSortableCont = hasBox && isSortableContainer(_box?.container);

                // Right controls (icon strip + scene sub-panel) share one opacity:
                // dim at rest, full on hover of either or when an element is selected.
                // An explicitly-opened drawer (Settings/Aidea Wizard/Animation/Elements)
                // also stays fully opaque — it's the active focus, so it must not
                // depend on hover.
                const _drawerOpen = rightTab && rightTab !== "scene";
                const rightOpacity =
                  this.state.rightControlsHover || hasBox || _drawerOpen ? 1 : 0.55;
                const onRightEnter = () =>
                  !this.state.rightControlsHover && this.setState({ rightControlsHover: true });
                const onRightLeave = () =>
                  this.state.rightControlsHover && this.setState({ rightControlsHover: false });

                const elementActions = hasBox
                  ? [
                      _cfg.needsTextEdition && {
                        key: "edit-text",
                        Icon: LuPen,
                        label: i18n.t("Edit Text"),
                        onClick: () =>
                          blurCKEditor(_tb.id, (text, content) => {
                            this.onTextEditorToggled(_tb.id, !_tb.showTextEditor, text, content);
                          }),
                      },
                      (_hasURL || _hasURLnotextprov) && {
                        key: "change-file",
                        Icon: LuUpload,
                        label: i18n.t("Replace File"),
                        onClick: () =>
                          isDirectorVideo(_tb?.state)
                            ? this.openDirectorVideoModal(boxSelected)
                            : this.setState({
                                fileModalResult: {
                                  id: boxSelected,
                                  value: undefined,
                                  accept: _accept,
                                },
                                carouselShow: true,
                                carouselFull: false,
                                ...resolveReplaceTarget(
                                  _tb?.state?.componentType,
                                  _tb?.state?.url || "",
                                  _accept
                                ),
                                aiPanel: null,
                              }),
                      },
                      _tb?.pluginId === "EnrichedPlayer" &&
                        canEditInDirector(_tb.state) && {
                          key: "edit-in-director",
                          Icon: LuClapperboard,
                          label: i18n.t(
                            "FileModal.APIProviders.VideoGeneration.Director.EditInDirector"
                          ),
                          onClick: () =>
                            this.openDirectorVideoModal(boxSelected, { importFromBox: true }),
                        },
                      _cfg.needsConfigModal && {
                        key: "plugin-config",
                        Icon: LuSettings2,
                        label: i18n.t("Plugin Settings"),
                        onClick: () => this.setState({ pluginConfigModal: _tb.id }),
                      },
                      _cfg.isRich && {
                        key: "fit-screen",
                        Icon: LuMaximize,
                        label: i18n.t("Fit to Screen"),
                        onClick: () => {
                          dispatch(
                            resizeBox(_tb.id, {
                              width: "100",
                              widthUnit: "%",
                              height: "100",
                              heightUnit: "%",
                            })
                          );
                          dispatch(
                            moveBox(_box.id, "0%", "0%", "absolute", _box.parent, _box.container)
                          );
                        },
                      },
                      _isSortableCont && {
                        key: "adjust-doc",
                        Icon: LuMaximize2,
                        label: i18n.t("Fit to Document"),
                        onClick: () => {
                          if (_tb.structure) {
                            let w = _tb.structure.width,
                              wu = _tb.structure.widthUnit;
                            if (w === "100" && wu === "%") {
                              w = _cfg.needsTextEdition ? "auto" : "20";
                              wu = "%";
                            } else {
                              w = "100";
                              wu = "%";
                            }
                            dispatch(resizeBox(_tb.id, { width: w, widthUnit: wu }));
                          }
                        },
                      },
                      // Görsel/rich görsel pluginlerde bu aksiyon "Araçlar"
                      // (ToolsPanel) içine taşındı; strip'te yalnızca görsel
                      // olmayan pointer pluginleri (Visor3D, VirtualTour vb.) için kalır.
                      _cfg.needsPointerEventsAllowed &&
                        !(
                          _pluginId.includes("image") ||
                          _pluginId.includes("photo") ||
                          _pluginId.includes("hotspot") ||
                          _pluginId === "shapes"
                        ) && {
                          key: "pointer-events",
                          Icon: LuMove,
                          label: i18n.t("PointerEvents"),
                          onClick: () => {
                            const boxEl = document.getElementById("box-" + boxSelected);
                            if (!boxEl) return;
                            boxEl.classList.toggle("pointerEventsEnabled");
                            const enabled = boxEl.classList.contains("pointerEventsEnabled");
                            const pe =
                              _tb?.config?.name &&
                              IdealStudio.Plugins.get(_tb.config.name)?.pointerEventsCallback;
                            if (pe) pe(enabled ? "enableAll" : "disableAll", _tb);
                          },
                        },
                      _tb?.state?.nBoxes && {
                        key: "nbox-add",
                        Icon: LuPlus,
                        label: i18n.t("AddAnswer") || "Cevap Ekle",
                        onClick: () =>
                          this.toolbarUpdated(
                            _box.id,
                            "main",
                            "state",
                            "nBoxes",
                            _tb.state.nBoxes + 1
                          ),
                      },
                      /* Lipsync temporarily hidden
                      _tb?.pluginId === "EnrichedPlayer" && {
                        key: "lipsync",
                        Icon: LuMic,
                        label: "Lipsync",
                        onClick: () =>
                          this.setState({ addAnimationVisible: true, markCursorValue: null }),
                      },
                      */
                      _animCount > 1 && {
                        key: "edit-anim",
                        Icon: LuSparkles,
                        label: i18n.t("AnimationLabel"),
                        onClick: () => {
                          this.setState({
                            addAnimationVisible: !this.state.addAnimationVisible,
                            markCursorValue: null,
                          });
                          dispatch(selectBox(boxSelected, _box));
                        },
                      },
                      _tb?.pluginId === "AtomicBoxPlugin" && {
                        key: "font-increase",
                        Icon: LuAArrowUp,
                        label: i18n.t("Increase Text"),
                        onClick: () => {
                          const cur = _tb.state.fontScale || 1;
                          this.toolbarUpdated(
                            boxSelected,
                            "main",
                            "state",
                            "fontScale",
                            Math.min(parseFloat((cur + 0.15).toFixed(2)), 2.0)
                          );
                        },
                      },
                      _tb?.pluginId === "AtomicBoxPlugin" && {
                        key: "font-decrease",
                        Icon: LuAArrowDown,
                        label: i18n.t("Decrease Text"),
                        onClick: () => {
                          const cur = _tb.state.fontScale || 1;
                          this.toolbarUpdated(
                            boxSelected,
                            "main",
                            "state",
                            "fontScale",
                            Math.max(parseFloat((cur - 0.15).toFixed(2)), 0.4)
                          );
                        },
                      },
                      {
                        key: "copy-style",
                        Icon: LuPaintbrush,
                        label: i18n.t("styleClipboard.copy"),
                        active: !!this.state.styleCopyMode,
                        onClick: () => copyStyle(buildStylePayload(_box, _tb)),
                      },
                      {
                        key: "copy-box",
                        Icon: LuCopy,
                        label: i18n.t("Copy") || "Kopyala",
                        onClick: () => this.clipboardRef.current?.copyButtonListener(),
                      },
                      {
                        key: "duplicate-box",
                        Icon: LuCopyPlus,
                        label: i18n.t("Duplicate") || "Çoğalt",
                        onClick: () => this.clipboardRef.current?.duplicateBox(),
                      },
                      {
                        key: "delete-box",
                        Icon: LuTrash2,
                        label: i18n.t("Delete") || "Sil",
                        danger: true,
                        onClick: () => {
                          if (!_box) return;
                          // When an inline sub-item of an InteractivePlugin box is
                          // selected, the Sil tab must remove ONLY that sub-item —
                          // not the parent box and its sibling items. Mirrors the
                          // guard in the Delete/Backspace keydown handler.
                          const iStudio =
                            this.props.store && this.props.store.getState().interactivityStudio;
                          const selectedItemId = iStudio && iStudio.selectedItemId;
                          if (
                            selectedItemId &&
                            (_isInteractive || _box.pluginId === "InteractivePlugin")
                          ) {
                            dispatch(removeInteractiveItem(_box.id, selectedItemId));
                            return;
                          }
                          this.onBoxDeleted(_box.id, _box.parent, _box.container, navItemSelected);
                        },
                      },
                    ]
                      .filter(Boolean)
                      .filter((a) =>
                        _isInteractive
                          ? a.key === "copy-box" ||
                            a.key === "duplicate-box" ||
                            a.key === "delete-box"
                          : true
                      )
                  : undefined;
                const isImage =
                  hasBox &&
                  (_pluginId.includes("image") ||
                    _pluginId.includes("photo") ||
                    _pluginId.includes("hotspot") ||
                    _pluginId === "shapes");
                // Video (EnrichedPlayer / BasicPlayer) da görsel gibi bir
                // "Araçlar" sekmesi alır: Yapı + Kutu Stili aynı panelde.
                const isVideo =
                  hasBox && (_pluginId.includes("player") || _pluginId.includes("video"));
                const _boxImageUrl = (pluginToolbars[boxSelected]?.state?.url || "").toLowerCase();
                const _merlinUnsupportedExt = MERLIN_UNSUPPORTED_EXT.test(_boxImageUrl);
                const isMerlinEligible = isImage && !_merlinUnsupportedExt;
                // Animated (webp) image: AI Wizard opens the animation popup.
                const isAnimatedImage = isImage && ANIMATED_IMAGE_EXT.test(_boxImageUrl);
                // Video/audio Merlin (recorded-video EnrichedPlayer boxes): show the
                // same Merlin tab/drawer as images, gated to actual video files
                // (gif/webp are not video). v1 exposes Transcribe + coming-soon cards.
                const isMerlinVideo =
                  hasBox &&
                  _pluginId === "enrichedplayer" &&
                  !/\.(gif|webp)(\?.*)?$/.test(_boxImageUrl);
                const hasMerlinJob =
                  (isMerlinEligible || isAnimatedImage) &&
                  !!localStorage.getItem(`image-edit-job-${boxSelected}`);
                const TABS = [
                  { key: "scene", Icon: LuLayers, label: i18n.t("Scene"), badge: false },
                  // "Araçlar" (tools) Sahne'nin hemen altında dursun.
                  // Görsel + video için. Video'da Ayarlar sekmesi de kalır
                  // (url / kontroller / otomatik oynat orada durur).
                  ...((isImage || isVideo) && !_isInteractive
                    ? [{ key: "tools", Icon: LuWrench, label: i18n.t("Tools"), badge: false }]
                    : []),
                  // Görsel + video'da "Ayarlar" (properties) sekmesi gizlendi —
                  // yerini "Araçlar" (tools) alıyor (URL / kontroller / otomatik
                  // oynat oraya taşındı). Diğer plugin türlerinde Ayarlar durur.
                  ...(!((isImage || isVideo) && !_isInteractive)
                    ? [
                        {
                          key: "properties",
                          Icon: MdTune,
                          label: i18n.t("Settings"),
                          badge: false,
                        },
                      ]
                    : []),
                  ...(_isInteractive
                    ? [
                        {
                          key: "elements",
                          Icon: LuLayoutList,
                          label: i18n.t("Elements") || "Elementler",
                          badge: false,
                        },
                      ]
                    : []),
                  ...(hasBox && !_isInteractive
                    ? [
                        {
                          key: "animation",
                          Icon: MdAnimation,
                          label: i18n.t("Effect"),
                          badge: hasEntry || hasExit,
                        },
                      ]
                    : []),
                  ...((isMerlinEligible || isAnimatedImage || isMerlinVideo) && !_isInteractive
                    ? [
                        {
                          key: "merlin",
                          Icon: LuSparkles,
                          label: "AI Wizard",
                          badge: hasMerlinJob,
                        },
                      ]
                    : []),
                ];
                // Scene panel helpers
                const _scPage = (containedViewSelected && containedViewSelected !== 0
                  ? containedViews[containedViewSelected]
                  : navItems[navItemSelected]) || { boxes: [] };
                const _scBoxes = _scPage.boxes || [];
                const _scLayer = _scBoxes.indexOf(boxSelected);
                const _scDisable = !boxSelected || boxSelected === -1 || _scBoxes.length <= 1;
                const _scNoBox = !boxSelected || boxSelected === -1;
                const _selectedBoxHasGroupId = hasBox && !!_box?.groupId;
                const _scBtn = (dis, onClick, children, title) => (
                  <SceneIconButton key={title} label={title} onClick={onClick} disabled={dis}>
                    {children}
                  </SceneIconButton>
                );
                const _scGroup = {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 2,
                };
                const _scSep = {
                  width: "100%",
                  height: 1,
                  background: "#f1f5f9",
                  margin: "2px 0",
                  flexShrink: 0,
                };

                // Exact same SVGs as ActionsRibbon
                const _svgBringToFront = (
                  <svg width="22" height="22" viewBox="0 0 25 20" fill="none">
                    <path
                      d="M24.4718 11.5921L21.6976 9.99886L24.2069 8.55661C24.5866 8.33919 24.8211 7.93424 24.8211 7.50272C24.8211 7.07121 24.5849 6.66625 24.2069 6.44884L13.3969 0.23837C12.8434 -0.0786262 12.1566 -0.0802859 11.6031 0.23837L0.791428 6.4505C0.411745 6.66791 0.177185 7.07287 0.177185 7.50438C0.177185 7.9359 0.413432 8.34085 0.791428 8.55827L3.30071 10.0005L0.528181 11.5938C0.202498 11.7797 0 12.1249 0 12.4967C0 12.8684 0.202497 13.212 0.526493 13.3979L11.5964 19.7593C11.8697 19.917 12.1819 20 12.4992 20C12.8164 20 13.1286 19.917 13.402 19.7593L24.4718 13.3995C24.7975 13.2136 25 12.8684 25 12.4983C25 12.1282 24.7975 11.783 24.4735 11.5971L24.4718 11.5921ZM2.96659 7.50272L12.4992 2.02583L22.0317 7.50272L12.4992 12.9796L2.96659 7.50272Z"
                      fill="#475569"
                    />
                  </svg>
                );
                const _svgAhead = (
                  <svg width="22" height="22" viewBox="0 0 23 20" fill="none">
                    <path
                      d="M22.4489 11.7714L19.4527 10.0008L22.4489 8.23024C22.7937 8.02643 23 7.6634 23 7.26057C23 6.85773 22.7937 6.49471 22.4489 6.2909L12.0605 0.152854C11.8905 0.0525436 11.6968 0 11.5 0C11.4465 0 11.3898 0.00477669 11.3268 0.0143301C11.267 0.0238834 11.2056 0.0398057 11.1442 0.0605047C11.0686 0.0859804 11.0009 0.116233 10.9395 0.152854L0.551068 6.28931C0.355832 6.40395 0.203109 6.57432 0.107066 6.77972C-0.0346373 7.08383 -0.0346373 7.43412 0.107066 7.73824C0.203109 7.94363 0.355832 8.114 0.551068 8.22864L3.5473 9.9992L0.551068 11.7698C0.206257 11.9736 0 12.3366 0 12.7394C0 13.1423 0.206257 13.5053 0.551068 13.7091L10.9395 19.8471C11.1095 19.9475 11.3032 20 11.5 20C11.6968 20 11.8905 19.9475 12.0605 19.8471L22.4489 13.7107C22.7937 13.5069 23 13.1439 23 12.741C23 12.3382 22.7937 11.9752 22.4489 11.7714ZM20.2714 12.741L11.5 17.9221L2.72857 12.741L5.44927 11.1345L10.2814 14.0037C10.3695 14.0562 10.4624 14.1024 10.5585 14.1438L10.8403 14.311C10.9505 14.3762 11.0717 14.424 11.2024 14.4559C11.4732 14.5195 11.7488 14.4973 12.0023 14.3906C12.0558 14.3683 12.1077 14.3412 12.1597 14.311L12.4384 14.1454C12.536 14.104 12.6289 14.0562 12.7171 14.0053L17.5586 11.1392L20.2714 12.741Z"
                      fill="#475569"
                    />
                  </svg>
                );
                const _svgBehind = (
                  <svg width="22" height="22" viewBox="0 0 21 20" fill="none">
                    <path
                      d="M21 10.3531C21 9.97137 20.7987 9.6131 20.4766 9.42075L18.9252 8.4957L20.4766 7.57066C20.8001 7.37831 21 7.02004 21 6.63828C21 6.25652 20.7987 5.89825 20.4766 5.7059L11.2642 0.211438C10.7926 -0.0704794 10.2074 -0.0704794 9.73577 0.211438L0.523382 5.7059C0.199863 5.89825 0 6.25652 0 6.63828C0 7.02004 0.201301 7.37831 0.523382 7.57066L2.07484 8.4957L0.523382 9.42075C0.199863 9.6131 0 9.97137 0 10.3531C0 10.7349 0.201301 11.0932 0.523382 11.2855L1.55864 11.9037L0.543512 12.5336C0.232934 12.7186 0.0402602 13.0622 0.0402602 13.4293C0.0402602 13.7963 0.232934 14.1399 0.543512 14.3249L9.67395 19.7724C9.92414 19.9207 10.2088 20 10.4993 20C10.7897 20 11.0744 19.9207 11.3246 19.7724L20.455 14.3249C20.7656 14.1399 20.9583 13.7963 20.9583 13.4293C20.9583 13.0622 20.7656 12.7186 20.455 12.5336L19.4198 11.9154L20.4752 11.2855C20.7987 11.0932 20.9986 10.7349 20.9986 10.3531H21ZM10.4993 11.4837L2.37679 6.63828L10.4993 1.79282L18.6218 6.63828L10.4993 11.4837ZM3.78302 9.51472L9.65382 13.0167C10.1657 13.3221 10.8329 13.3221 11.3462 13.0167L17.217 9.51472L18.6232 10.3531L10.5007 15.1986L2.37823 10.3531L3.78446 9.51472H3.78302Z"
                      fill="#475569"
                    />
                  </svg>
                );
                const _svgSendToBack = (
                  <svg width="22" height="22" viewBox="0 0 21 20" fill="none">
                    <path
                      d="M20.9986 9.96749C20.9986 9.6 20.7972 9.25513 20.4751 9.06997L18.9236 8.17951L20.4751 7.28905C20.7987 7.10389 20.9986 6.75901 20.9986 6.39152C20.9986 6.02403 20.7972 5.67915 20.4751 5.49399L11.2636 0.203534C10.7919 -0.0678445 10.2067 -0.0678445 9.735 0.203534L0.52342 5.49399C0.199879 5.67915 0 6.02403 0 6.39152C0 6.75901 0.201317 7.10389 0.52342 7.28905L2.07498 8.17951L0.52342 9.06997C0.199879 9.25513 0 9.6 0 9.96749C0 10.335 0.201317 10.6799 0.52342 10.865L2.15263 11.8007L0.52342 12.7364C0.199879 12.9216 0 13.2664 0 13.6339C0 14.0014 0.201317 14.3463 0.52342 14.5315L9.65448 19.7753C9.91044 19.9223 10.2023 20 10.5 20C10.7977 20 11.0896 19.9223 11.3455 19.7753L20.4766 14.5315C20.8001 14.3463 21 14.0014 21 13.6339C21 13.2664 20.7987 12.9216 20.4766 12.7364L18.8474 11.8007L20.4766 10.865C20.8001 10.6799 21 10.335 21 9.96749H20.9986ZM3.85805 12.7816L9.6516 16.1088C10.1635 16.4028 10.8307 16.4028 11.3426 16.1088L17.1362 12.7816L18.6202 13.6339L10.4971 18.2982L2.37408 13.6339L3.85805 12.7816ZM10.4971 14.6318L2.37408 9.96749L3.77897 9.16043L9.65016 12.5314C9.90612 12.6784 10.198 12.7562 10.4957 12.7562C10.7933 12.7562 11.0852 12.6784 11.3412 12.5314L17.2124 9.16043L18.6187 9.96749L10.4957 14.6318H10.4971Z"
                      fill="#475569"
                    />
                  </svg>
                );

                const _closePanel = () =>
                  this.setState({ rightActiveTab: null, animPanCollapsed: false });
                const _activeTab = TABS.find((t) => t.key === rightTab);

                return (
                  <>
                    {/* Scene actions panel */}
                    {rightTab === "scene" && (
                      <div
                        onMouseEnter={onRightEnter}
                        onMouseLeave={onRightLeave}
                        style={{
                          position: "absolute",
                          right: CARD_RIGHT + STRIP_W + 16,
                          top: CARD_TOP,
                          zIndex: 102,
                          background: "white",
                          borderRadius: 14,
                          boxShadow: "0 4px 24px rgba(0,0,0,0.14)",
                          opacity: rightOpacity,
                          transition: "opacity 0.18s ease",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 4,
                          padding: 6,
                          overflow: "hidden",
                        }}
                      >
                        {/* Katman sırası */}
                        <div style={_scGroup}>
                          {_scBtn(
                            _scDisable || _scLayer === _scBoxes.length - 1,
                            () =>
                              dispatch(
                                changeBoxLayer(boxSelected, _scPage.id, 0, "front", _scBoxes)
                              ),
                            _svgBringToFront,
                            "Öne Getir"
                          )}
                          {_scBtn(
                            _scDisable || _scLayer === _scBoxes.length - 1,
                            () =>
                              dispatch(
                                changeBoxLayer(boxSelected, _scPage.id, 0, "ahead", _scBoxes)
                              ),
                            _svgAhead,
                            "İleri"
                          )}
                          {_scBtn(
                            _scDisable || _scLayer === 0,
                            () =>
                              dispatch(
                                changeBoxLayer(boxSelected, _scPage.id, 0, "behind", _scBoxes)
                              ),
                            _svgBehind,
                            "Geri"
                          )}
                          {_scBtn(
                            _scDisable || _scLayer === 0,
                            () =>
                              dispatch(
                                changeBoxLayer(boxSelected, _scPage.id, 0, "back", _scBoxes)
                              ),
                            _svgSendToBack,
                            "Arkaya Gönder"
                          )}
                        </div>

                        <LayersPanel sceneId={_scPage.id} container={0} boxes={_scBoxes} />

                        <div style={_scSep} />

                        {/* Gruptan Çıkar */}
                        <div style={_scGroup}>
                          {_scBtn(
                            _scNoBox || !_selectedBoxHasGroupId,
                            () => this.props.dispatch(ungroupAideaSmartElement(boxSelected)),
                            <LuUngroup size={20} />,
                            i18n.t("aideaSmartElementsUngroup")
                          )}
                        </div>
                        <div style={_scSep} />
                        <div style={_scGroup}>
                          {_scBtn(
                            !_scNoBox,
                            () => this.clipboardRef.current?.copyScene(),
                            <LuCopy size={20} />,
                            i18n.t("scenePaste.copyScene", "Copy scene")
                          )}
                        </div>
                      </div>
                    )}

                    {/* Tools panel — crop / border / remove-bg / chroma key.
                          Same visual language as the Scene panel: a compact
                          floating card with icon-only buttons stacked vertically. */}
                    {rightTab === "tools" && (isImage || isVideo) && (
                      <div
                        id="toolsPanelDrawer"
                        onMouseEnter={onRightEnter}
                        onMouseLeave={onRightLeave}
                        style={{
                          position: "absolute",
                          right: CARD_RIGHT + STRIP_W + 16,
                          top: CARD_TOP,
                          maxHeight: MAX_PANEL_H,
                          zIndex: 102,
                          background: "white",
                          borderRadius: 14,
                          boxShadow: "0 4px 24px rgba(0,0,0,0.14)",
                          opacity: rightOpacity,
                          transition: "opacity 0.18s ease",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 4,
                          padding: 6,
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}
                      >
                        <ToolsPanel
                          variant={isVideo && !isImage ? "video" : "image"}
                          boxId={boxSelected}
                          box={boxes[boxSelected]}
                          imageUrl={pluginToolbars[boxSelected]?.state?.url || ""}
                          styleState={pluginToolbars[boxSelected]?.style}
                          structureState={pluginToolbars[boxSelected]?.structure}
                          navId={navItemSelected}
                          dispatch={dispatch}
                          onApplyImageUrl={(url) =>
                            this.toolbarUpdated(boxSelected, "main", "state", "url", url)
                          }
                          onCropToNewBox={this.handleCropToNewBox}
                          onInsufficientBalance={notifyInsufficientBalance}
                          // İşaretçi Olayları — strip aksiyonundan Araçlar'a taşındı.
                          // Sadece pointer-events destekleyen pluginlerde gösterilir.
                          showPointerEvents={!!_cfg.needsPointerEventsAllowed}
                          pointerEventsEnabled={
                            !!document
                              .getElementById("box-" + boxSelected)
                              ?.classList.contains("pointerEventsEnabled")
                          }
                          onTogglePointerEvents={() => {
                            const boxEl = document.getElementById("box-" + boxSelected);
                            if (!boxEl) return false;
                            boxEl.classList.toggle("pointerEventsEnabled");
                            const enabled = boxEl.classList.contains("pointerEventsEnabled");
                            const pe =
                              _tb?.config?.name &&
                              IdealStudio.Plugins.get(_tb.config.name)?.pointerEventsCallback;
                            if (pe) pe(enabled ? "enableAll" : "disableAll", _tb);
                            return enabled;
                          }}
                          // İşaretçi Listesi — Ayarlar panelinden Araçlar'a taşındı.
                          // Sadece rich pluginlerde (ör. HotspotImages) gösterilir.
                          showMarks={!!_cfg.isRich}
                          marksState={this.props.marks}
                          viewToolbars={this.props.viewToolbars}
                          onRichMarksModalToggled={() => {
                            this.setState({ richMarksVisible: !this.state.richMarksVisible });
                            if (this.state.richMarksVisible) {
                              this.setState({ currentRichMark: null });
                            }
                          }}
                          onRichMarkEditPressed={(mark) => this.setState({ currentRichMark: mark })}
                          onRichMarkDeleted={(id) => {
                            const _marks = this.props.marks;
                            const cvid = _marks[id].connection;
                            if (isContainedView(cvid)) {
                              const thiscv = this.props.containedViews[cvid];
                              if (thiscv && Object.keys(thiscv.parent).length === 1) {
                                const confirmText =
                                  i18n.t("messages.confirm_delete_CV_also_1") +
                                  this.props.viewToolbars[cvid].viewName +
                                  i18n.t("messages.confirm_delete_CV_also_2");
                                this.setState({
                                  richMarkDeleteInfo: {
                                    markId: id,
                                    cvid,
                                    confirmText,
                                    mark: _marks[id],
                                  },
                                  deleteAlsoCv: false,
                                });
                                return;
                              }
                            }
                            dispatch(deleteRichMark(_marks[id]));
                          }}
                        />
                      </div>
                    )}

                    {/* Properties panel — floating card, scrollable, left of icon card */}
                    {rightTab === "properties" && (
                      <div
                        id="rightPanel"
                        onMouseEnter={onRightEnter}
                        onMouseLeave={onRightLeave}
                        style={{
                          backgroundColor: "white",
                          position: "absolute",
                          right: CARD_RIGHT + STRIP_W + 16,
                          top: CARD_TOP,
                          width: `${RIGHT_RAIL.panelWidth}px`,
                          display: "flex",
                          flexDirection: "column",
                          maxHeight: MAX_PANEL_H,
                          zIndex: 100,
                          borderRadius: 14,
                          boxShadow: "0 4px 24px rgba(0,0,0,0.14)",
                          overflow: "hidden",
                          opacity: rightOpacity,
                          transition: "opacity 0.18s ease",
                        }}
                      >
                        <RightPanelShell
                          title={_activeTab?.label || i18n.t("Settings")}
                          Icon={_activeTab?.Icon}
                          onClose={_closePanel}
                          style={{ flex: 1, minHeight: 0 }}
                        >
                          <div
                            className="dndWindow"
                            style={{
                              overflowY: "auto",
                              overflowX: "hidden",
                              flex: 1,
                              minHeight: 0,
                            }}
                          >
                            <Toolbar
                              {...this.getToolbarProps({
                                dispatch,
                                boxes,
                                boxSelected,
                                containedViews,
                                containedViewSelected,
                                navItemSelected,
                                navItems,
                                globalConfig,
                                ribbonHeight,
                                pluginToolbars,
                                viewToolbars,
                                carouselShow: this.state.carouselShow,
                                isBusy,
                                marks,
                                exercises,
                                animationsById,
                                soundList,
                                uploadFunction,
                                currentViewOrContained,
                              })}
                              activeAccordionKey={this.state.activeAccordionKey}
                            />
                          </div>
                        </RightPanelShell>
                      </div>
                    )}

                    {/* Elementler tab paneli — scene list + element list + property editor */}
                    {rightTab === "elements" &&
                      _isInteractive &&
                      (() => {
                        const _iStudio =
                          this.props.store && this.props.store.getState().interactivityStudio;
                        const _interactiveMode = (_iStudio && _iStudio.mode) || "design";
                        const _selectedSceneId = (_iStudio && _iStudio.selectedSceneId) || null;
                        const _selectedElementId = (_iStudio && _iStudio.selectedElementId) || null;
                        const _scenario = pluginToolbars[boxSelected]?.state?.scenario || null;
                        const _scenes = (_scenario && _scenario.scenes) || [];
                        const _startSceneId = _scenario && _scenario.startSceneId;
                        const _selectedScene =
                          _scenes.find((s) => s.id === _selectedSceneId) || null;
                        const _elements = (_selectedScene && _selectedScene.elements) || [];
                        const _selectedElement =
                          _elements.find((e) => e.id === _selectedElementId) || null;
                        const _variables = (_scenario && _scenario.variables) || [];

                        const TYPE_ICONS_PANEL = {
                          visualtext: "article",
                          visualimage: "image",
                          videocard: "videocam",
                          flipcard: "flip",
                          truefalse: "rule",
                          mcq: "quiz",
                        };
                        const TYPE_LABELS_PANEL = {
                          visualtext: i18n.t("ElementType.TextCard") || "Metin Kartı",
                          visualimage: i18n.t("ElementType.ImageCard") || "Görsel Kart",
                          videocard: i18n.t("ElementType.VideoCard") || "Video Kart",
                          flipcard: i18n.t("ElementType.FlipCard") || "Çift Yüzlü Kart",
                          truefalse: i18n.t("ElementType.TrueFalse") || "Doğru / Yanlış",
                          mcq: i18n.t("ElementType.MCQ") || "Çoktan Seçmeli",
                        };
                        const PANEL_ADDABLE_TYPES = ["flipcard", "truefalse", "mcq"];

                        return (
                          <div
                            id="interactiveElementsPanel"
                            style={{
                              backgroundColor: "white",
                              position: "absolute",
                              right: CARD_RIGHT + STRIP_W + 8,
                              top: CARD_TOP,
                              maxHeight: MAX_PANEL_H,
                              width: "300px",
                              display: "flex",
                              flexDirection: "column",
                              zIndex: 100,
                              borderRadius: 14,
                              boxShadow: "0 4px 24px rgba(0,0,0,0.14)",
                              overflow: "hidden",
                            }}
                          >
                            <RightPanelShell
                              title="Senaryo"
                              Icon={LuLayoutList}
                              onClose={_closePanel}
                              style={{
                                flex: 1,
                                minHeight: 0,
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              {/* Mode toggle */}
                              <div
                                style={{
                                  display: "flex",
                                  gap: 6,
                                  padding: "10px 12px 8px",
                                  flexShrink: 0,
                                }}
                              >
                                {[
                                  {
                                    key: "design",
                                    label: i18n.t("Design") || "Tasarım",
                                    icon: "edit",
                                  },
                                  {
                                    key: "simulate",
                                    label: i18n.t("Simulator") || "Simülatör",
                                    icon: "play_arrow",
                                  },
                                ].map(({ key, label, icon }) => (
                                  <button
                                    key={key}
                                    type="button"
                                    onClick={() => {
                                      dispatch(setInteractiveMode(key));
                                      if (key === "design" && _scenario?.startSceneId) {
                                        dispatch(selectScene(boxSelected, _scenario.startSceneId));
                                      }
                                    }}
                                    style={{
                                      flex: 1,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: 4,
                                      padding: "5px 8px",
                                      borderRadius: 8,
                                      border: "1.5px solid",
                                      borderColor: _interactiveMode === key ? "#a963f5" : "#e2e8f0",
                                      background: _interactiveMode === key ? "#f3e7ff" : "white",
                                      color: _interactiveMode === key ? "#7f56d9" : "#64748b",
                                      fontSize: 11,
                                      fontWeight: _interactiveMode === key ? 700 : 500,
                                      cursor: "pointer",
                                      transition: "all 0.15s",
                                    }}
                                  >
                                    <span className="material-icons" style={{ fontSize: 13 }}>
                                      {icon}
                                    </span>
                                    {label}
                                  </button>
                                ))}
                              </div>

                              {/* Scrollable content area */}
                              <div
                                style={{
                                  flex: 1,
                                  overflowY: "auto",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                {/* ── Senaryo yok empty state ── */}
                                {!_scenario && (
                                  <div
                                    style={{
                                      padding: "24px 16px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      textAlign: "center",
                                      gap: 4,
                                    }}
                                  >
                                    <span
                                      className="material-icons"
                                      style={{ fontSize: 36, color: "#a963f5" }}
                                    >
                                      auto_stories
                                    </span>
                                    <p
                                      style={{
                                        margin: "6px 0 2px",
                                        fontWeight: 600,
                                        fontSize: 13,
                                        color: "#1e293b",
                                      }}
                                    >
                                      {i18n.t("InteractiveScenario.Empty.Title") ||
                                        "Senaryo bulunamadı"}
                                    </p>
                                    <p
                                      style={{
                                        margin: "0 0 12px",
                                        fontSize: 11,
                                        color: "#94a3b8",
                                      }}
                                    >
                                      {i18n.t("InteractiveScenario.Empty.Description") ||
                                        "Bu element için yeni bir senaryo oluştur"}
                                    </p>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        const sc = emptyScenario();
                                        dispatch(
                                          updatePluginToolbar(
                                            boxSelected,
                                            "main",
                                            "state",
                                            "scenario",
                                            sc,
                                            [],
                                            navItemSelected
                                          )
                                        );
                                        dispatch(setInteractiveMode("design"));
                                        dispatch(selectScene(boxSelected, sc.startSceneId));
                                      }}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 4,
                                        padding: "6px 14px",
                                        borderRadius: 8,
                                        border: "1.5px solid #a963f5",
                                        background: "#f3e7ff",
                                        color: "#7f56d9",
                                        fontSize: 12,
                                        fontWeight: 700,
                                        cursor: "pointer",
                                      }}
                                    >
                                      <span className="material-icons" style={{ fontSize: 14 }}>
                                        add
                                      </span>
                                      {i18n.t("InteractiveScenario.Empty.Create") ||
                                        "Senaryo Oluştur"}
                                    </button>
                                  </div>
                                )}

                                {/* ── SAHNELER section ── */}
                                <div style={{ padding: "0 12px 0" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "6px 2px",
                                      gap: 6,
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: 10,
                                        fontWeight: 700,
                                        color: "#94a3b8",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.06em",
                                        flex: 1,
                                      }}
                                    >
                                      Sahneler ({_scenes.length})
                                    </span>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        const scene = defaultForScene({
                                          title: `Sahne ${_scenes.length + 1}`,
                                        });
                                        dispatch(addScene(boxSelected, scene));
                                        dispatch(selectScene(boxSelected, scene.id));
                                      }}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                        padding: "2px 7px",
                                        borderRadius: 5,
                                        border: "1px solid #a963f5",
                                        background: "#f3e7ff",
                                        color: "#7f56d9",
                                        fontSize: 10,
                                        fontWeight: 700,
                                        cursor: "pointer",
                                      }}
                                    >
                                      <span className="material-icons" style={{ fontSize: 12 }}>
                                        add
                                      </span>
                                      Sahne
                                    </button>
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 3,
                                      paddingBottom: 8,
                                    }}
                                  >
                                    {_scenes.map((scene) => {
                                      const isSel = scene.id === _selectedSceneId;
                                      const isStart = scene.id === _startSceneId;
                                      const elCount = (scene.elements || []).length;
                                      return (
                                        <div key={scene.id}>
                                          <div
                                            onClick={() => {
                                              dispatch(selectScene(boxSelected, scene.id));
                                              dispatch(
                                                selectScenarioElement(boxSelected, scene.id, null)
                                              );
                                            }}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 7,
                                              padding: "6px 8px",
                                              borderRadius: 7,
                                              cursor: "pointer",
                                              border: `1.5px solid ${isSel ? "#a963f5" : "#f0f0f5"}`,
                                              background: isSel ? "#f9f2ff" : "#fafafa",
                                              transition: "all 0.12s",
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: 9,
                                                height: 9,
                                                borderRadius: "50%",
                                                flexShrink: 0,
                                                background: scene.bgColor || "#1a1a2e",
                                                border: "1px solid rgba(0,0,0,0.2)",
                                              }}
                                            />
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                              <div
                                                style={{
                                                  fontSize: 11,
                                                  fontWeight: isSel ? 700 : 500,
                                                  color: "#1e293b",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                {isStart && (
                                                  <span
                                                    style={{ color: "#16a34a", marginRight: 3 }}
                                                  >
                                                    ▶
                                                  </span>
                                                )}
                                                {scene.title || "Sahne"}
                                              </div>
                                              <div style={{ fontSize: 10, color: "#94a3b8" }}>
                                                {elCount} element
                                              </div>
                                            </div>
                                            {isSel && !isStart && (
                                              <button
                                                type="button"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  dispatch(removeScene(boxSelected, scene.id));
                                                  dispatch(selectScene(boxSelected, null));
                                                }}
                                                style={{
                                                  width: 20,
                                                  height: 20,
                                                  borderRadius: 4,
                                                  border: "none",
                                                  background: "rgba(239,68,68,0.1)",
                                                  color: "#ef4444",
                                                  fontSize: 10,
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  flexShrink: 0,
                                                }}
                                              >
                                                <span
                                                  className="material-icons"
                                                  style={{ fontSize: 13 }}
                                                >
                                                  delete
                                                </span>
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>

                                {/* ── ARKA PLAN section (only when a scene is selected) ── */}
                                {_selectedScene && (
                                  <>
                                    <div
                                      style={{
                                        height: 1,
                                        background: "#f0f0f5",
                                        margin: "0 12px",
                                      }}
                                    />
                                    <div style={{ padding: "8px 12px 10px" }}>
                                      <div
                                        style={{
                                          fontSize: 10,
                                          fontWeight: 700,
                                          color: "#94a3b8",
                                          textTransform: "uppercase",
                                          letterSpacing: "0.06em",
                                          marginBottom: 8,
                                        }}
                                      >
                                        Arka Plan
                                      </div>

                                      {/* Quick presets */}
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: 5,
                                          flexWrap: "wrap",
                                          marginBottom: 8,
                                        }}
                                      >
                                        {[
                                          {
                                            label: i18n.t("bgPreset.transparent") || "Şeffaf",
                                            value: "transparent",
                                            icon: "blur_off",
                                          },
                                          {
                                            label: i18n.t("bgPreset.dark") || "Koyu",
                                            value: "#1a1a2e",
                                            icon: null,
                                          },
                                          {
                                            label: i18n.t("bgPreset.navy") || "Lacivert",
                                            value: "#0f172a",
                                            icon: null,
                                          },
                                          {
                                            label: i18n.t("bgPreset.white") || "Beyaz",
                                            value: "#ffffff",
                                            icon: null,
                                          },
                                          {
                                            label: i18n.t("bgPreset.gray") || "Gri",
                                            value: "#f1f5f9",
                                            icon: null,
                                          },
                                        ].map((preset) => {
                                          const isActive =
                                            (_selectedScene.bgColor || "#1a1a2e") === preset.value;
                                          return (
                                            <button
                                              key={preset.value}
                                              type="button"
                                              title={preset.label}
                                              onClick={() =>
                                                dispatch(
                                                  updateScene(boxSelected, _selectedSceneId, {
                                                    bgColor: preset.value,
                                                  })
                                                )
                                              }
                                              style={{
                                                width: 26,
                                                height: 26,
                                                borderRadius: 6,
                                                border: isActive
                                                  ? "2px solid #a963f5"
                                                  : "1.5px solid #e2e8f0",
                                                background:
                                                  preset.value === "transparent"
                                                    ? "repeating-conic-gradient(#e2e8f0 0% 25%, #fff 0% 50%) 0 0 / 8px 8px"
                                                    : preset.value,
                                                cursor: "pointer",
                                                flexShrink: 0,
                                                boxShadow: isActive
                                                  ? "0 0 0 2px rgba(169,99,245,0.25)"
                                                  : "none",
                                              }}
                                            />
                                          );
                                        })}

                                        {/* Custom color input */}
                                        <div
                                          style={{ position: "relative", width: 26, height: 26 }}
                                        >
                                          <input
                                            type="color"
                                            value={
                                              _selectedScene.bgColor &&
                                              _selectedScene.bgColor !== "transparent"
                                                ? _selectedScene.bgColor
                                                : "#1a1a2e"
                                            }
                                            onChange={(e) =>
                                              dispatch(
                                                updateScene(boxSelected, _selectedSceneId, {
                                                  bgColor: e.target.value,
                                                })
                                              )
                                            }
                                            title={i18n.t("PickCustomColor") || "Özel renk seç"}
                                            style={{
                                              width: 26,
                                              height: 26,
                                              padding: 0,
                                              border: "1.5px solid #e2e8f0",
                                              borderRadius: 6,
                                              cursor: "pointer",
                                              background: "none",
                                            }}
                                          />
                                        </div>
                                      </div>

                                      {/* Text color */}
                                      <div
                                        style={{ display: "flex", alignItems: "center", gap: 8 }}
                                      >
                                        <span style={{ fontSize: 11, color: "#64748b", flex: 1 }}>
                                          Metin rengi
                                        </span>
                                        <div style={{ position: "relative" }}>
                                          <input
                                            type="color"
                                            value={_selectedScene.textColor || "#ffffff"}
                                            onChange={(e) =>
                                              dispatch(
                                                updateScene(boxSelected, _selectedSceneId, {
                                                  textColor: e.target.value,
                                                })
                                              )
                                            }
                                            title="Metin rengi"
                                            style={{
                                              width: 26,
                                              height: 26,
                                              padding: 0,
                                              border: "1.5px solid #e2e8f0",
                                              borderRadius: 6,
                                              cursor: "pointer",
                                              background: "none",
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}

                                {/* ── ELEMENTLER section (only when a scene is selected) ── */}
                                {_selectedScene && (
                                  <>
                                    <div
                                      style={{
                                        height: 1,
                                        background: "#f0f0f5",
                                        margin: "0 12px",
                                      }}
                                    />
                                    <div style={{ padding: "8px 12px 0" }}>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 6,
                                          marginBottom: 6,
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: 10,
                                            fontWeight: 700,
                                            color: "#94a3b8",
                                            textTransform: "uppercase",
                                            letterSpacing: "0.06em",
                                            flex: 1,
                                          }}
                                        >
                                          Elementler ({_elements.length})
                                        </span>
                                      </div>

                                      {/* Element type picker */}
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: 4,
                                          flexWrap: "wrap",
                                          marginBottom: 8,
                                        }}
                                      >
                                        {PANEL_ADDABLE_TYPES.map((type) => (
                                          <button
                                            key={type}
                                            type="button"
                                            title={`${TYPE_LABELS_PANEL[type]} ekle`}
                                            onClick={() => {
                                              const idx = _elements.length;
                                              const col = idx % 3;
                                              const row = Math.floor(idx / 3);
                                              const el = defaultForElement(type, {
                                                x: 5 + col * 30,
                                                y: 5 + row * 20,
                                              });
                                              dispatch(
                                                addScenarioElement(
                                                  boxSelected,
                                                  _selectedSceneId,
                                                  el
                                                )
                                              );
                                              dispatch(
                                                selectScenarioElement(
                                                  boxSelected,
                                                  _selectedSceneId,
                                                  el.id
                                                )
                                              );
                                            }}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 4,
                                              padding: "4px 9px",
                                              borderRadius: 6,
                                              border: "1.5px solid #e8eaf0",
                                              background: "#f8f9ff",
                                              color: "#4b5563",
                                              fontSize: 11,
                                              fontWeight: 600,
                                              cursor: "pointer",
                                              transition: "all 0.12s",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.borderColor = "#a963f5";
                                              e.currentTarget.style.background = "#f3e7ff";
                                              e.currentTarget.style.color = "#7f56d9";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.borderColor = "#e8eaf0";
                                              e.currentTarget.style.background = "#f8f9ff";
                                              e.currentTarget.style.color = "#4b5563";
                                            }}
                                          >
                                            <span
                                              className="material-icons"
                                              style={{ fontSize: 13, color: "#a963f5" }}
                                            >
                                              {TYPE_ICONS_PANEL[type]}
                                            </span>
                                            {TYPE_LABELS_PANEL[type]}
                                          </button>
                                        ))}
                                      </div>

                                      {/* Element list */}
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: 3,
                                          paddingBottom: 8,
                                        }}
                                      >
                                        {_elements.length === 0 && (
                                          <p
                                            style={{
                                              margin: "4px 0 8px",
                                              fontSize: 11,
                                              color: "#94a3b8",
                                              fontStyle: "italic",
                                            }}
                                          >
                                            {i18n.t(
                                              "InteractiveScenario.Empty.AddElementFromTopHint"
                                            ) || "Yukarıdan element ekle, kanvasta konumlandır."}
                                          </p>
                                        )}
                                        {_elements.map((el) => {
                                          const isElSel = el.id === _selectedElementId;
                                          return (
                                            <div
                                              key={el.id}
                                              onClick={() =>
                                                dispatch(
                                                  selectScenarioElement(
                                                    boxSelected,
                                                    _selectedSceneId,
                                                    isElSel ? null : el.id
                                                  )
                                                )
                                              }
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 7,
                                                padding: "6px 8px",
                                                borderRadius: 7,
                                                cursor: "pointer",
                                                border: `1.5px solid ${isElSel ? "#a963f5" : "#f0f0f5"}`,
                                                background: isElSel ? "#f9f2ff" : "#fafafa",
                                                transition: "all 0.12s",
                                              }}
                                            >
                                              <span
                                                className="material-icons"
                                                style={{
                                                  fontSize: 15,
                                                  color: "#a963f5",
                                                  flexShrink: 0,
                                                }}
                                              >
                                                {TYPE_ICONS_PANEL[el.type] || "widgets"}
                                              </span>
                                              <span
                                                style={{
                                                  flex: 1,
                                                  fontSize: 11,
                                                  fontWeight: isElSel ? 700 : 500,
                                                  color: "#1e293b",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                {el.title || TYPE_LABELS_PANEL[el.type] || el.type}
                                              </span>
                                              <button
                                                type="button"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  dispatch(
                                                    removeScenarioElement(
                                                      boxSelected,
                                                      _selectedSceneId,
                                                      el.id
                                                    )
                                                  );
                                                  if (isElSel)
                                                    dispatch(
                                                      selectScenarioElement(
                                                        boxSelected,
                                                        _selectedSceneId,
                                                        null
                                                      )
                                                    );
                                                }}
                                                style={{
                                                  width: 20,
                                                  height: 20,
                                                  borderRadius: 4,
                                                  border: "none",
                                                  background: "rgba(239,68,68,0.1)",
                                                  color: "#ef4444",
                                                  fontSize: 10,
                                                  cursor: "pointer",
                                                  flexShrink: 0,
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                              >
                                                <span
                                                  className="material-icons"
                                                  style={{ fontSize: 13 }}
                                                >
                                                  delete
                                                </span>
                                              </button>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  </>
                                )}

                                {/* ── ÖZELLİKLER section (when element is selected) ── */}
                                {_selectedElement && (
                                  <>
                                    <div
                                      style={{
                                        height: 1,
                                        background: "#f0f0f5",
                                        margin: "0 12px",
                                      }}
                                    />
                                    <div style={{ padding: "8px 12px 12px" }}>
                                      <div
                                        style={{
                                          fontSize: 10,
                                          fontWeight: 700,
                                          color: "#94a3b8",
                                          textTransform: "uppercase",
                                          letterSpacing: "0.06em",
                                          marginBottom: 8,
                                        }}
                                      >
                                        {i18n.t("Properties") || "Özellikler"}
                                      </div>
                                      <div
                                        className="sce-prop-editor"
                                        style={{
                                          background: "#f8fafc",
                                          borderRadius: 10,
                                          padding: "10px 10px 12px",
                                          border: "1px solid #e2e8f0",
                                        }}
                                      >
                                        <ElementPropertyEditor
                                          element={_selectedElement}
                                          scenes={_scenes}
                                          variables={_variables}
                                          elements={_elements}
                                          setField={(path, value) =>
                                            dispatch(
                                              updateScenarioElement(
                                                boxSelected,
                                                _selectedSceneId,
                                                _selectedElement.id,
                                                path,
                                                value
                                              )
                                            )
                                          }
                                          onPickFile={(fieldName, accept) => {
                                            const pickId = `sce-el:${boxSelected}:${_selectedSceneId}:${_selectedElement.id}:${fieldName}`;
                                            this.setState({
                                              fileModalResult: {
                                                id: pickId,
                                                value: undefined,
                                                accept,
                                              },
                                              leftPanel: "library",
                                              libraryCategory: "My Files",
                                              aiPanel: null,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </RightPanelShell>
                          </div>
                        );
                      })()}

                    {/* Aidea Wizard feature panel — video only. On an image the
                          AI Wizard tab opens the Görseli Düzenle modal instead
                          (see onTabChange / _openAreaOps). */}
                    {rightTab === "merlin" && hasBox && isMerlinVideo && (
                      <div
                        id="merlinPanelDrawer"
                        onMouseEnter={onRightEnter}
                        onMouseLeave={onRightLeave}
                        style={{
                          position: "absolute",
                          right: CARD_RIGHT + STRIP_W + 16,
                          top: CARD_TOP,
                          width: "320px",
                          maxHeight: MAX_PANEL_H,
                          zIndex: 102,
                          borderRadius: 14,
                          boxShadow: "0 4px 24px rgba(0,0,0,0.14)",
                          overflow: "hidden",
                          display: "flex",
                          flexDirection: "column",
                          opacity: rightOpacity,
                          transition: "opacity 0.18s ease",
                        }}
                      >
                        <RightPanelShell
                          title="Aidea Wizard AI"
                          Icon={LuSparkles}
                          onClose={_closePanel}
                          style={{ flex: 1, minHeight: 0 }}
                        >
                          <VideoMerlinDrawer
                            boxId={boxSelected}
                            videoUrl={pluginToolbars[boxSelected]?.state?.url || ""}
                            navId={navItemSelected}
                            trainingId={new URLSearchParams(window.location.search).get("id")}
                            sceneIndex={navItemsIds.indexOf(navItemSelected) + 1}
                            onOpenNarration={(text, nav) => {
                              // "Resmi Anlatım" → open the normal AI voice sound
                              // modal (AddSoundModal, "ai"/Anlatım Sesi tab) for a
                              // NEW scene sound, pre-filled with the transcript text.
                              // Scope the prefill to THIS scene (nav) so switching
                              // scenes inside the modal doesn't seed it elsewhere.
                              this.setState({
                                showAddSoundModal: true,
                                addSoundModalTab: "ai",
                                addSoundInitialIndex: null,
                                addSoundInitialText: text || "",
                                addSoundInitialTextNavId: nav || null,
                              });
                            }}
                          />
                        </RightPanelShell>
                      </div>
                    )}

                    {/* Animation panel — only when element is selected */}
                    {rightTab === "animation" && hasBox && !_isInteractive && (
                      <div
                        id="animationPanelDrawer"
                        onMouseEnter={onRightEnter}
                        onMouseLeave={onRightLeave}
                        style={{
                          position: "absolute",
                          right: CARD_RIGHT + STRIP_W + 16,
                          top: CARD_TOP,
                          height: MAX_PANEL_H,
                          maxHeight: MAX_PANEL_H,
                          width: "300px",
                          zIndex: 102,
                          display: "flex",
                          flexDirection: "column",
                          gap: DRAWER_STACK_GAP,
                          opacity: rightOpacity,
                          transition: "opacity 0.18s ease",
                        }}
                      >
                        {/* Selection card: fills all remaining stack space —
                              big when the pan card is closed/empty, yields to
                              the pan card's natural height when it's open.
                              Its own content (.ap-panel--flow) scrolls
                              internally when it doesn't fit. */}
                        <div
                          style={{
                            background: "white",
                            borderRadius: 14,
                            boxShadow: "0 4px 24px rgba(0,0,0,0.14)",
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column",
                            flex: "1 1 auto",
                            // Header + tabs + one row of preset cards; header +
                            // tabs only while the pan card is open, so a short
                            // stack doesn't squeeze the pan card (and its
                            // seconds slider) away instead.
                            minHeight: _animStackFloors.selection,
                          }}
                        >
                          <RightPanelShell
                            title={_activeTab?.label || i18n.t("AnimationLabel")}
                            Icon={_activeTab?.Icon}
                            onClose={_closePanel}
                            onBack={
                              this.state.animPanActive && !this.state.animPanCollapsed
                                ? this._backFromPanSettings
                                : undefined
                            }
                            style={{ flex: 1, minHeight: 0 }}
                          >
                            <AnimationPanel
                              panControlsHost={this.state.animPanHost}
                              panSettingsCollapsed={this.state.animPanCollapsed}
                              onPanStateChange={this._onAnimPanStateChange}
                              elementType={(() => {
                                const sub = this.state.selectedAtomicSubField;
                                if (sub && sub.boxId === boxSelected) {
                                  const ed = this._readAtomicElementData(boxSelected);
                                  // Multi-select: text-only presets only when
                                  // every selected field is text.
                                  return selectedSubFieldPaths(sub).every((p) =>
                                    this._isAtomicFieldText(p, ed)
                                  )
                                    ? "text"
                                    : "element";
                                }
                                const b = boxes[boxSelected];
                                if (!b) return "element";
                                const toolbars =
                                  this.props.store.getState().undoGroup.present.pluginToolbarsById;
                                const tb = toolbars?.[boxSelected];
                                const pid = (tb?.pluginId || b.pluginId || "").toLowerCase();
                                if (pid.includes("text") || pid.includes("title")) return "text";
                                if (pid === "atomicboxplugin") {
                                  const ed = this._readAtomicElementData(boxSelected);
                                  if (ed && getAtomicElementUiType(ed.type) === "text")
                                    return "text";
                                }
                                return "element";
                              })()}
                              entryAnimation={(() => {
                                const sub = this.state.selectedAtomicSubField;
                                if (!sub || sub.boxId !== boxSelected) return null;
                                const ed = this._readAtomicElementData(boxSelected);
                                return this._readAtomicFieldAnim(ed, sub.path, "entry");
                              })()}
                              exitAnimation={(() => {
                                const sub = this.state.selectedAtomicSubField;
                                if (!sub || sub.boxId !== boxSelected) return null;
                                const ed = this._readAtomicElementData(boxSelected);
                                return this._readAtomicFieldAnim(ed, sub.path, "exit");
                              })()}
                              fieldLabel={(() => {
                                const sub = this.state.selectedAtomicSubField;
                                if (!sub || sub.boxId !== boxSelected) return null;
                                const paths = selectedSubFieldPaths(sub);
                                return paths.length > 1
                                  ? paths.map((p) => humanizeFieldPath(p)).join(", ")
                                  : humanizeFieldPath(sub.path);
                              })()}
                              syncKey={(() => {
                                const sub = this.state.selectedAtomicSubField;
                                return sub && sub.boxId === boxSelected
                                  ? `${sub.boxId}::${selectedSubFieldPaths(sub).join("|")}`
                                  : `box::${boxSelected}`;
                              })()}
                              box={(() => {
                                const b = boxes[boxSelected];
                                if (!b) return b;
                                return {
                                  ...b,
                                  boxAnimation: b.boxAnimation ?? b.textAnimation ?? null,
                                };
                              })()}
                              onApplyEntry={(animName, duration, panOptions) => {
                                const sub = this.state.selectedAtomicSubField;
                                if (sub && sub.boxId === boxSelected) {
                                  this.writeAtomicFieldAnim(
                                    sub.boxId,
                                    selectedSubFieldPaths(sub),
                                    "entry",
                                    animName,
                                    duration
                                  );
                                  return;
                                }
                                const el = document.getElementById(`box-${boxSelected}`);
                                const box = boxes[boxSelected];
                                const startFrame = box?.timeline?.startFrame ?? 0;
                                if (box?.textAnimation) dispatch(deleteTextAnimation(boxSelected));
                                if (!animName) {
                                  dispatch(deleteBoxAnimation(boxSelected));
                                  if (el) resetElementAnimationState(el);
                                  setTimeout(
                                    () => this.ideaTimelineRef.current?.seekToFrame(startFrame),
                                    30
                                  );
                                } else {
                                  const entryPreset = getBoxAnimationPresets().find(
                                    (p) => p.name === animName
                                  );
                                  const animPayload = {
                                    ...(entryPreset ?? { name: animName }),
                                    ...(panOptions || {}),
                                  };
                                  dispatch(
                                    updateBoxAnimation(boxSelected, animPayload, duration, 0)
                                  );
                                  // Land the playhead where the entrance animation ENDS,
                                  // not at startFrame: at the start the entrance is on its
                                  // initial frame (opacity 0) so the element would look
                                  // hidden. Seeking to the end leaves it in its final,
                                  // fully-visible state.
                                  const entranceEndFrame = startFrame + Math.round(duration * 30);
                                  if (el && entryPreset) {
                                    this._cancelBoxAnimPreview();
                                    this._boxAnimPreviewBoxId = boxSelected;
                                    this._boxAnimPreviewCancel = previewBoxAnimation(
                                      el,
                                      animName,
                                      duration,
                                      getBoxAnimationPresets(),
                                      panOptions
                                    );
                                    this._boxAnimPreviewTimeout = setTimeout(
                                      () => {
                                        this._boxAnimPreviewCancel = null;
                                        this._boxAnimPreviewTimeout = null;
                                        this._boxAnimPreviewBoxId = null;
                                        this.ideaTimelineRef.current?.seekToFrame(entranceEndFrame);
                                      },
                                      duration * 1000 + 60
                                    );
                                  } else {
                                    setTimeout(
                                      () =>
                                        this.ideaTimelineRef.current?.seekToFrame(entranceEndFrame),
                                      30
                                    );
                                  }
                                }
                              }}
                              onApplyExit={(animName, duration, panOptions) => {
                                const sub = this.state.selectedAtomicSubField;
                                if (sub && sub.boxId === boxSelected) {
                                  this.writeAtomicFieldAnim(
                                    sub.boxId,
                                    selectedSubFieldPaths(sub),
                                    "exit",
                                    animName,
                                    duration
                                  );
                                  return;
                                }
                                const el = document.getElementById(`box-${boxSelected}`);
                                const box = boxes[boxSelected];
                                // Scene (training) duration in frames. A full-duration
                                // element has no explicit endFrame, so its exit must be
                                // anchored to the scene end
                                const exitSceneId =
                                  containedViewSelected && containedViewSelected !== 0
                                    ? containedViewSelected
                                    : navItemSelected;
                                const sceneDuration =
                                  this.props.store.getState().undoGroup.present.navItemsById?.[
                                    exitSceneId
                                  ]?.duration || 1800;
                                // Anchor the exit to the box's REAL stage end, the same
                                // one the timeline layer shows. Videos rarely persist
                                // timeline.endFrame (the badge is media-derived), and
                                // falling back to the scene end would park the playhead
                                // OUTSIDE the box's range — the seek's layer pass then
                                // hides the element (inRange=false → opacity 0).
                                const rawEndFrame = box?.timeline?.endFrame;
                                let ownEndFrame =
                                  typeof rawEndFrame === "number" ? rawEndFrame : null;
                                if (ownEndFrame == null) {
                                  const mediaEl = document.querySelector(
                                    `#box-${boxSelected} video, #box-${boxSelected} audio`
                                  );
                                  const mediaDur =
                                    mediaEl &&
                                    Number.isFinite(mediaEl.duration) &&
                                    mediaEl.duration > 0
                                      ? mediaEl.duration
                                      : null;
                                  if (mediaDur) {
                                    ownEndFrame = resolveBoxEndFrame(
                                      box,
                                      Math.ceil(mediaDur * 30),
                                      animationsById[boxSelected] || [],
                                      30
                                    );
                                  }
                                }
                                const endFrame = Math.min(
                                  ownEndFrame ?? sceneDuration,
                                  sceneDuration
                                );
                                const exitStartFrame = Math.max(
                                  0,
                                  endFrame - Math.round(duration * 30)
                                );
                                if (box?.textAnimation) dispatch(deleteTextAnimation(boxSelected));
                                if (!animName) {
                                  dispatch(deleteBoxExitAnimation(boxSelected));
                                  if (el) resetElementAnimationState(el);
                                  setTimeout(
                                    () => this.ideaTimelineRef.current?.seekToFrame(exitStartFrame),
                                    30
                                  );
                                } else {
                                  const exitPreset = getBoxExitAnimationPresets().find(
                                    (p) => p.name === animName
                                  );
                                  const animPayload = {
                                    ...(exitPreset ?? { name: animName }),
                                    ...(panOptions || {}),
                                  };
                                  dispatch(
                                    updateBoxExitAnimation(boxSelected, animPayload, duration)
                                  );
                                  if (el && exitPreset) {
                                    this._cancelBoxAnimPreview();
                                    this._boxAnimPreviewBoxId = boxSelected;
                                    this._boxAnimPreviewCancel = previewBoxAnimation(
                                      el,
                                      animName,
                                      duration,
                                      getBoxExitAnimationPresets(),
                                      panOptions
                                    );
                                    this._boxAnimPreviewTimeout = setTimeout(
                                      () => {
                                        this._boxAnimPreviewCancel = null;
                                        this._boxAnimPreviewTimeout = null;
                                        this._boxAnimPreviewBoxId = null;
                                        // The preview parks the element on the exit's final
                                        // (hidden) frame. Re-query the node (React may have
                                        // replaced it after the dispatch) and clear the stale
                                        // styles directly — then land the playhead where the
                                        // exit starts so the element stays visible on canvas.
                                        const liveEl = document.getElementById(
                                          `box-${boxSelected}`
                                        );
                                        if (liveEl) resetElementAnimationState(liveEl);
                                        this.ideaTimelineRef.current?.seekToFrame(exitStartFrame);
                                      },
                                      duration * 1000 + 60
                                    );
                                  } else {
                                    setTimeout(
                                      () =>
                                        this.ideaTimelineRef.current?.seekToFrame(exitStartFrame),
                                      30
                                    );
                                  }
                                }
                              }}
                              onClose={_closePanel}
                              hideHeader
                            />
                          </RightPanelShell>
                        </div>
                        {/* Pan card takes its natural height when there is
                              room; when the stack is short (timeline open) it
                              shrinks and scrolls internally, but never below
                              its first section — the seconds slider. */}
                        <div
                          className="anim-pan-host"
                          ref={this._setAnimPanHost}
                          style={{
                            background: "white",
                            borderRadius: 14,
                            boxShadow: "0 4px 24px rgba(0,0,0,0.14)",
                            flex: "0 1 auto",
                            minHeight: _animStackFloors.pan,
                            overflowY: "auto",
                          }}
                        />
                      </div>
                    )}

                    {/* Icon card — floating, auto-height, top-right */}
                    <RightIconStrip
                      tabs={TABS}
                      activeTab={rightTab}
                      top={CARD_TOP}
                      right={CARD_RIGHT}
                      actions={elementActions}
                      opacity={rightOpacity}
                      onMouseEnter={onRightEnter}
                      onMouseLeave={onRightLeave}
                      onTabChange={(key) => {
                        // AI Wizard on an image: no drawer — the full-screen
                        // Görseli Düzenle modal opens directly. (A video keeps
                        // its VideoMerlinDrawer below.)
                        if (key === "merlin" && isMerlinEligible) {
                          this._openAreaOps(boxSelected);
                          return;
                        }
                        // Animated (webp) image: the animation popup.
                        if (key === "merlin" && isAnimatedImage) {
                          this._openAnimationWizard(boxSelected);
                          return;
                        }
                        const next = rightTab === key ? null : key;
                        // Opening a panel from the rail on top of a selected
                        // element dismisses that element's over-box pill —
                        // see utils/rightDrawerPill.js.
                        this.setState({
                          rightActiveTab: next,
                          pillHiddenForTab: pillDismissalForTab(next, hasBox),
                        });
                      }}
                    />
                  </>
                );
              })()}
              {/* end right panel */}
            </div>
            {/* === Phase B Task 4 === Docked Workflow panel — third column.
                Sibling of #workspace inside mainRow so workspace's absolute
                right-panel cards (CARD_RIGHT from workspace's right edge) do
                not overlap. The panel self-hides when the active scene has
                no InteractivePlugin box, so the flex layout collapses to the
                original two-column shape without any extra conditional. */}
            {/* <CanvasWorkflowPanel /> */}
          </div>
          <ServerFeedback
            show={this.state.serverModal}
            title={this.state.serverModalTitle}
            isSuccess={this.state.serverModalSuccess}
            message={this.state.serverModalMessage}
            hideModal={() => this.setState({ serverModal: false })}
          />
          {/* Agentic-chat panel — ALWAYS enabled, in every environment, with no
              flag/kill-switch (product decision). Client-only guard for SSR safety;
              nothing else gates it. */}
          {typeof window !== "undefined" &&
            (!this.state.buildParams || this.state.buildRevealed) && (
              <ChatPanel
                chatbotOptIn={globalConfig.chatbotOptIn ?? false}
                buildThread={
                  this.state.buildParams ? (
                    <BuildThread
                      draftId={this.state.buildParams.draftId}
                      navItemsIds={navItemsIds}
                    />
                  ) : null
                }
                widgetProps={
                  globalConfig.jobWidgetVisible
                    ? {
                        onToolbarUpdated: this.toolbarUpdated,
                        // Widget "Onayla" → infografik sonucunu mevcut sahneye
                        // uygula (modal ile aynı fonksiyon). generate-images her
                        // zaman mevcut sahne (n); sceneIndex = n → navItemsIds[n-1].
                        onInfographicApprove: (job) => {
                          const md = job?.metadata || {};
                          const rawIdx = job?.sceneIndex ?? md.sceneIndex;
                          const idx = rawIdx != null && rawIdx !== "" ? parseInt(rawIdx, 10) : NaN;
                          const navFromIndex = Number.isFinite(idx) ? navItemsIds[idx - 1] : null;
                          const targetNavId =
                            (job?.navId && navItems[job.navId] ? job.navId : null) ||
                            (navFromIndex && navItems[navFromIndex] ? navFromIndex : null) ||
                            navItemSelected;
                          applyInfographicImagesResult(job?.result, { targetNavId });
                        },
                        // Widget "Onayla" → infografik SAHNE (generate) sonucunu
                        // yeni sahne olarak ekle. sceneIndex = n+1 gönderilir →
                        // yeni sahne, navItemsIds[(n+1)-1-1] = [idx-2]'nin ardına.
                        onInfographicSceneApprove: (job) => {
                          const md = job?.metadata || {};
                          const rawIdx = job?.sceneIndex ?? md.sceneIndex;
                          const idx = rawIdx != null && rawIdx !== "" ? parseInt(rawIdx, 10) : NaN;
                          const navFromIndex = Number.isFinite(idx) ? navItemsIds[idx - 2] : null;
                          const targetNavId =
                            (job?.navId && navItems[job.navId] ? job.navId : null) ||
                            (navFromIndex && navItems[navFromIndex] ? navFromIndex : null) ||
                            navItemSelected;
                          applyInfographicSceneResult(job?.result, { targetNavId });
                        },
                        // Widget "Onayla" → batch soru işini sahnelere ekle. Her soru,
                        // üretildiği KAYNAK sahnenin (question.navId) ardına yeni sahne
                        // olur. applyGeneratedQuestion store'dan TAZE okuduğu için ard
                        // arda ekleme stale-slot sorunu yaşamaz; modaldeki reverse sırası
                        // birebir korunur (aynı anchor'daki sorular orijinal sırada kalır).
                        // Not: JobWidgetHost aynı job'ı jobId ile tekilleştirir; yine de
                        // aynı job hem modalda hem widget'ta onaylanırsa çift eklenebilir.
                        onQuestionBatchApprove: (job) => {
                          const questions =
                            job?.metadata?.questions || job?.result?.questions || job?.questions;
                          if (!Array.isArray(questions) || !this.applyGeneratedQuestion) return;
                          questions
                            .filter((q) => q && !q.error && q.navItem)
                            .slice()
                            .reverse()
                            .forEach((q) => this.applyGeneratedQuestion(q));
                        },
                        // Widget "Sahneye ekle" → Görsel Ekle'nin 3B obje /
                        // hareketli görsel kutusu (modaldaki onay kartıyla aynı
                        // fonksiyon). GIF/WebP bunun yerine görsel olarak
                        // eklenir — bkz. JobWidgetHost.
                        onSceneVisualApprove: (result, targetNavId) =>
                          insertSceneVisualBox(dispatch, result, targetNavId),
                        navItems,
                        navItemsIds,
                        navItemSelected,
                        containedViews,
                        containedViewSelected,
                        boxes,
                        // addBoxThunk (not plain addBox) — a Merlin/queue-added
                        // EnrichedPlayer mp4 has no explicit timeline.endFrame,
                        // so it needs the thunk's media-duration probe to persist
                        // one. Without it the box has no timeline at all and
                        // buildLayers/resolveBoxTiming default it to startFrame=0
                        // with a wrong fallback duration (see addBoxThunk doc in
                        // common/actions.es6).
                        onBoxAdded: (
                          ids,
                          draggable,
                          resizable,
                          content,
                          style,
                          state,
                          structure,
                          initialParams
                        ) =>
                          dispatch(
                            addBoxThunk(
                              ids,
                              draggable,
                              resizable,
                              content,
                              style,
                              state,
                              structure,
                              initialParams
                            )
                          ),
                        onNavItemSelected: (id) => dispatch(selectNavItem(id)),
                        onBoxDeleted: (id, parent, container, page) =>
                          this.onBoxDeleted(id, parent, container, page),
                        // Timeline satır sırasını/z-order'ı "Canlandır" swap'ından
                        // sonra eski kutunun index'ine geri oturtmak için — bkz.
                        // JobWidgetHost'taki onBoxLayerChange kullanımı.
                        onBoxLayerChange: (...args) => dispatch(changeBoxLayer(...args)),
                        pluginToolbars,
                        boxSelected,
                      }
                    : null
                }
              />
            )}
          {this.state.buildParams && (
            <BuildChat
              key={this.state.buildParams.jobId}
              params={this.state.buildParams}
              resumed={this.state.buildResumed}
              navItemsIds={navItemsIds}
              onScenesChanged={this._importBuildProgress}
              onBuildFinished={this._onBuildFinished}
              onRevealed={this._onBuildRevealed}
              onJobChanged={this._onBuildJobChanged}
            />
          )}
          {typeof window !== "undefined" && <HelpHub />}
          <EditorAlerts
            i18n={i18n}
            lmsOverwriteDialog={this.state.lmsOverwriteDialog}
            lmsLogCreatedAt={this.state.lmsLogCreatedAt}
            onLmsExportConfirm={() => this._doLmsExport(true)}
            onLmsExportOverwrite={() => this._doLmsExport(false)}
            onLmsExportCancel={() =>
              this.setState({
                lmsOverwriteDialog: false,
                lmsExporting: false,
                lmsExportResult: null,
              })
            }
            lmsExporting={this.state.lmsExporting}
            lmsExportResult={this.state.lmsExportResult}
            fontLinkModalVisible={this.state.fontLinkModalVisible}
            pendingFontLinks={this.state.pendingFontLinks || []}
            fontLinkModalLoading={this.state.fontLinkModalLoading}
            fontLinkModalResult={this.state.fontLinkModalResult}
            onFontLinkConfirm={() => this.handleFontLinkModalConfirm()}
            onFontLinkCancel={() => this.handleFontLinkModalCancel()}
            localDraftPrompt={this.state.localDraftPrompt}
            onLocalDraftDecision={this._onLocalDraftDecision}
          />
          <ExitModal
            showExitModal={this.state.showExitModal}
            closeExitModal={() => this.setState({ showExitModal: false })}
            save={() => {
              if (window.ideaEnvSaveState) {
                window.ideaEnvSaveState(
                  { ...this.props.store.getState() },
                  true,
                  () => {
                    // Also the unsaved-changes guard's baseline — see the
                    // manual-save handler above for why.
                    this._autosaveLastSignature = getUndoSignature(
                      this.props.store.getState().undoGroup
                    );
                  },
                  (err) => {
                    if (err && err.isSaveConflict) {
                      this._openSaveConflict(err.currentUpdatedAt);
                    }
                  }
                );
              } else {
                console.error("Save function not found");
                if (window._LSExitAndReturnList) {
                  window._LSExitAndReturnList();
                } else {
                  window.location.href = `${getLoginBaseUrl()}/courses`;
                }
              }
            }}
            status={this.props.status}
          />
          <UnsavedChangesGuardModal
            show={this.state.showUnsavedChangesGuard}
            saving={this.state.unsavedChangesGuardSaving}
            error={this.state.unsavedChangesGuardError}
            onStay={() =>
              this.setState({ showUnsavedChangesGuard: false, unsavedChangesGuardError: null })
            }
            onLeaveWithoutSaving={() => {
              this.setState({ showUnsavedChangesGuard: false });
              this._unsavedChangesGuard.confirmLeave();
            }}
            onSaveAndLeave={() => {
              this.setState({ unsavedChangesGuardSaving: true, unsavedChangesGuardError: null });
              ideaEnvSaveState(
                { ...this.props.store.getState() },
                false,
                () => {
                  this._autosaveLastSignature = getUndoSignature(
                    this.props.store.getState().undoGroup
                  );
                  this.setState({
                    showUnsavedChangesGuard: false,
                    unsavedChangesGuardSaving: false,
                  });
                  this._unsavedChangesGuard.confirmLeave();
                },
                (err) => {
                  if (err && err.isSaveConflict) {
                    this._openSaveConflict(err.currentUpdatedAt);
                    return;
                  }
                  this.setState({
                    unsavedChangesGuardSaving: false,
                    unsavedChangesGuardError: i18n.t("unsavedChangesGuard.saveError", {
                      defaultValue: "Couldn't save your changes. Please try again.",
                    }),
                  });
                }
              );
            }}
          />
          <SaveBeforeSyncModal
            show={!!this.state.saveBeforeSync}
            saving={!!this.state.saveBeforeSync?.saving}
            error={this.state.saveBeforeSync?.error}
            onCancel={() => this.closeSaveBeforeSync(false)}
            onSaveAndSync={this.saveBeforeSync}
          />
          <LegacyTimelineRepairModal
            show={this.state.legacyTimelineRepair !== null}
            summary={this.state.legacyTimelineRepair}
            onRepair={this._repairMediaTimeline}
            onDismiss={() => this.setState({ legacyTimelineRepair: null })}
          />
          <StaleTrainingBanner />
          <SaveConflictModal
            show={!!this.state.saveConflict}
            currentUpdatedAt={this.state.saveConflict?.currentUpdatedAt}
            phase={this.state.saveConflict?.phase || null}
            onOverwrite={() => this._overwriteSaveConflict()}
            onReload={() => this._reloadServerCopy()}
            onCancel={() => this.setState({ saveConflict: null })}
          />
          {/* Hareketli Görsel'in "AI ile düzenle"si — pill'deki yıldız
              aidea:motion-ai-edit olayını atar, pencereyi bu açar. Bu satır
              yoksa yıldız hiçbir şey yapmaz (olayı dinleyen kalmaz). */}
          <MotionAiEditHost />
          <EditorModals
            state={this.state}
            timelineTimeSec={this._timelineTimeSec || 0}
            setState={(patch) => this.setState(patch)}
            store={this.props.store}
            dispatch={dispatch}
            pluginToolbars={pluginToolbars}
            viewToolbars={viewToolbars}
            boxes={boxes}
            boxSelected={boxSelected}
            navItems={navItems}
            navItemsIds={navItemsIds}
            navItemSelected={navItemSelected}
            containedViews={containedViews}
            containedViewSelected={containedViewSelected}
            filesUploaded={filesUploaded}
            globalConfig={globalConfig}
            uploadFunction={(...args) => dispatch(uploadFunction(...args))}
            deleteFunction={(...args) => dispatch(deleteFunction(...args))}
            currentViewOrContained={currentViewOrContained}
            title={title}
            disabled={disabled}
            marks={marks}
            soundParentId={currentViewOrContained}
            voiceProfile={this.state.voiceProfile}
            uploadTemplateFunction={(value) => this.uploadTemplate(navItemSelected, value)}
            onInfographicSceneGenerated={(sceneData) => applyInfographicSceneResult(sceneData)}
            onInfographicImagesFromSoundGenerated={(sceneData, opts) =>
              applyInfographicImagesResult(sceneData, opts)
            }
            onMotionSceneGenerated={(result) =>
              // The backend returns a ready MotionScene box; give it the
              // timeline length the narration produced.
              addMotionSceneBox(dispatch, result, navItemSelected)
            }
            onSceneVisualGenerated={(result) =>
              insertSceneVisualBox(dispatch, result, result?.box?.parent || navItemSelected)
            }
            onInfographicImageGenerated={(imageUrl) => {
              if (!imageUrl) return;
              const boxId = "image-" + Date.now();
              dispatch(
                addBox(
                  { id: boxId, parent: navItemSelected, container: 0 },
                  true,
                  true,
                  "",
                  {},
                  { url: imageUrl },
                  undefined,
                  {
                    name: "HotspotImages",
                    position: { x: "0%", y: "0%", type: "absolute" },
                    width: 100,
                    height: 100,
                    widthUnit: "%",
                    heightUnit: "%",
                    url: imageUrl,
                  }
                )
              );
            }}
            onQuestionGenerated={
              (this.applyGeneratedQuestion = (sceneData) => {
                const {
                  navItem,
                  navId: sourceNavId,
                  boxesById: sceneBoxes,
                  pluginToolbarsById: sceneToolbars,
                  correctAnswers,
                  soundList: sceneSounds,
                  narrationAudioUrl,
                  _voiceId,
                  _voiceName,
                  _provider,
                  _language,
                  _gender,
                  _narrationText,
                } = sceneData;
                if (!navItem?.id) return;
                // Soru sayfası, üretildiği KAYNAK sahnenin (sourceNavId) hemen
                // arkasına eklenir; kaynak yoksa/silinmişse seçili sahneye düşer.
                // Onayda birden çok soru ard arda dispatch edildiğinden render
                // closure'ındaki navItemsIds/navItems STALE kalır (önceki eklenen
                // sahneleri görmez) → hepsi aynı slota yığılır. Her soruyu kendi
                // kaynağının ardına doğru konumlamak için store'dan TAZE oku.
                const present = this.props.store.getState().undoGroup.present;
                const freshNavIds = present.navItemsIds || navItemsIds;
                const freshNavItems = present.navItemsById || navItems;
                // Zaten eklenmişse tekrar ekleme: soru sahnesinin id'si backend'den
                // sabit gelir; state'te bu id varsa (aynı job'ı yeniden onaylama /
                // widget+modal çakışması) sahneyi ikinci kez kurma.
                if (freshNavItems[navItem.id]) return;
                const anchorId =
                  sourceNavId && freshNavIds.includes(sourceNavId) ? sourceNavId : navItemSelected;
                const parentId = freshNavItems[anchorId]?.parent;
                if (parentId === undefined || parentId === null) return;

                const inASlide = (navItem.type || "slide") === "slide";
                const insertPosition = freshNavIds.indexOf(anchorId) + 1;

                dispatch(
                  addNavItem(
                    navItem.id,
                    navItem.name || "Soru Sayfası",
                    parentId,
                    navItem.type || "slide",
                    insertPosition,
                    navItem.background,
                    navItem.customSize,
                    true,
                    true,
                    navItem.sortable_id,
                    anchorId
                  )
                );

                // Soru sahnesi, eğitim sihirbazının (middleware quiz-scene-builder)
                // kurduğu sahnelerle aynı kuralı alır: öğrenci soruyu cevaplamadan
                // ilerleyemez ("Soruyu Bekle"). addNavItem varsayılanı waitForTime
                // olduğundan bu set edilmezse soru otomatik geçilir ve Visor sahne
                // listesi (segmentData isQuizRow) sahneyi "VİDEO" diye etiketler.
                dispatch(
                  updateViewToolbar(navItem.id, {
                    isMandatory: true,
                    mandatoryType: "waitForAction",
                    minTime: 3,
                    autoNext: false,
                  })
                );

                // Matching sağ sütunu render'da sayıdan bağımsız
                // "sc-Answer<i + MATCHING_RIGHT_OFFSET>" anahtarıyla beklenir,
                // ama API yanıtı legacy "sc-Answer<i + nBoxes>" şemasıyla gelir
                // (örn. nBoxes=3 → sağ hücreler sc-Answer3/4/5). Remap'lemezsek
                // sağ öğeler boş container'lara düşer ve render olmaz. Önce her
                // Matching kutusunun nBoxes'ını topla.
                const matchingNBoxesByParent = {};
                Object.entries(sceneToolbars || {}).forEach(([tbBoxId, tb]) => {
                  if (tb?.pluginId === "Matching") {
                    matchingNBoxesByParent[tbBoxId] = tb.state?.nBoxes ?? 0;
                  }
                });
                const remapMatchingContainer = (parentId, container) => {
                  const nBoxes = matchingNBoxesByParent[parentId];
                  if (!nBoxes || typeof container !== "string") return container;
                  const m = container.match(/^sc-Answer(\d+)$/);
                  if (!m) return container;
                  const idx = parseInt(m[1], 10);
                  // Zaten offset şemasındaysa (sc-Answer100+) dokunma.
                  if (idx >= MATCHING_RIGHT_OFFSET) return container;
                  // Sağ sütun: nBoxes <= idx < MATCHING_RIGHT_OFFSET.
                  if (idx >= nBoxes) return "sc-Answer" + (MATCHING_RIGHT_OFFSET + (idx - nBoxes));
                  return container;
                };

                // Complex/react assessment plugins (TrueFalse, Matching, MC, ...)
                // depend on the parent box's state.__pluginContainerIds: boxCreator
                // (reducers/boxes_by_id.es6) builds the parent's sortableContainers
                // ONLY from this map. The manual add path (common_tools.createBox →
                // parsePluginContainersReact) populates it; the API response does NOT.
                // Without it the parent box is created with empty sortableContainers,
                // so the child question/answer boxes can't attach → the assessment
                // structure is broken and correct-answer marking/render fails.
                // Rebuild it here from each parent's child containers (use the SAME
                // remapped container name the child box gets, so Matching's right
                // column lands in the right container).
                const containerIdsByParent = {};
                Object.entries(sceneBoxes || {}).forEach(([, box]) => {
                  const parent = box.parent;
                  if (!parent) return;
                  const container = remapMatchingContainer(parent, box.container ?? 0);
                  if (typeof container !== "string" || !isSortableContainer(container)) return;
                  if (!containerIdsByParent[parent]) containerIdsByParent[parent] = {};
                  containerIdsByParent[parent][container] = {
                    id: container,
                    name: container,
                    height: "auto",
                  };
                });

                Object.entries(sceneBoxes || {}).forEach(([boxId, box]) => {
                  const toolbar = sceneToolbars?.[boxId];
                  if (!toolbar?.pluginId) return;
                  const rawPos = box.position || {};
                  const posX = rawPos.x !== undefined && rawPos.x !== null ? rawPos.x : 0;
                  const posY = rawPos.y !== undefined && rawPos.y !== null ? rawPos.y : 0;
                  const boxParent = box.parent ?? navItem.id;
                  const boxContainer = remapMatchingContainer(boxParent, box.container ?? 0);
                  const pluginConfig =
                    IdealStudio?.Plugins?.get(toolbar.pluginId)?.getConfig?.() ?? null;
                  dispatch(
                    addBox(
                      {
                        id: boxId,
                        parent: boxParent,
                        container: boxContainer,
                        config: pluginConfig,
                        page: navItem.id,
                      },
                      box.draggable !== false,
                      inASlide,
                      "",
                      {
                        ...derivePluginBoxStyle(toolbar.pluginId, toolbar.state),
                        ...(box.style || {}),
                      },
                      containerIdsByParent[boxId]
                        ? {
                            ...(toolbar.state || {}),
                            __pluginContainerIds: containerIdsByParent[boxId],
                          }
                        : toolbar.state || {},
                      toolbar.structure,
                      {
                        name: toolbar.pluginId,
                        position: {
                          x: posX === 0 ? "0%" : posX,
                          y: posY === 0 ? "0%" : posY,
                          type: rawPos.type || "absolute",
                        },
                        width: toolbar.structure?.width ?? box.width ?? 100,
                        height: toolbar.structure?.height ?? box.height ?? 100,
                        widthUnit: toolbar.structure?.widthUnit ?? "%",
                        heightUnit: toolbar.structure?.heightUnit ?? "%",
                        url: toolbar.state?.url || "",
                      }
                    )
                  );
                });

                // correctAnswers dispatch
                if (correctAnswers) {
                  Object.entries(correctAnswers).forEach(([boxId, answer]) => {
                    const pluginId = sceneToolbars?.[boxId]?.pluginId;
                    if (pluginId === "TrueFalse" && Array.isArray(answer)) {
                      // The API returns boolean[] (true = statement is correct), but
                      // the entire TrueFalse system (editor default correctAnswer,
                      // editor click, and TrueFalseVisor scoring) stores/compares the
                      // string literals "true"/"false". The learner's currentAnswer is
                      // always strings, so a boolean correctAnswer never matches → the
                      // Visor marks every answer wrong. Normalize to strings here.
                      const normalized = answer.map((a) =>
                        a === true || a === "true" ? "true" : "false"
                      );
                      dispatch(setCorrectAnswer(boxId, normalized, navItem.id));
                    } else if (pluginId === "FillInBlank" && Array.isArray(answer)) {
                      answer.forEach((ans, i) =>
                        dispatch(setCorrectAnswer(boxId, ans, navItem.id, false, true, i))
                      );
                    } else if (pluginId === "Matching" && Array.isArray(answer)) {
                      answer.forEach(([left, right], i) =>
                        dispatch(setCorrectAnswer(boxId, right, navItem.id, true, false, -1, left))
                      );
                    } else {
                      dispatch(setCorrectAnswer(boxId, answer, navItem.id));
                    }
                  });
                }

                // Anlatım sesini sahneye ekle. API yanıtı sesi zaten hazır verir
                // (soundList[navItem.id] — gerçek file/startTime/endTime/volumeLevel);
                // bunu doğrudan kullan ve düzenleme/yeniden açma için voiceData ekle
                // (AIVoiceTab soundData ile aynı şekil). voiceName guid değil gerçek
                // isimden gelir. soundList boşsa narrationAudioUrl'den fallback kur.
                const buildVoiceData = () => ({
                  provider: _provider || "",
                  language: _language || "",
                  voiceId: _voiceId || "",
                  voiceName: _voiceName || _voiceId || "",
                  gender: _gender || "",
                  narratorMode: "ai",
                });

                const sceneSoundEntries = sceneSounds?.[navItem.id];
                if (Array.isArray(sceneSoundEntries) && sceneSoundEntries.length > 0) {
                  sceneSoundEntries.forEach((sound) =>
                    dispatch(addSound(navItem.id, { ...sound, voiceData: buildVoiceData() }))
                  );
                } else if (narrationAudioUrl) {
                  dispatch(
                    addSound(navItem.id, {
                      file: narrationAudioUrl,
                      name: "narration.mp3",
                      startTime: 0,
                      endTime: null,
                      volumeLevel: 1.0,
                      narrationText: _narrationText || "",
                      voiceData: buildVoiceData(),
                    })
                  );
                }

                dispatch(selectNavItem(navItem.id));
              })
            }
          />
          <KeyboardShortcutsOverlay />
          {/* Job widget artık ChatPanel üzerinden (widgetProps ile) mount
               ediliyor. JobWidgetHost'u burada AYRICA mount etmek widget'ı
               (native React ağacı, iframe değil) çift render eder. */}
          {this.state.knollingViewVisible && (
            <KnollingView
              boxes={boxes}
              soundList={this.props.soundList}
              pluginToolbars={pluginToolbars}
              navItems={navItems}
              navItemSelected={navItemSelected}
              onClose={() => this.setState({ knollingViewVisible: false })}
              onNavigateToScene={(navId) => {
                this.props.dispatch(selectNavItem(navId));
                this.setState({ knollingViewVisible: false });
              }}
            />
          )}
          {this.state.areaOps && (
            <AreaOpsModal
              visible={!!this.state.areaOps}
              boxId={this.state.areaOps.boxId}
              imageUrl={this.state.areaOps.imageUrl}
              trainingId={new URLSearchParams(window.location.search).get("id")}
              navId={navItemSelected}
              sceneIndex={navItemsIds.indexOf(navItemSelected) + 1}
              initialFeatureId={this.state.areaOps.featureId}
              selectionToken={this.state.areaOps.token}
              onClose={this._closeAreaOps}
              // Came from the animation popup: X / Esc / backdrop crossfade back
              // to it (same as its Animate Image card) instead of cutting out.
              closeToWizardFeature={this.state.areaOps.returnToAnimate ? "animate" : undefined}
              onOpenWizardFeature={this._openWizardFromAreaOps}
              onApply={(applyBoxId, url, urlMap) => {
                // Opened from the animation popup: remember the fixed still for
                // the way back. A box showing an animation (holdEdit) keeps it —
                // the still is not written onto it.
                const ret = this.state.areaOps?.returnToAnimate;
                if (ret && applyBoxId === this.state.areaOps.boxId) {
                  this.setState((s) =>
                    s.areaOps?.returnToAnimate
                      ? {
                          areaOps: {
                            ...s.areaOps,
                            returnToAnimate: { ...s.areaOps.returnToAnimate, editedUrl: url },
                          },
                        }
                      : null
                  );
                  if (ret.holdEdit) {
                    if (urlMap && Object.keys(urlMap).length) {
                      this.props.dispatch(applyImageUrlMap(urlMap));
                    }
                    return;
                  }
                }
                // Live URL-swap onto the box (same path applyAnimationResult
                // takes for a same-type image result): pluginToolbars[id].state.url.
                const targetScene =
                  containedViewSelected && containedViewSelected !== 0
                    ? containedViewSelected
                    : navItemSelected;
                this.props.dispatch(
                  updatePluginToolbar(applyBoxId, "main", "state", "url", url, [], targetScene)
                );
                // "Eğitimdeki tüm görsellere uygula": the bulk job returns a
                // urlMap for every stamped image — swap them all on the canvas
                // (scene images + backgrounds), not just the edited box.
                if (urlMap && Object.keys(urlMap).length) {
                  this.props.dispatch(applyImageUrlMap(urlMap));
                }
              }}
            />
          )}
          {this.state.timelineMerlinBoxId && (
            <ImageAnimatorModal
              visible={!!this.state.timelineMerlinBoxId && !this.state.merlinLeaving}
              onClose={() => this._closeMerlin()}
              onExited={this._onMerlinExited}
              handoff={this.state.merlinHandoff}
              imageUrl={this.state.timelineMerlinImageUrl}
              boxId={this.state.timelineMerlinBoxId}
              navId={navItemSelected}
              initialFeatureId={this.state.merlinInitialFeatureId}
              initialSettings={this.state.merlinInitialSettings || undefined}
              onEditSourceImage={this._editAnimationSource}
              sceneIndex={navItemsIds.indexOf(navItemSelected) + 1}
              // "Aidea Akıllı Öğeler" submit'i: REST çağrısı değil, thunk.
              // İlerleme/hata kutunun üzerinde gösterildiği için modal kendini
              // kapatıyor. Modalın açılışta sabitlediği boxId gelir; seçim
              // arada değişirse doğru kutuya çalışsın diye ona düşülür.
              onDecomposeSmartElements={(targetBoxId) =>
                this.props.dispatch(
                  decomposeBoxWithAideaSmartElements(targetBoxId || this.state.timelineMerlinBoxId)
                )
              }
              onAcceptAnimation={(animationData) => this.acceptAnimation(animationData)}
              onInsufficientBalance={notifyInsufficientBalance}
            />
          )}
          <AnimatorPanel
            dispatch={dispatch}
            onSaved={() => {
              // Also the unsaved-changes guard's baseline -- see the
              // manual-save handler above for why.
              this._autosaveLastSignature = getUndoSignature(this.props.store.getState().undoGroup);
            }}
            onConflict={(currentUpdatedAt) => this._openSaveConflict(currentUpdatedAt)}
            // Same baseline the nav guard reads (see _unsavedChangesGuard
            // above) -- lets the panel show its "unsaved changes" banner
            // only when genuinely true instead of unconditionally.
            getLastSavedSignature={() => this._autosaveLastSignature}
          />
          <ThemePaletteModal
            show={this.state.showThemeModal}
            onClose={() => this.setState({ showThemeModal: false })}
            onAddImageModalToggle={(callback) =>
              this.setState({
                showAddImageModal: true,
                onAddImageModalSelected: typeof callback === "function" ? callback : null,
              })
            }
          />
          {this.state.showEditModal && (
            <HtmlEditModal
              show={this.state.showEditModal}
              onClose={() => this.setState({ showEditModal: false })}
              initialHtml={
                boxSelected && pluginToolbars[boxSelected]?.state
                  ? pluginToolbars[boxSelected].state._html || ""
                  : ""
              }
              onSave={(sanitizedHtml) => {
                if (!boxSelected || !pluginToolbars[boxSelected]) return;
                const tb = pluginToolbars[boxSelected];
                const newState = { ...tb.state, _html: sanitizedHtml };
                const apiPlugin = IdealStudio.Plugins.get(tb.pluginId);
                const newToolbar = apiPlugin ? apiPlugin.getToolbar(newState) : tb;
                dispatch(updateBox(boxSelected, boxes[boxSelected].content, newToolbar, newState));
                this.setState({ showEditModal: false });
              }}
            />
          )}
        </Container>
      </DndProvider>
    );
  }

  /**
   * Detects whether the freshly hydrated training is "empty" (no scenes / no boxes)
   * and, if so, forces the GlobalConfig modal open in `emptyHydrate` mode.
   * Designed to be called once after `importStateAsync` lands its IMPORT_STATE
   * dispatch in the store. The forced flag prevents the user from closing the
   * modal until they confirm the training's initial config (Task 13).
   */
  /**
   * Returns the id of an existing empty slide (no boxes, no children) if one
   * exists, otherwise null. Used by addNavItem call-sites to avoid stacking
   * duplicate blank slides when the user clicks "+ Add slide" while an empty
   * slide already exists. The guard mirrors the user's intent: only create a
   * brand-new slide when there's actually content to push down.
   */
  findExistingEmptySlide = () => {
    const present =
      this.props.store && this.props.store.getState
        ? this.props.store.getState().undoGroup.present
        : null;
    if (!present) return null;
    const navItemsById = present.navItemsById || {};
    for (const id of Object.keys(navItemsById)) {
      const item = navItemsById[id];
      if (!item || item.type !== "slide") continue;
      const noBoxes = !Array.isArray(item.boxes) || item.boxes.length === 0;
      const noChildren = !Array.isArray(item.children) || item.children.length === 0;
      if (noBoxes && noChildren) return id;
    }
    return null;
  };

  /**
   * One-shot migration for trainings created before the in-canvas EditorHeader
   * was retired. Walks every scene's viewToolbar, materialises whatever
   * heading text it carried (documentTitleContent / documentSubtitleContent /
   * numPageContent) into a normal editable BasicText box at the same screen
   * position the legacy header rendered, then hides the legacy fields.
   * Idempotent — globalConfig.legacyHeadersMigrated guards re-runs.
   */
  runLegacyHeaderMigration = () => {
    const dispatch = this.props.dispatch || (this.props.store && this.props.store.dispatch);
    if (!dispatch) return;
    const present =
      this.props.store && this.props.store.getState
        ? this.props.store.getState().undoGroup.present
        : null;
    if (!present) return;
    migrateLegacySceneHeaders({
      present,
      dispatch,
      addBoxAction: addBox,
      updateViewToolbarAction: updateViewToolbar,
      changeGlobalConfigAction: changeGlobalConfig,
    });
  };

  detectAndForceGlobalConfigIfEmpty = () => {
    const dispatch = this.props.dispatch || (this.props.store && this.props.store.dispatch);
    const present = this.props.store.getState().undoGroup.present;
    const sceneCount = Object.keys(present.navItemsById || {}).filter(
      (k) => String(k) !== "0"
    ).length;
    const boxCount = Object.keys(present.boxesById || {}).length;
    const initialConfigCompleted = !!(
      present.globalConfig && present.globalConfig.initialConfigCompleted
    );

    // Brand-new training arrives with zero scenes (createEmptyTrainingState
    // intentionally ships a root-only structure). Materialise the first scene
    // through the live ADD_NAV_ITEM reducer so its shape matches every other
    // scene in the codebase. Runs ONCE per hydrate when there are no scenes
    // — guarded so successive refreshes don't keep stacking new scenes.
    if (sceneCount === 0 && dispatch) {
      const newId = ID_PREFIX_PAGE + Date.now();
      dispatch(
        addNavItem(
          newId,
          i18n.t("slide") || "Slide",
          0,
          PAGE_TYPES.SLIDE,
          -1,
          "",
          0,
          false,
          true,
          undefined,
          null
        )
      );
      // Drop the default editable header on the just-created scene so the
      // user lands on a familiar layout (replaces the legacy in-canvas
      // EditorHeader). Same factory the carousel "+" path uses.
      const presentAfter = this.props.store.getState().undoGroup.present;
      addDefaultSceneHeader({
        navItemId: newId,
        onBoxAdded: (...args) => dispatch(addBoxThunk(...args)),
        boxes: presentAfter ? presentAfter.boxesById : {},
      });
    }

    // The forced GlobalConfig modal must only appear ONCE — on the very first
    // load of a brand-new training. globalConfig.initialConfigCompleted is
    // flipped to true the first time the user hits Save in this modal
    // (see GlobalConfig.handleSave). On subsequent refreshes — even if the
    // training still happens to have only one empty scene — the marker keeps
    // the modal closed.
    const isEmpty = sceneCount <= 1 && boxCount === 0;
    if (isEmpty && !initialConfigCompleted) {
      this.setState({
        showGlobalConfig: true,
        globalConfigMode: "emptyHydrate",
        globalConfigForced: true,
      });
    }
  };

  // Enrich & Motionize — or Sync with "Extract texts in visuals" (choices.extractOnly: lift the
  // image text only, no design): sync the scene first (images/texts get their windows and exits),
  // then one paid job on those windows. The result applies itself from the job tray
  // (JobWidgetHost), which also shows the job's steps.
  handleMotionizeScene = async (choices, navItemSelected = this.props.navItemSelected) => {
    if (this.motionizing) return; // one paid request at a time: the key below changes per click
    this.motionizing = true;
    const { dispatch, getState } = this.props.store;
    const extractOnly = !!(choices && choices.extractOnly);
    let out;
    let synced = false;
    try {
      // one shot: the sync overlay stays up (hold) through the job until its result is placed
      synced = await this.handleSyncScene(navItemSelected, { hold: true });
      if (!synced) return; // its error modal is up
      this.setSceneSync(navItemSelected, extractOnly ? "extracting" : "motionizing");
      out = await runMotionDirector(
        dispatch,
        getState,
        {
          ...choices,
          text: "extract",
          idempotencyKey: "sync-" + navItemSelected + "-" + Date.now(),
        },
        { navId: navItemSelected }
      );
    } finally {
      this.motionizing = false;
      if (synced && !(out && out.jobId)) this.setSceneSync(navItemSelected, null);
    }
    if (out.error === "insufficient-balance") return; // already notified
    if (out.jobId) {
      this.lockSceneForMotionJob(navItemSelected, out.jobId, extractOnly);
      return;
    }
    this.setState({
      serverModal: true,
      serverModalTitle: i18n.t("messages.syncScene.errorTitle"),
      serverModalMessage: i18n.t(`messages.syncScene.modal.motionErrors.${out.error}`),
      serverModalSuccess: false,
    });
  };

  // The scene stays locked (canvas overlay + timeline clips, chat.css) until its job ends, so the
  // author cannot edit boxes the result is about to replace. ponytail: in-memory only — a reload
  // drops the lock (the job still lands in the tray); persist per job if that bites.
  lockSceneForMotionJob = (navId, jobId, extractOnly) => {
    markMotionAutoApply(jobId); // placed below the moment it completes; the tray leaves its toast to us
    this.props.dispatch(selectBox(-1)); // no keyboard edit of a box selected before the lock
    this.setState((s) => ({ motionBusy: { ...s.motionBusy, [navId]: { jobId } } }));
    const unlock = () =>
      this.setState((s) => {
        if ((s.motionBusy[navId] || {}).jobId !== jobId) return null;
        const { [navId]: _done, ...rest } = s.motionBusy;
        return { motionBusy: rest };
      });
    waitForJob(jobId, { timeoutMs: 30 * 60 * 1000 }).then(
      async (result) => {
        // one shot: place the result here, then end the overlay on the success check; the tray
        // records it as approved (never offers Approve) and the toast says it is done
        const { dispatch, getState } = this.props.store;
        const out = await applyMotionResult(dispatch, getState, result, navId);
        if (out.error) {
          console.warn("[sync] motion result not applied", out.error, { jobId }); // card keeps Approve
        } else {
          window.dispatchEvent(new CustomEvent("aidea:jobApplied", { detail: { jobId } }));
          window.dispatchEvent(
            new CustomEvent("aidea:toast", {
              detail: {
                message: i18n.t(`messages.syncScene.toast.${extractOnly ? "extracted" : "motion"}`),
              },
            })
          );
        }
        unlock();
        this.setSceneSync(navId, "success");
        setTimeout(() => this.setSceneSync(navId, null), 1500);
      },
      () => {
        unlock();
        this.setSceneSync(navId, null);
        this.setState({
          serverModal: true,
          serverModalTitle: i18n.t("messages.syncScene.errorTitle"),
          serverModalMessage: i18n.t("messages.syncScene.modal.jobFailed"),
          serverModalSuccess: false,
        });
      }
    );
  };

  // Resolves true once the training is saved, false if the author cancels.
  confirmSaveBeforeSync = () =>
    new Promise((resolve) => {
      this._resolveSaveBeforeSync?.(false); // a second sync while open: the first one stops
      this._resolveSaveBeforeSync = resolve;
      this.setState({ saveBeforeSync: { saving: false, error: null } });
    });

  closeSaveBeforeSync = (saved) => {
    this.setState({ saveBeforeSync: null });
    this._resolveSaveBeforeSync?.(saved);
    this._resolveSaveBeforeSync = null;
  };

  saveBeforeSync = () => {
    this.setState({ saveBeforeSync: { saving: true, error: null } });
    this._autosaveSaving = true; // keeps the autosave tick from sending a second save (self-409)
    ideaEnvSaveState(
      { ...this.props.store.getState() },
      false,
      () => {
        this._autosaveSaving = false;
        this._autosaveLastSignature = getUndoSignature(this.props.store.getState().undoGroup);
        this.closeSaveBeforeSync(true);
      },
      (err) => {
        this._autosaveSaving = false;
        if (err && err.isSaveConflict) {
          this.closeSaveBeforeSync(false);
          this._openSaveConflict(err.currentUpdatedAt);
          return;
        }
        this.setState({
          saveBeforeSync: {
            saving: false,
            error: i18n.t("messages.syncScene.saveFirst.saveError"),
          },
        });
      }
    );
  };

  setSceneSync = (navId, status) =>
    this.setState((s) => {
      const { [navId]: _prev, ...rest } = s.syncByScene;
      return { syncByScene: status ? { ...rest, [navId]: status } : rest };
    });

  // Resolves true once the scene is synced (Enrich & Motionize waits on it), false otherwise.
  // opts.hold: on success leave the overlay up (Enrich / extract continue with their job).
  handleSyncScene = async (navItemSelected = this.props.navItemSelected, { hold = false } = {}) => {
    const { navItems, pluginToolbars } = this.props;
    if (!navItemSelected || !navItems[navItemSelected]) return false;
    // The backend reads the scene audio from the saved training.
    if (
      hasUndoSignatureChanged(
        this._autosaveLastSignature,
        getUndoSignature(this.props.store.getState().undoGroup)
      ) &&
      !(await this.confirmSaveBeforeSync())
    ) {
      return false;
    }

    const currentNav = navItems[navItemSelected];
    const boxIds = currentNav.boxes || [];

    const filteredPluginToolbars = boxIds.reduce((acc, boxId) => {
      if (pluginToolbars[boxId]) {
        acc[boxId] = pluginToolbars[boxId];
      }
      return acc;
    }, {});

    const allBoxes = this.props.store.getState().undoGroup.present.boxesById;
    const filteredBoxes = boxIds.reduce((acc, boxId) => {
      if (allBoxes[boxId]) {
        acc[boxId] = allBoxes[boxId];
      }
      return acc;
    }, {});

    // The scene's narration clips — the green bars on the timeline. The whole
    // list goes to the backend, which ends every element with the last one.
    // Sending a single number instead could not describe a scene with two
    // speakers, one that starts after zero, or one with a hidden take.
    const soundList = this.props.store.getState().undoGroup.present.soundList;
    const sceneSounds = (soundList && soundList[navItemSelected]) || [];
    const narrationSound = Array.isArray(sceneSounds)
      ? sceneSounds.find((s) => s.file || s.filePath) || null
      : null;
    // Legacy fallback value, still sent for an older backend.
    const audioDuration = narrationSound?.duration || narrationSound?.endTime || 0;

    const setSync = (status) => this.setSceneSync(navItemSelected, status);
    setSync("syncing");

    try {
      const result = await syncScene(
        this.state.trainingId,
        navItemSelected,
        filteredPluginToolbars,
        filteredBoxes,
        audioDuration,
        Array.isArray(sceneSounds) ? sceneSounds : []
      );

      // TODO: Simulate network delay, remove later
      await new Promise((resolve) => setTimeout(resolve, 3000));

      if (result && (result.boxesById || result.pluginToolbarsById)) {
        this.props.dispatch(
          syncSceneSuccess(result.boxesById || {}, result.pluginToolbarsById || {})
        );
        await this.refitSceneEndMarker(navItemSelected);
      }
      if (hold) return true;
      setSync("success");
      setTimeout(() => setSync(null), 1500);
      window.dispatchEvent(
        new CustomEvent("aidea:toast", {
          detail: { message: i18n.t("messages.syncScene.toast.synced") },
        })
      );
      return true;
    } catch (err) {
      setSync(null);
      this.setState({
        serverModal: true,
        serverModalTitle: i18n.t("messages.syncScene.errorTitle"),
        serverModalMessage: i18n.t("messages.syncScene.errorMessage"),
        serverModalSuccess: false,
      });
      return false;
    }
  };

  /**
   * Move the scene-end marker (the grey bar, navItem.duration) to the end of
   * what the scene now contains — the narration included.
   *
   * The timeline bootstraps that marker ONCE, while the scene has no persisted
   * duration, and from then on treats it as the author's own mark that growing
   * or shrinking content must never move (see IdeaTimeline, "Bootstrap only").
   * So after a re-record the marker keeps pointing at the old narration's end
   * and nothing ever corrects it. A sync is the author explicitly asking for
   * the scene to be re-fitted to the narration, which is the one moment that
   * mark is meant to be re-derived — hence this lives here and nowhere else.
   */
  async refitSceneEndMarker(sceneId) {
    if (!sceneId) return;
    try {
      const present = this.props.store.getState().undoGroup.present;
      const layers = await buildLayersFromBoxes({
        boxes: present.boxesById || {},
        animations: present.animationsById || {},
        currentScene: sceneId,
        navItemsById: present.navItemsById || {},
        soundList: present.soundList || {},
        pluginToolbars: present.pluginToolbarsById || {},
        fps: 30,
      });
      const sceneEnd = layers.reduce((max, l) => {
        // A looping bed tiles across the scene instead of setting its length.
        if (l.type === "scene-audio" && l.audioData?.loopScene) return max;
        return Math.max(max, l.endFrame || 0);
      }, 0);
      if (sceneEnd > 0 && sceneEnd !== present.navItemsById?.[sceneId]?.duration) {
        this.props.dispatch(changeNavItemDuration(sceneId, sceneEnd));
      }
    } catch (err) {
      // Cosmetic: the elements are already synced, only the marker is stale.
      console.warn("[syncScene] scene-end marker refit failed", err);
    }
  }

  showTour() {
    this.setState({ showTour: true, showHelpButton: false });
  }
  createInitModal() {
    return (
      <Alert
        className="pageModal welcomeModal"
        show={this.state.initModal}
        hasHeader={false}
        title={
          <span>
            <i style={{ fontSize: "14px", marginRight: "5px" }} className="material-icons">
              delete
            </i>
            {i18n.t("messages.confirm_delete_cv")}
          </span>
        }
        cancelButton
        acceptButtonText={i18n.t("joyride.start")}
        onClose={(bool) => {
          if (bool) {
            this.setState({ showTour: true, initModal: false });
          } else {
            this.setState({ initModal: false });
          }
        }}
      >
        <div className="welcomeModalDiv">
          <img src={screen} alt="" style={{ width: "100%" }} />
          <h1>
            {i18n.t("joyride.welcome")}
            <strong style={{ color: "#a963f5" }}>Aideapro Studio</strong>!
          </h1>
          <p>{i18n.t("joyride.idealStudio_description")}</p>
          <p>
            <strong>{i18n.t("joyride.need_help")}</strong>
          </p>
        </div>
      </Alert>
    );
  }

  handleUndefinedNavItemSelected() {
    const { navItemSelected, navItemsIds, navItems } = this.props;

    const isCurrentSceneInvalid =
      !navItemSelected ||
      navItemSelected === 0 ||
      !navItems[navItemSelected] ||
      navItems[navItemSelected] === undefined;

    const hasScenes = navItemsIds && navItemsIds.length > 0;

    const shouldAutoSelectFirstScene = isCurrentSceneInvalid && hasScenes;

    if (shouldAutoSelectFirstScene) {
      const firstSceneId = navItemsIds.find((id) => id !== 0 && navItems[id]);
      if (firstSceneId) {
        this.props.dispatch(selectNavItem(firstSceneId));
      }
    }
  }

  handleUndefinedIndexSelected() {
    const { indexSelected, navItemsIds, navItems, containedViews } = this.props;

    const isContainedView = indexSelected && indexSelected.toString().startsWith("cv-");
    if (isContainedView && containedViews[indexSelected]) {
      return;
    }

    const isCurrentSceneInvalid =
      !indexSelected ||
      indexSelected === 0 ||
      !navItems[indexSelected] ||
      navItems[indexSelected] === undefined;

    const hasScenes = navItemsIds && navItemsIds.length > 0;

    const shouldAutoSelectFirstScene = isCurrentSceneInvalid && hasScenes;

    if (shouldAutoSelectFirstScene) {
      const firstSceneId = navItemsIds.find((id) => id !== 0 && navItems[id]);
      if (firstSceneId) {
        this.props.dispatch(selectNavItem(firstSceneId));
      }
    }
  }

  handleUndefinedContainedViewSelected() {
    const { navItemSelected, navItemsIds, navItems } = this.props;

    if (!navItemSelected || navItemSelected === 0) {
      const hasScenes = navItemsIds && navItemsIds.length > 0;
      if (hasScenes) {
        const firstSceneId = navItemsIds.find((id) => id !== 0 && navItems[id]);
        if (firstSceneId) {
          this.props.dispatch(selectNavItem(firstSceneId));
        }
      }
    }
  }

  initAllSceneDurations() {
    const state = this.props.store.getState().undoGroup.present;
    const { boxesById, navItemsById, navItemsIds, animationsById, soundList, pluginToolbarsById } =
      state;
    if (!navItemsIds || !boxesById) return;

    navItemsIds.forEach((sceneId) => {
      const navItem = navItemsById?.[sceneId];
      if (!navItem) return;
      buildLayersFromBoxes({
        boxes: boxesById,
        animations: animationsById || {},
        currentScene: sceneId,
        navItemsById: navItemsById || {},
        soundList: soundList || {},
        pluginToolbars: pluginToolbarsById || {},
        fps: 30,
        defaultDuration: navItem.duration || 1800,
      }).then((layers) => {
        if (!layers.length) return;
        // A loopScene sound's clip bar keeps its natural (one-period) span —
        // it must not inflate the persisted scene duration it's exempt from.
        const maxFrame = layers.reduce((m, l) => {
          if (l.type === "scene-audio" && l.audioData?.loopScene) return m;
          return Math.max(m, l.endFrame || 0);
        }, 0);
        if (maxFrame > 0 && maxFrame !== navItem.duration) {
          this.props.dispatch(changeNavItemDuration(sceneId, maxFrame));
        }
      });
    });
  }

  migrateTextAnimations() {
    const { boxes } = this.props;
    if (!boxes) return;
    const toMigrate = Object.entries(boxes).filter(
      ([, box]) => box?.textAnimation?.animation && !box.boxAnimation
    );
    if (!toMigrate.length) return;
    toMigrate.forEach(([id, box]) => {
      this.props.dispatch(
        updateBoxAnimation(
          id,
          box.textAnimation.animation,
          box.textAnimation.duration || 1,
          box.textAnimation.delay || 0
        )
      );
      this.props.dispatch(deleteTextAnimation(id));
    });
  }

  sceneAudioKey(sound) {
    return `${sound.id || ""}|${sound.file}|${sound.startTime}`;
  }

  getSceneAudio(sound) {
    const key = this.sceneAudioKey(sound);
    let el = this.sceneAudioPool.get(key);
    if (!el) {
      // Through the shared audio context where the source allows it (it then
      // starts within a few ms); a plain element otherwise.
      el = openTimelineAudio(sound.file, (plain, failed) =>
        this.replaceSceneAudio(key, plain, failed)
      );
      // Preload; lazy-loading on play() causes a gap at the start.
      el.preload = "auto";
      this.sceneAudioPool.set(key, el);
    }
    // Sounds entering the pool mid-playback must adopt the active preview rate.
    this.setSceneAudioRate(key, el, this._previewSpeed);
    // Re-read every tick so a level edited while playing applies at once.
    const volume = narrationVolume(sound);
    if (el.volume !== volume) el.volume = volume;
    return el;
  }

  // Every rate change of a pool element: one that is holding 1x for a start
  // (audio_sync.es6) takes the new rate when the hold ends, not now.
  setSceneAudioRate(key, el, rate) {
    const sync = this.sceneAudioSync.get(key);
    if (sync) setAudioSyncRate(sync, el, rate);
    else if (el.playbackRate !== rate) el.playbackRate = rate;
  }

  // A routed element could not load its source: the piece goes on with the
  // plain element `plain`. Nothing has played yet, and nothing is started
  // here — whoever starts the piece next finds it where it was meant to
  // begin, also when that starter knows nothing of the sync state.
  replaceSceneAudio(key, plain, failed) {
    // Removed or re-created meanwhile: an old element's error changes nothing.
    if (this.sceneAudioPool.get(key) !== failed) return;
    plain.preload = "auto";
    plain.volume = failed.volume;
    plain.muted = failed.muted;
    plain.playbackRate = this._previewSpeed;
    this.sceneAudioPool.set(key, plain);
    let sync = this.sceneAudioSync.get(key);
    if (!sync) {
      sync = createAudioSyncState();
      this.sceneAudioSync.set(key, sync);
    }
    sync.deferRate = false;
    sync.playPending = false; // that play() was the failed element's
    // The start that was meant: a seek still waiting; else where a starter
    // had put the failed element; else the piece's in-point.
    const sound = this.getCurrentSceneSoundList().find(
      (s) => s && s.file && this.sceneAudioKey(s) === key
    );
    const put = failed.currentTime;
    const inSec = (sound && sound.audioOffset) || 0;
    const at = sync.startAt != null ? sync.startAt : put > 0 ? put : inSec;
    // Applied now, or as soon as the new element can seek.
    seekAudioSync(sync, plain, at);
  }

  // Stop, leave the audio graph, then let go of the source — in that order:
  // emptying the source of a still-routed element reads as a load failure.
  dropSceneAudio(key) {
    const el = this.sceneAudioPool.get(key);
    if (el) {
      el.pause();
      unrouteAudio(el);
      el.src = "";
    }
    this.sceneAudioPool.delete(key);
    this.sceneAudioSync.delete(key);
  }

  // Called by IdeaTimeline when the preview speed changes or playback starts/stops.
  setPreviewSpeed(rate) {
    const next = rate > 0 ? rate : 1;
    if (this._previewSpeed === next) return;
    this._previewSpeed = next;
    this.sceneAudioPool.forEach((el, key) => this.setSceneAudioRate(key, el, next));
    if (this.animationScene && typeof this.animationScene.setPlaySpeed === "function") {
      this.animationScene.setPlaySpeed(next);
    }
  }

  // The preview playhead, through the shared scene time bus: no EditorApp render per frame.
  _publishTimelineTime(time) {
    this._timelineTimeSec = time;
    const sceneId =
      this.props.containedViewSelected != 0
        ? this.props.containedViewSelected
        : this.props.navItemSelected;
    sceneTimeBus.publish(time, sceneId);
    sceneTimeBus.commitFrame(Math.round(time * 30), sceneId);
  }

  pauseSceneAudioPool() {
    this.sceneAudioPool.forEach((el) => {
      if (!el.paused) el.pause();
    });
  }

  // Time reports of the second (deprecated, hidden) timeline. `seek`: its
  // playhead was moved on purpose — the narration is put there, playing or
  // not. Any other update only keeps a running preview going.
  onSecondTimelineTime(time, { seek = false } = {}) {
    this._publishTimelineTime(time);
    if (this.animationScene) this.animationScene.setTime(time);
    if (seek || this._soundPlaying) this.driveSceneNarration(time, { seek });
  }

  getCurrentSceneSoundList() {
    const sceneId =
      this.props.containedViewSelected != 0
        ? this.props.containedViewSelected
        : this.props.navItemSelected;
    const list = this.props.store.getState().undoGroup.present.soundList?.[sceneId];
    return Array.isArray(list) ? list : [];
  }

  getCurrentSceneDurationSec() {
    const sceneId =
      this.props.containedViewSelected != 0
        ? this.props.containedViewSelected
        : this.props.navItemSelected;
    const navItem = this.props.store.getState().undoGroup.present.navItemsById?.[sceneId];
    return (navItem?.duration || 0) / 30;
  }

  // A loopScene sound's authored window (startTime/endTime) is one tile's
  // period, not its real lifetime — it plays on repeat until the scene ends.
  // Mirrors the tiling in common/sceneTimeline.es6 without rebuilding the
  // whole scene timeline on every preview tick.
  getSoundWindow(sound, t, sceneDurationSec) {
    const startTime = sound.startTime || 0;
    if (sound.loopScene) {
      const period = sound.endTime > startTime ? sound.endTime - startTime : sound.duration || 0;
      const loopEnd = sceneDurationSec > 0 ? sceneDurationSec : sound.endTime;
      const inWindow = period > 0 && startTime <= t && t < loopEnd;
      return {
        inWindow,
        audioTime: inWindow ? ((t - startTime) % period) + (sound.audioOffset || 0) : 0,
        clipSec: period,
        loopRound: inWindow ? Math.floor((t - startTime) / period) : null,
      };
    }
    return {
      inWindow: startTime <= t && sound.endTime > t,
      audioTime: t - startTime + (sound.audioOffset || 0),
      clipSec: sound.endTime - startTime,
      loopRound: null,
    };
  }

  getSceneAudioSync(sound) {
    const key = this.sceneAudioKey(sound);
    let sync = this.sceneAudioSync.get(key);
    if (!sync) {
      sync = createAudioSyncState();
      sync.isNew = true;
      this.sceneAudioSync.set(key, sync);
    }
    return sync;
  }

  // Stops and forgets pool elements whose piece is gone (deleted, or its file
  // or start changed) — also while playing.
  pruneSceneAudioPool(sounds) {
    const keys = new Set(sounds.filter((s) => s && s.file).map((s) => this.sceneAudioKey(s)));
    [...this.sceneAudioPool.keys()].forEach((key) => {
      if (!keys.has(key)) this.dropSceneAudio(key);
    });
  }

  // `all`: every piece, for a retry. Read by pool key so a fallback element is what is checked.
  narrationHolders(time, { all = false } = {}) {
    const sceneDurationSec = this.getCurrentSceneDurationSec();
    const out = [];
    this.getCurrentSceneSoundList().forEach((sound) => {
      if (!sound || !sound.file || sound.visible === false) return;
      if (!all && !this.getSoundWindow(sound, time, sceneDurationSec).inWindow) return;
      const key = this.sceneAudioKey(sound);
      this.getSceneAudio(sound);
      out.push(
        elementHolder(`nar:${key}`, "audio", () => this.sceneAudioPool.get(key), {
          startSec: sound.startTime || 0,
        })
      );
    });
    return out;
  }

  // A play request (first start, resume, start after a seek), in the task
  // the timeline clock starts in.
  startSceneNarration(time) {
    wakeAudioGraph();
    this.driveSceneNarration(time);
  }

  // The one place that starts, positions and stops the scene narration, one
  // pool element and one sync state per piece.
  // `seek`: the playhead was moved — only then is a piece put on the playhead;
  // a start reached by playing begins at its in-point (audioOffset) and a
  // resume continues where the piece stopped.
  driveSceneNarration(time, { seek = false } = {}) {
    const sceneDurationSec = this.getCurrentSceneDurationSec();
    const sounds = this.getCurrentSceneSoundList();
    this.pruneSceneAudioPool(sounds);
    sounds.forEach((sound) => {
      if (!sound || !sound.file) return;
      const el = this.getSceneAudio(sound);
      const sync = this.getSceneAudioSync(sound);
      const { inWindow, audioTime, clipSec, loopRound } = this.getSoundWindow(
        sound,
        time,
        sceneDurationSec
      );
      const inSec = sound.audioOffset || 0;
      if (!inWindow) {
        if (!el.paused) el.pause();
        // Reaching it (again) starts from the in-point: the piece is put
        // there now, once per in-point, so that the start itself has nothing
        // to wait for. A changed trim moves it again.
        if (sync.parkedAt !== inSec) {
          resetAudioSync(sync);
          seekAudioSync(sync, el, inSec);
          sync.parkedAt = inSec;
        }
        sync.loopRound = null;
        sync.rejoin = false;
        sync.isNew = false;
        return;
      }
      sync.parkedAt = null;
      // Hidden (eye-toggled) sounds must not play in preview. Showing one
      // again is not a start: it joins at the playhead.
      if (sound.visible === false) {
        if (!el.paused) el.pause();
        sync.rejoin = true;
        return;
      }
      sync.deferRate = isRouted(el);
      // A piece that appears mid-way while playing (shown again, or its
      // source was just replaced) is put on the playhead once.
      const rejoin = sync.rejoin || (sync.isNew && this._soundPlaying && audioTime - inSec > 0.2);
      sync.rejoin = false;
      sync.isNew = false;
      // loopScene: a new round restarts the piece on purpose; that is not a
      // sync correction (and the file may have ended by itself).
      const newRound = loopRound != null && sync.loopRound != null && loopRound !== sync.loopRound;
      sync.loopRound = loopRound;
      if (seek || newRound || rejoin) seekAudioSync(sync, el, audioTime);
      if (this._soundPlaying) {
        driveAudioSync(sync, el, audioTime, this._previewSpeed, inSec + clipSec, inSec);
      }
    });
  }

  // Buffer the selected scene's narrations before playback so play() starts in
  // sync; otherwise the sources load lazily on play (~1s) and the audio starts late.
  preloadSceneNarration() {
    const sceneId =
      this.props.containedViewSelected != 0
        ? this.props.containedViewSelected
        : this.props.navItemSelected;
    if (!sceneId) return;
    const sounds = this.props.store.getState().undoGroup.present.soundList?.[sceneId];
    const list = Array.isArray(sounds) ? sounds.filter((s) => s && s.file) : [];
    // A removed piece is stopped at once, playing or not; new ones are only
    // loaded ahead while nothing plays (the driver creates them otherwise).
    this.pruneSceneAudioPool(list);
    if (this._soundPlaying) return;
    list.forEach((s) => this.getSceneAudio(s));
  }

  componentDidUpdate(prevProps, prevState) {
    // Training language changed: re-translate untouched default texts.
    const prevContentLanguage = normalizeContentLanguage(
      prevProps.globalConfig && prevProps.globalConfig.contentLanguage
    );
    const nextContentLanguage = normalizeContentLanguage(
      this.props.globalConfig && this.props.globalConfig.contentLanguage
    );
    if (prevContentLanguage && nextContentLanguage && prevContentLanguage !== nextContentLanguage) {
      updateDefaultTextsToContentLanguage(
        this.props.store.getState().undoGroup.present.pluginToolbarsById,
        this.props.dispatch,
        updatePluginToolbar
      );
    }
    // Read-and-clear: dispatch(selectBox) is synchronous, so the first
    // componentDidUpdate after a timeline handler sets this flag is the one
    // it targets.
    const suppressAutoPanel = this._suppressAutoPanelOnce;
    this._suppressAutoPanelOnce = false;

    // Over-box pill vs. right-rail drawer (see utils/rightDrawerPill.js).
    const pillDismissStale = isPillDismissalStale({
      pillHiddenForTab: this.state.pillHiddenForTab,
      activeTab: this.state.rightActiveTab,
      selectionChanged: prevProps.boxSelected !== this.props.boxSelected,
    });
    if (pillDismissStale) this.setState({ pillHiddenForTab: null });
    // Same body-class hook ToolsPanel and the crop overlay use to get out of
    // the pill's way (_editorBox.scss) — the pill's portal outranks every
    // drawer on z-index, so hiding it is the only way to uncover them.
    document.body.classList.toggle(
      "right-drawer-open",
      !!this.state.pillHiddenForTab && !pillDismissStale
    );
    document.body.classList.toggle("style-copy-mode", !!this.state.styleCopyMode);

    // Drive the Save-button status color: yellow when the doc differs from the
    // last saved baseline, green when in sync. Reuses the same signature the
    // autosave tick and unsaved-changes guard diff against, so it flips green
    // the instant any save path updates _autosaveLastSignature (each also does
    // a setState, which re-enters here). Guarded to only setState on a real
    // transition.
    //
    // A server load (IMPORT_STATE) replaces content wholesale — that's the
    // just-saved server state, not an unsaved edit — so re-sync the baseline
    // to it here, synchronously with the render that first shows the loaded
    // content. Without this the mount-time (pre-import) baseline briefly
    // differs from the loaded content and the indicator flashes yellow before
    // the async re-seed catches up. Skip when the load is a restored local
    // draft (unsavedWorkRestored): that genuinely IS unsaved, so it must stay
    // yellow (baseline left null → treated as changed).
    if (this.props.lastActionDispatched === IMPORT_STATE && !this.unsavedWorkRestored) {
      this._autosaveLastSignature = getUndoSignature(this.props.store.getState().undoGroup);
    }
    const unsaved = hasUndoSignatureChanged(
      this._autosaveLastSignature,
      getUndoSignature(this.props.store.getState().undoGroup)
    );
    window.aideaDirty = unsaved; // read by window.aideaBridge.isDirty()
    if (unsaved !== this.state.hasUnsavedChanges) {
      this.setState({ hasUnsavedChanges: unsaved });
    }

    if (this.props.boxes !== prevProps.boxes) {
      this.migrateTextAnimations();
      this._pruneLayerTimes();
    }

    // Complete a pending DragDrop inline "+ area" once its new answer child has
    // been created by the template render.
    if (this.pendingDndInsert && this.props.boxes !== prevProps.boxes) {
      this.reconcilePendingDndInsert();
    }

    // Preload narration when the scene changes or new data (e.g. training load) arrives.
    if (
      this.props.navItemSelected !== prevProps.navItemSelected ||
      this.props.containedViewSelected !== prevProps.containedViewSelected ||
      this.props.lastActionDispatched !== prevProps.lastActionDispatched
    ) {
      this.preloadSceneNarration();
    }

    // When a new box is added and selected, if the right panel isn't already on the properties tab, switch to it (unless the added box's plugin config opts out of this behavior)
    if (
      !suppressAutoPanel &&
      this.props.lastActionDispatched === "ADD_BOX" &&
      this.props.boxes !== prevProps.boxes &&
      this.props.boxSelected &&
      this.props.boxes[this.props.boxSelected] &&
      !(prevProps.boxes && prevProps.boxes[this.props.boxSelected]) &&
      this.state.rightActiveTab !== "properties"
    ) {
      const tb = this.props.pluginToolbars[this.props.boxSelected];
      const api = tb ? IdealStudio.Plugins.get(tb.pluginId) : null;
      const cfg = api ? api.getConfig() : null;
      if (cfg && cfg.fullScreenOverlay) {
        const tab = tb.pluginId === "InteractivePlugin" ? "elements" : "properties";
        this.setState({ rightActiveTab: tab, activeAccordionKey: null });
      }
    }

    if (prevProps.boxSelected !== this.props.boxSelected && !this.props.boxSelected) {
      if (this.state.rightActiveTab === "animation") {
        this.setState({ rightActiveTab: null });
      }
    }

    // When user selects an InteractivePlugin box, auto-switch right panel to elements tab.
    if (
      !suppressAutoPanel &&
      prevProps.boxSelected !== this.props.boxSelected &&
      this.props.boxSelected &&
      this.props.pluginToolbars[this.props.boxSelected]?.pluginId === "InteractivePlugin" &&
      this.state.rightActiveTab !== "elements"
    ) {
      this.setState({ rightActiveTab: "elements" });
    }

    // Görsel bir kutu seçildiğinde "Ayarlar" (properties) sekmesi görsellerde
    // gizli olduğu için, açık kalan properties sekmesini "Araçlar" (tools) ile
    // değiştir. Böylece görsele tıklayınca doğrudan araçlar paneli gelir.
    if (
      !suppressAutoPanel &&
      prevProps.boxSelected !== this.props.boxSelected &&
      this.props.boxSelected &&
      this.state.rightActiveTab === "properties"
    ) {
      const _tb = this.props.pluginToolbars[this.props.boxSelected];
      const _pid = (_tb?.pluginId || "").toLowerCase();
      const _isImg =
        _pid.includes("image") ||
        _pid.includes("photo") ||
        _pid.includes("hotspot") ||
        _pid === "shapes";
      if (_isImg && _tb?.pluginId !== "InteractivePlugin") {
        this.setState({ rightActiveTab: "tools" });
      }
    }

    const startsWithCV = (val) => typeof val === "string" && val.startsWith("cv");

    const isContainedView =
      startsWithCV(prevProps?.navItemSelected) ||
      startsWithCV(prevProps?.indexSelected) ||
      startsWithCV(this.props?.navItemSelected) ||
      startsWithCV(this.props?.indexSelected);

    if (isContainedView) {
      return;
    }

    if (prevProps.navItemSelected !== this.props.navItemSelected) {
      this.remotionTimelineRef.current?.handleStop();
      this.handleUndefinedNavItemSelected();
    }

    if (prevProps.indexSelected !== this.props.indexSelected) {
      this.handleUndefinedIndexSelected();
    }

    if (
      prevProps.containedViewSelected !== this.props.containedViewSelected &&
      this.props.containedViewSelected === 0
    ) {
      this.handleUndefinedContainedViewSelected();
    }

    // Plugin toolbars değiştiğinde font'ları yeniden yükle
    if (prevProps.pluginToolbars !== this.props.pluginToolbars) {
      this.loadEditorFonts();
    }
  }

  _doLmsExport(overWrite) {
    this.lmsExporter.doExport(overWrite);
  }

  _loadSubtitleBundleForScormExport = async () => {
    // SCORM offline runtime does not allow studio API calls.
    // So we fetch the complete subtitle bundle here and embed it into the SCORM zip.
    const trainingId = window.idealStudioTrainingId;
    if (this._subtitleBundleCache && this._subtitleBundleCacheKey === trainingId) {
      return this._subtitleBundleCache;
    }

    if (!trainingId || !window.ideaLibraryRootUrl) {
      return null;
    }

    const languagesResponse = await fetchSubtitleLanguages();
    let languages = [];
    if (Array.isArray(languagesResponse)) {
      languages = languagesResponse;
    } else if (languagesResponse && Array.isArray(languagesResponse.availableLanguages)) {
      languages = languagesResponse.availableLanguages;
    } else if (languagesResponse && Array.isArray(languagesResponse.data)) {
      languages = languagesResponse.data;
    }

    const languageCodes = Array.from(
      new Set(
        (languages || [])
          .map((langObj) => {
            if (!langObj) return null;
            if (typeof langObj === "string") return langObj;
            return langObj.languageCode || langObj.langCode || langObj.code || null;
          })
          .filter(Boolean)
      )
    );

    const subtitlesByLanguage = {};

    for (const langCode of languageCodes) {
      try {
        const data = await fetchAllSubtitlesForLanguage(langCode);

        let scenesArray = [];
        if (Array.isArray(data)) scenesArray = data;
        else if (data && Array.isArray(data.scenes)) scenesArray = data.scenes;
        else if (data && Array.isArray(data.data)) scenesArray = data.data;

        const transcriptsByScene = {};
        if (scenesArray && scenesArray.length > 0) {
          scenesArray.forEach((scene) => {
            let transcript = null;
            if (scene && scene.subtitle && scene.subtitle.transcript) {
              transcript = scene.subtitle.transcript;
            } else if (scene && scene.transcript) {
              transcript = scene.transcript;
            }

            if (transcript) {
              const sceneId = (scene && (scene.navId || scene.id || scene.sceneId)) || null;
              if (sceneId) transcriptsByScene[sceneId] = transcript;
            }
          });
        }

        subtitlesByLanguage[langCode] = transcriptsByScene;
      } catch (err) {
        console.error(`Subtitle fetch failed for ${langCode}:`, err);
        subtitlesByLanguage[langCode] = {};
      }
    }

    this._subtitleBundleCache = {
      languages: languages || [],
      subtitlesByLanguage,
    };
    this._subtitleBundleCacheKey = trainingId;

    return this._subtitleBundleCache;
  };

  loadEditorFonts() {
    this.fontLoader.loadFonts();
    // Brand-kit fonts are files in our storage, not Google Fonts: register
    // them so text set in one renders right after a reload. Never throws.
    loadOrgBrandFonts();
  }

  handleFontLinkModalConfirm() {
    this.fontLoader.handleFontLinkModalConfirm();
  }

  handleFontLinkModalCancel() {
    this.fontLoader.handleFontLinkModalCancel();
  }

  handleFontModalCancel() {
    this.fontLoader.handleFontModalCancel();
  }

  /**
   * After component mounts
   * Loads plugin API and sets listeners for plugin events, marks and keyboard keys pressed
   */
  componentDidMount() {
    this._layerSession = editorLayerTimes.startSession();
    // aideaBridge: saves/reloads made outside this component must move the
    // unsaved-changes baseline too, or aideaDirty stays true after them.
    window.aideaMarkSaved = (state) => {
      this._autosaveLastSignature = getUndoSignature(
        (state || this.props.store.getState()).undoGroup
      );
      this.setState({ autosavePulseVisible: false });
    };
    setMandatoryPopupForceUpdate(() => this.forceUpdate());

    this._unsubscribeStyleClipboard = subscribeStyleClipboard((payload) =>
      this.setState({ styleCopyMode: !!payload })
    );
    // Any click on the top bar or right rail ends style-copy mode. Capture phase,
    // so "copy style" itself clears then re-copies. Canvas, scene list and
    // timeline are left alone: pasting in another scene is part of the flow.
    this._styleCopyChromeCancel = (e) => {
      if (!this.state.styleCopyMode) return;
      const el = e.target;
      if (el && el.closest && el.closest("#iconBar, .rightIconStrip")) clearStyleClipboard();
    };
    document.addEventListener("mousedown", this._styleCopyChromeCancel, true);

    this.loadEditorFonts();

    // Preload the first scene's narration (if data is ready).
    this.preloadSceneNarration();

    // UI language only; training content keeps globalConfig.contentLanguage.
    this._i18nLanguageHandler = () => {
      this.forceUpdate();
    };
    i18n.on("languageChanged", this._i18nLanguageHandler);

    // Toolbar'ın (EditorShortcuts) ✨ Aidea Wizard butonu merkezi modal yerine sağdaki
    // Aidea Wizard panelini açsın — right strip'teki Aidea Wizard ikonuyla aynı yüzey.
    this._openMerlinPanelHandler = (e) => {
      // On an editable image the AI Wizard is the Görseli Düzenle modal, same
      // as a click on the rail's AI Wizard tab.
      const boxId = e?.detail?.boxId || this.props.boxSelected;
      const url = (this.props.pluginToolbars?.[boxId]?.state?.url || "").toLowerCase();
      if (boxId && boxId !== -1 && url && !MERLIN_UNSUPPORTED_EXT.test(url)) {
        this._openAreaOps(boxId);
        return;
      }
      if (boxId && boxId !== -1 && this._isAnimatedImageBox(boxId)) {
        this._openAnimationWizard(boxId);
        return;
      }
      // The pill's own ✨ button opens this drawer, so the pill has to step
      // aside here too — otherwise it covers the dialog it just opened. Same
      // rule as a rail click; see utils/rightDrawerPill.js.
      this.setState({
        rightActiveTab: "merlin",
        pillHiddenForTab: pillDismissalForTab("merlin", !!this.props.boxSelected),
      });
    };
    window.addEventListener("aidea:openMerlinPanel", this._openMerlinPanelHandler);
    // The canvas pill's animation popup (EditorShortcuts) asks for the same
    // "Görseli Düzenle" round trip as this file's own popup.
    this._editAnimationSourceHandler = (e) => this._editAnimationSource(e.detail || {});
    window.addEventListener("aidea:editAnimationSource", this._editAnimationSourceHandler);
    this._openDirectorProjectHandler = (e) => this.openDirectorVideoModal(null, e.detail || {});
    window.addEventListener("aidea:openDirectorProject", this._openDirectorProjectHandler);

    window.showServerModal = (title, message, isSuccess) => {
      this.setState({
        serverModalTitle: title,
        serverModalMessage: message,
        serverModalSuccess: isSuccess,
        serverModal: true,
      });
    };

    let _id = window.idealStudioTrainingId;
    let _tenantId = window.tenantId;
    // R10: opened with ?id only while this course builds (or is paused after scene 1) → restore the build view
    // (lock + live job + chat) instead of an unlocked editor over a building course.
    if (!BUILD_PARAMS) this._restoreActiveBuild();

    // //  state testi için
    // _id=-1;

    // Check LMS connection status and voice profile (both independent of importStateAsync)
    if (_id != null && _id !== "") {
      _LSCheckLmsStatus(_id).then((lmsStatus) => {
        // console.log("_LSCheckLmsStatus result:", lmsStatus);
        this.setState({
          isLmsConnect: lmsStatus.isLmsConnect || false,
          lmsLogCreatedAt: lmsStatus.LmsLog?.createdAt || null,
        });
      });

      fetchVoiceProfile(_id).then((profile) => {
        if (profile) {
          this.setState({ voiceProfile: profile });
          window.idealStudioVoiceProfile = profile;
        }
        this._voiceProfileSettled = true;
        this.seedContentLanguage();
      });
    } else {
      this._voiceProfileSettled = true;
    }
    // No server import will land (standalone, restored draft, live build).
    if (!(_id != null && _id !== "" && !this.unsavedWorkRestored && !BUILD_PARAMS)) {
      this._serverStateImported = true;
      this.seedContentLanguage();
    }

    // Only fetch state from server if unsaved work was NOT restored
    // If unsaved work was restored, we want to keep that state instead
    if (_id != null && _id !== "" && !this.unsavedWorkRestored && !BUILD_PARAMS) {
      this.setState(
        {
          trainingId: _id,
        },
        () => {
          this.props.dispatch(
            importStateAsync(_id, _tenantId, (response) => {
              this.setState({
                baseUrl: response.baseUrl || "",
                trainingId: response.id || _id,
                trainingName: response.name || "",
                informationText: response.informationText || "",
                aiOutput: response.aiOutput || null,
                createdWithAI: response.createdWithAI || false,
                lmsContentId: response.lmsContentId || null,
                createdAt: response.createdAt || null,
              });
              // Seed the save-conflict token (see common/saveConflict.es6) --
              // the baseline every save from here on echoes back until the
              // next successful save/reload updates it.
              setBaseUpdatedAt(response.updatedAt);
              // The callback fires BEFORE the IMPORT_STATE dispatch lands in the
              // store (see common/actions.es6 importStateAsync). Defer the
              // empty-training detection to the next tick so the store is
              // populated when we read it.
              setTimeout(() => {
                if (isBuildLocked()) return; // R10 restore landed first: no GlobalConfig/draft modal over the build view
                this.props.dispatch(migrateLegacyGuides());
                this.props.dispatch(migrateLegacySoundLists());
                this.runLegacyHeaderMigration();
                this.detectAndForceGlobalConfigIfEmpty();
                this.detectLegacyMediaTimeline();
                // Baseline for the unsaved-changes guard: this is the
                // just-loaded, server-saved state, so nothing should look
                // "unsaved" yet.
                this._autosaveLastSignature = getUndoSignature(
                  this.props.store.getState().undoGroup
                );
                this._serverStateImported = true;
                this.seedContentLanguage();
                this._checkLocalDraft(response.updatedAt);
              }, 0);
            })
          );
        }
      );
    } else {
      // No training id (standalone) or unsaved work already restored above —
      // neither path fetches, so mark the editor loaded now (otherwise a
      // later runtime error would be misclassified as a first-load failure).
      markEditorLoaded();
    }

    if (process.env.NODE_ENV === "production" && process.env.DOC === "doc") {
      // window.parent.addEventListener("beforeunload", this.beforeUnloadAlert); // it is done outside
      window.oncontextmenu = function () {
        return false;
      };
    }
    // setTimeout(()=>{this.setState({ showHelpButton: false });}, 30000);
    this.keyboardListener.addListener();
    // document.addEventListener('onbeforeunload', this.exitListener);

    if (cookies.get("idealStudio_visitor") === undefined) {
      cookies.set("idealStudio_visitor", true);
    }

    // Opt-in autosave: one interval for the component's lifetime, gated
    // internally by _autosaveTick so toggling the checkbox never has to
    // create/destroy timers. Every tick recomputes the unsaved-changes pulse
    // and, when due, fires a real (quiet-mode) save — see _autosaveTick().
    this._autosaveIntervalId = setInterval(this._autosaveTick, AUTOSAVE_INTERVAL_MS);
    // Seed the guard's baseline synchronously, right before arming it.
    // Without this, _autosaveLastSignature is still the constructor's `null`
    // and hasUndoSignatureChanged() treats "no baseline" as "always changed"
    // (see autosaveDecision.es6) -- so a Back-press or tab-close during the
    // mount -> server-response round trip would warn on an untouched
    // document. The async re-seed above (once importStateAsync's response
    // lands) overwrites this with the authoritative post-import signature.
    // Skip when unsaved work was restored: that draft was never saved to the
    // server, so seeding from it would mark it "already saved" and silently
    // suppress the unsaved-changes guard for exactly the case it protects.
    if (!this.unsavedWorkRestored) {
      this._autosaveLastSignature = getUndoSignature(this.props.store.getState().undoGroup);
    }
    this._unsavedChangesGuard.addListener();

    // Local draft: drop stale ones, then back up unsaved work (debounced) once
    // the open-time prompt (_checkLocalDraft) has been settled.
    purgeOldDrafts();
    this._draftScheduler = createDraftScheduler(this._writeLocalDraft);
    this._unsubscribeDraft = this.props.store.subscribe(() => {
      const present = this.props.store.getState().undoGroup.present;
      // Deferred while the new-training config modal owned the screen: once it
      // closes, offer the draft first; writes stay off until the prompt settles.
      if (this._draftDeferred && !this.state.globalConfigForced) {
        this._draftDeferred = false;
        this._checkLocalDraft(this._draftServerUpdatedAt);
      }
      if (!this._draftReady || present === this._lastDraftPresent) return;
      this._lastDraftPresent = present;
      this._draftScheduler.poke();
    });
  }

  _writeLocalDraft = () => {
    const state = this.props.store.getState();
    if (!hasUndoSignatureChanged(this._autosaveLastSignature, getUndoSignature(state.undoGroup))) {
      return; // matches the last server save: nothing to protect
    }
    // Serializing a huge state is the expensive part: do it when the browser is idle.
    const write = () =>
      saveDraftFromState(window.idealStudioTrainingId, this.props.store.getState(), getUserId());
    if (window.requestIdleCallback) window.requestIdleCallback(write, { timeout: 5000 });
    else setTimeout(write, 0);
  };

  // Right after a training loads: if a local draft exists for it (same user,
  // different content), ask whether to open it. Drafts are only written once
  // this has settled so a fresh load can't overwrite the draft being offered.
  async _checkLocalDraft(serverUpdatedAt) {
    const trainingId = window.idealStudioTrainingId;
    const userId = getUserId();
    if (!userId) {
      // Nothing could ever be offered back without a user (drafts aren't written either).
      this._draftReady = true;
      return;
    }
    let draft = await getDraft(trainingId, userId);
    if (!draft) {
      draft = takeLegacyDraft(trainingId, userId);
      if (draft) await putDraft(trainingId, draft);
    }
    if (isBuildLocked()) return; // R10 restore landed during the lookup: no draft modal over the build view
    const { prompt, serverNewer } = decideDraftPrompt({
      draft,
      userId,
      currentSignature: getContentSignature(this.props.store.getState()),
      serverUpdatedAt,
    });
    if (prompt) {
      // No popup over a popup: the new-training config modal owns the screen;
      // the draft is kept and offered on the next open; writing resumes once
      // the modal closes.
      if (this.state.globalConfigForced) {
        this._draftDeferred = true;
        this._draftServerUpdatedAt = serverUpdatedAt;
        return;
      }
      this.setState({
        localDraftPrompt: { draft, serverNewer, phase: "choose" },
        legacyTimelineRepair: null,
      });
      return;
    }
    if (draft && draft.userId === userId) deleteDraft(trainingId, userId); // identical to the server copy
    this._draftReady = true;
  }

  // One modal, two phases (no popup over a popup): "choose" -> accept opens the
  // draft, decline moves to "confirmDiscard" in the same dialog.
  _onLocalDraftDecision = (accepted) => {
    const prompt = this.state.localDraftPrompt;
    if (!prompt) return;
    if (prompt.phase === "choose" && !accepted) {
      this.setState({ localDraftPrompt: { ...prompt, phase: "confirmDiscard" } });
      return;
    }
    if (prompt.phase === "confirmDiscard" && !accepted) {
      this.setState({ localDraftPrompt: { ...prompt, phase: "choose" } });
      return;
    }
    if (prompt.phase === "choose") {
      // Imported like the server load, but left dirty (the save baseline stays
      // the server's, so the normal conflict flow arbitrates the next save).
      try {
        this.unsavedWorkRestored = true;
        this.props.dispatch(importState(serialize(JSON.parse(prompt.draft.exportedState))));
        this.props.dispatch(migrateLegacyGuides());
        this.props.dispatch(migrateLegacySoundLists());
        window.dispatchEvent(
          new CustomEvent(LOCAL_DRAFT_NOTICE_EVENT, { detail: { kind: "loaded" } })
        );
      } catch (e) {
        console.warn("Local draft could not be opened:", e);
      }
    } else {
      deleteDraft(window.idealStudioTrainingId, getUserId());
    }
    this.setState({ localDraftPrompt: null }, () => {
      this._draftReady = true;
      this.detectLegacyMediaTimeline();
    });
  };

  componentWillUnmount() {
    this._endLayerSession();
    delete window.aideaMarkSaved;
    this._unsubscribeDraft?.();
    this._draftScheduler?.cancel();
    document.body.classList.remove("right-drawer-open");
    this._unsubscribeStyleClipboard?.();
    document.removeEventListener("mousedown", this._styleCopyChromeCancel, true);
    this.keyboardListener.removeListener();
    this._unsavedChangesGuard.removeListener();
    this.globalDragDrop.removeListeners();
    this.pruneSceneAudioPool([]);
    window.removeEventListener("message", this.handleWidgetMessage);
    if (this._animPanelOutsideClick) {
      document.removeEventListener("mousedown", this._animPanelOutsideClick);
    }
    if (this._i18nLanguageHandler) {
      i18n.off("languageChanged", this._i18nLanguageHandler);
    }
    if (this._openDirectorProjectHandler) {
      window.removeEventListener("aidea:openDirectorProject", this._openDirectorProjectHandler);
    }
    if (this._openMerlinPanelHandler) {
      window.removeEventListener("aidea:openMerlinPanel", this._openMerlinPanelHandler);
    }
    if (this._editAnimationSourceHandler) {
      window.removeEventListener("aidea:editAnimationSource", this._editAnimationSourceHandler);
    }
    if (this._autosaveIntervalId) {
      clearInterval(this._autosaveIntervalId);
    }
    // document.removeEventListener('onbeforeunload', this.exitListener);

    // Clean up global callback
    if (window.showServerModal) {
      delete window.showServerModal;
    }
  }

  // Single source of truth for both the navbar checkbox and the ask-on-load
  // prompt — answering the prompt flips the same state the checkbox reflects,
  // and always marks the prompt as answered so it doesn't come back this
  // session. Never persisted (no localStorage/sessionStorage): a fresh
  // browser load always re-runs the constructor with autosaveEnabled: false.
  _setAutosaveEnabled(enabled) {
    if (enabled) {
      // Baseline so the next tick doesn't pulse/save on stale changes from
      // before autosave was turned on.
      this._autosaveLastSignature = getUndoSignature(this.props.store.getState().undoGroup);
    }
    this.setState({
      autosaveEnabled: enabled,
      // Re-toggling (either direction) clears a prior failure/conflict
      // suspension without requiring a manual save first — never during a build.
      autosaveSuspended: isBuildLocked(),
      autosavePromptDismissed: true,
      // Toggling off should silence any pulse immediately; toggling on
      // starts from a fresh baseline, so nothing to pulse yet either.
      autosavePulseVisible: false,
    });
  }

  // Pre-timeline content check, run once per load right after the state lands.
  // Those media boxes have no persisted timeline window, which is invisible to
  // the recorder's manifest builder: their audio never reaches a video export
  // and the scene collapses to the min-time floor. Cheap scan (no network) —
  // the media probing only happens if the user accepts the repair.
  detectLegacyMediaTimeline = () => {
    // No popup over a popup: the brand-new-training config modal and the
    // local-draft prompt both own the screen at this moment.
    if (this.state.globalConfigForced || this.state.localDraftPrompt) return;
    const present = this.props.store.getState().undoGroup.present;
    const legacy = findLegacyMediaBoxes(
      present.boxesById,
      present.pluginToolbarsById,
      present.animationsById
    );
    if (legacy.length > 0) {
      this.setState({
        legacyTimelineRepair: {
          videos: legacy.filter((box) => box.type === "video").length,
          audios: legacy.filter((box) => box.type === "audio").length,
          scenes: new Set(legacy.map((box) => box.parent)).size,
        },
      });
    }
  };

  // Repairs every legacy media box, then saves — the export reads the SERVER
  // copy, so an unsaved repair would fix nothing. One undoable step; the
  // dialog stays open on failure so the user can retry or dismiss.
  _repairMediaTimeline = async (onProgress) => {
    const report = await collectMediaTimelinePatches({
      boxes: this.props.boxes,
      pluginToolbars: this.props.pluginToolbars,
      animationsById: this.props.animationsById,
      probe: getMediaDuration,
      onProgress,
    });
    if (report.repaired === 0) {
      throw new Error("legacy timeline repair produced no usable durations");
    }

    this.props.dispatch(repairMediaTimelines(report.patches));
    await new Promise((resolve, reject) => {
      ideaEnvSaveState(
        { ...this.props.store.getState() },
        false,
        resolve,
        reject,
        false, // force
        true // quiet: the dialog already reports progress
      );
    });
    this._autosaveLastSignature = getUndoSignature(this.props.store.getState().undoGroup);

    this.setState({ legacyTimelineRepair: null });
    return report;
  };

  // Single entry point for every save path's 409 signal -- keeps the "which
  // modal must close first" decision (no popup over a popup) in one place
  // instead of copied at each of the five save call sites. Both ExitModal
  // and UnsavedChangesGuardModal ask a version of the same "what should
  // happen to this save" question the conflict dialog now needs to ask
  // instead, so they close rather than stack underneath it.
  _openSaveConflict(currentUpdatedAt) {
    this.setState({
      showExitModal: false,
      showUnsavedChangesGuard: false,
      unsavedChangesGuardSaving: false,
      saveConflict: { currentUpdatedAt, phase: null },
    });
  }

  // "Overwrite with my version": resend the exact same save minus
  // baseUpdatedAt (force=true) so the server skips the check entirely. A
  // force-resend can't itself conflict (there's no token to compare), so
  // onError here only has to handle an unrelated failure -- the pre-existing
  // generic "Hata" modal (server_utils.es6) already explains those; this
  // just stops the button from showing "Saving…" forever.
  _overwriteSaveConflict() {
    this.setState((prev) => ({
      saveConflict: prev.saveConflict && { ...prev.saveConflict, phase: "overwriting" },
    }));
    ideaEnvSaveState(
      { ...this.props.store.getState() },
      false,
      () => {
        this._autosaveLastSignature = getUndoSignature(this.props.store.getState().undoGroup);
        this.setState({
          saveConflict: null,
          autosavePulseVisible: false,
          autosaveSuspended: isBuildLocked(),
        });
      },
      () => {
        this.setState((prev) => ({
          saveConflict: prev.saveConflict && { ...prev.saveConflict, phase: null },
        }));
      },
      true
    );
  }

  // Build mode: re-import the server copy after each finished scene (BuildChat),
  // keeping the scene the user is looking at. Resolves once the store has it.
  // The thunk's promise settles after IMPORT_STATE (or after its own catch), so a
  // failed import never hangs BuildChat's import chain. The mount import is skipped
  // in build mode, so the same training fields are seeded here.
  _importBuildProgress = () => {
    const keep = this.props.store.getState().undoGroup.present.navItemSelected;
    const _id = window.idealStudioTrainingId;
    return Promise.resolve(
      this.props.dispatch(
        importStateAsync(_id, window.tenantId, (response) => {
          this.setState({
            baseUrl: response.baseUrl || "",
            trainingId: response.id || _id,
            trainingName: response.name || "",
            createdWithAI: response.createdWithAI || false,
            createdAt: response.createdAt || null,
          });
          setBaseUpdatedAt(response.updatedAt);
        })
      )
    ).then(() => {
      const present = this.props.store.getState().undoGroup.present;
      const byId = present.navItemsById || {};
      // Keep the user's scene; on the first import (a build doc may select no scene)
      // fall back to scene 1 so the reveal lands on it.
      const target = byId[keep]
        ? keep
        : byId[present.navItemSelected]
          ? null
          : (present.navItemsIds || []).find((id) => id !== 0 && byId[id]);
      if (target) this.props.dispatch(selectNavItem(target));
      this._autosaveLastSignature = getUndoSignature(this.props.store.getState().undoGroup);
      return present.navItemsIds; // BuildChat's expired path decides on this
    });
  };

  // Build mode: first scene revealed → mount the standard ChatPanel (BuildChat goes headless).
  _onBuildRevealed = () => this.setState({ buildRevealed: true });

  _onBuildFinished = () => {
    setBuildLocked(false);
    window.history.replaceState(
      null,
      "",
      window.location.pathname + stripBuildParams(window.location.search) + window.location.hash
    );
    this.setState({ autosaveSuspended: false }); // unconditional: also re-renders the held autosave prompt
  };

  // ?id-only open: ask mw for a running/paused build of this course (after the ?code= exchange settled).
  // Nothing running (null) → the normal editor, untouched.
  // The id is read after the exchange: on ?id&code= opens it is set only then.
  _restoreActiveBuild = () =>
    whenEnvironmentReady()
      .then(() => window.idealStudioTrainingId && fetchActiveBuild(window.idealStudioTrainingId))
      .then((active) => {
        const restored = restoredBuildState(active);
        if (!restored || this.state.buildParams) return;
        setBuildLocked(true);
        this._draftDeferred = false; // clearing globalConfigForced below must not replay the deferred draft prompt
        window.history.replaceState(
          null,
          "",
          window.location.pathname +
            withBuildParams(window.location.search, restored.buildParams) +
            window.location.hash
        );
        // The mount import may have opened these before the probe landed.
        this.setState({
          ...restored,
          autosaveSuspended: true,
          showGlobalConfig: false,
          globalConfigForced: false,
          globalConfigMode: "edit",
          localDraftPrompt: null,
          legacyTimelineRepair: null,
        });
      })
      .catch(() => undefined);

  // Continue / Improve started a new job: remount BuildChat on it (key) docked, and point ?job= at it so a reload follows.
  // The lock and the build URL hold across the switch.
  _onBuildJobChanged = (jobId) => {
    window.history.replaceState(
      null,
      "",
      window.location.pathname +
        replaceBuildJob(window.location.search, jobId) +
        window.location.hash
    );
    this.setState((s) => ({
      buildParams: { ...s.buildParams, jobId },
      buildResumed: true,
      buildRevealed: true,
    }));
  };

  // "Reload server copy": discard local edits and re-import the server's
  // current state in place, via the same importStateAsync path already used
  // on mount and on "discard local draft" (handleRestoreDecision above) --
  // a proven re-dispatchable path, not a new one.
  _reloadServerCopy() {
    const _id = window.idealStudioTrainingId;
    const _tenantId = window.tenantId;
    if (_id == null || _id === "") {
      this.setState({ saveConflict: null });
      return;
    }
    this.setState((prev) => ({
      saveConflict: prev.saveConflict && { ...prev.saveConflict, phase: "reloading" },
    }));
    this.props.dispatch(
      importStateAsync(_id, _tenantId, (response) => {
        setBaseUpdatedAt(response.updatedAt);
        // Mirrors the mount-time seed: this callback fires before
        // IMPORT_STATE lands in the store, so defer reading it back out.
        setTimeout(() => {
          this._autosaveLastSignature = getUndoSignature(this.props.store.getState().undoGroup);
          this.setState({
            saveConflict: null,
            autosavePulseVisible: false,
            autosaveSuspended: isBuildLocked(),
          });
        }, 0);
      })
    );
  }

  _autosaveTick() {
    if (this.state.visorVisible) return; // in-editor Preview overlay open
    const trainingId = window.idealStudioTrainingId;
    if (trainingId == null || trainingId === "") return; // no real training to save (standalone/no id)

    const nextSignature = getUndoSignature(this.props.store.getState().undoGroup);

    // The pulse mirrors "is there something unsaved right now" independent
    // of whether a save is about to fire — it's the only signal left while
    // autosave is suspended by an unresolved conflict (see below).
    this.setState({
      autosavePulseVisible: shouldShowUnsavedPulse({
        enabled: this.state.autosaveEnabled,
        prevSignature: this._autosaveLastSignature,
        nextSignature,
      }),
    });

    const isSaving =
      this._autosaveSaving || !!window.bulkAnimateApplying || !!window.animatorPanelSaving;
    const fire = shouldAutosaveTick({
      enabled: this.state.autosaveEnabled,
      suspended: this.state.autosaveSuspended,
      isSaving,
      prevSignature: this._autosaveLastSignature,
      nextSignature,
    });
    if (!fire) return;

    this._autosaveSaving = true;
    ideaEnvSaveState(
      { ...this.props.store.getState() },
      false,
      () => {
        this._autosaveSaving = false;
        this._autosaveLastSignature = nextSignature;
        this.setState({ autosavePulseVisible: false });
      },
      (err) => {
        this._autosaveSaving = false;
        // Don't silently retry or silently give up: pause ticking until the
        // user resolves it (manual save, Overwrite, Reload, or re-toggling
        // the checkbox), and for an actual conflict, surface the same modal
        // every other save path uses.
        this.setState({ autosaveSuspended: true });
        if (err && err.isSaveConflict) {
          this._openSaveConflict(err.currentUpdatedAt);
        }
      },
      false, // force
      true // quiet: no full-screen overlay for a background tick
    );
  }

  beforeUnloadAlert() {
    if (!this.state.publishing) {
      return i18n.t("messages.exit_page");
    }
    return undefined;
  }
  currentPage() {
    return isContainedView(this.props.containedViewSelected)
      ? this.props.containedViews[this.props.containedViewSelected]
      : this.props.navItemSelected !== 0
        ? this.props.navItems[this.props.navItemSelected]
        : null;
  }
  keyListener(e) {
    let key = e.keyCode ? e.keyCode : e.which;
    if (key === 9) {
      if (!tabInDialog(e)) e.preventDefault();
      return;
    }
    // Checks what element has the cursor focus currently.
    // `document.activeElement.className` is NOT always a string — for SVG
    // elements (e.g. Lucide icons inside buttons) it is an `SVGAnimatedString`
    // with `.baseVal`/`.animVal` instead. Calling `.indexOf` on that throws
    // and breaks every keyboard handler (Backspace/Esc/Arrows/Ctrl+Z/...).
    const focusRaw = document.activeElement.className;
    let focus = "";
    if (typeof focusRaw === "string") {
      focus = focusRaw;
    } else if (focusRaw && typeof focusRaw.baseVal === "string") {
      focus = focusRaw.baseVal; // SVGAnimatedString
    } else if (focusRaw && typeof focusRaw.toString === "function") {
      focus = String(focusRaw); // DOMTokenList et al.
    }
    let notText =
      (!document.activeElement.type || focus.indexOf("rib") !== -1) &&
      focus.indexOf("form-control") === -1 &&
      focus.indexOf("tituloCurso") === -1 &&
      focus.indexOf("cke_editable") === -1;

    // Ctrl/⌘ + Z → undo; Ctrl/⌘ + Shift + Z and Ctrl + Y → redo.
    // Skipped while typing (form fields / CKEditor via `notText`, plus plain
    // contentEditable) so the browser's own text undo isn't doubled.
    const undoRedo = getUndoRedoIntent(e);
    if (undoRedo && notText && !tabInDialog(e) && !isContentEditableFocus(document.activeElement)) {
      this.props.dispatch(undoRedo === "redo" ? ActionCreators.redo() : ActionCreators.undo());
    }
    // Ctrl/Cmd + A — select all boxes on the current scene
    if (key === 65 && (e.ctrlKey || e.metaKey) && !this.state.openTextEditor && notText) {
      let boxSelectedData = this.currentPage();
      if (boxSelectedData && boxSelectedData.boxes && boxSelectedData.boxes.length) {
        e.preventDefault();
        // this.props.dispatch(selectBoxAll(Object.keys(this.props.boxes))); // allPageSelect
        this.props.dispatch(selectBoxAll(boxSelectedData.boxes)); // currentPageSelect
      }
    }

    // InteractivePlugin parent box is a fixed container — arrow keys must not
    // translate it. Inline sub-items are managed inside the plugin's own canvas.
    const arrowSelectedToolbar =
      this.props.boxSelected != -1 ? this.props.pluginToolbars[this.props.boxSelected] : null;
    // Arrow keys must not nudge the selected box while the user is typing in a
    // form field (inputs, radios, selects...) or while any modal/dialog is open
    // (e.g. "Add marker" modal) — otherwise the box behind the overlay moves.
    const activeEl = document.activeElement;
    const arrowInFormField =
      !!activeEl &&
      (/^(INPUT|TEXTAREA|SELECT)$/.test(activeEl.tagName) || activeEl.isContentEditable);
    const arrowInOverlay =
      !!(
        activeEl &&
        activeEl.closest &&
        activeEl.closest('.modal, [role="dialog"], .MuiDialog-root, .MuiModal-root')
      ) ||
      !!document.querySelector(
        '.modal.show, .modal.in, [role="dialog"][aria-modal="true"], .MuiDialog-root'
      );
    const arrowBlockInteractive =
      (arrowSelectedToolbar && arrowSelectedToolbar.pluginId === "InteractivePlugin") ||
      arrowInFormField ||
      arrowInOverlay;

    if (
      key === 37 &&
      this.props.boxSelected != -1 &&
      this.props.boxes != null &&
      !this.state.openTextEditor &&
      !arrowBlockInteractive
    ) {
      let box = this.props.boxes[this.props.boxSelected];
      let a = Number(box.position.x.replace("%", ""));
      if (a > 1) {
        let positionX = Number(box.position.x.replace("%", "")) - 1 + "%";
        let positionY = Number(box.position.y.replace("%", "")) + 0 + "%";
        this.props.dispatch(
          moveBox(box.id, positionX, positionY, "absolute", box.parent, box.container)
        );
      }
    }
    if (
      key === 38 &&
      this.props.boxSelected != -1 &&
      this.props.boxes != null &&
      !this.state.openTextEditor &&
      !arrowBlockInteractive
    ) {
      let box = this.props.boxes[this.props.boxSelected];
      let a = Number(box.position.y.replace("%", ""));
      if (a > 1) {
        let positionX = Number(box.position.x.replace("%", "")) + 0 + "%";
        let positionY = Number(box.position.y.replace("%", "")) - 1 + "%";
        this.props.dispatch(
          moveBox(box.id, positionX, positionY, "absolute", box.parent, box.container)
        );
      }
    }
    if (
      key === 39 &&
      this.props.boxSelected != -1 &&
      this.props.boxes != null &&
      !this.state.openTextEditor &&
      !arrowBlockInteractive
    ) {
      let box = this.props.boxes[this.props.boxSelected];
      var boxdiv = document.getElementById("box-" + box.id);
      let a = Number(box.position.x.replace("%", ""));
      let width = 99 - boxdiv.style.width.replace("%", "");
      if (a <= width) {
        let positionX = Number(box.position.x.replace("%", "")) + 1 + "%";
        let positionY = Number(box.position.y.replace("%", "")) + 0 + "%";
        this.props.dispatch(
          moveBox(box.id, positionX, positionY, "absolute", box.parent, box.container)
        );
      }
    }
    if (
      key === 40 &&
      this.props.boxSelected != -1 &&
      this.props.boxes != null &&
      !this.state.openTextEditor &&
      !arrowBlockInteractive
    ) {
      let box = this.props.boxes[this.props.boxSelected];
      var boxdiv = document.getElementById("box-" + box.id);
      let a = Number(box.position.y.replace("%", ""));
      //   console.log("clienheight önce: ", boxdiv.clientHeight)
      //   let height = Number(99 - (boxdiv.clientHeight*0.16));
      if (a <= 95) {
        let positionX = Number(box.position.x.replace("%", "")) + 0 + "%";
        let positionY = Number(box.position.y.replace("%", "")) + 1 + "%";
        this.props.dispatch(
          moveBox(box.id, positionX, positionY, "absolute", box.parent, box.container)
        );
      }
    }

    if (key === 80 && e.ctrlKey && e.shiftKey) {
      e.cancelBubble = true;
      e.preventDefault();

      e.stopImmediatePropagation();
      printToPDF(this.props.store.getState().undoGroup.present, (b) => {
        if (b) {
          alert("Error");
        }
      });
    }

    // Supr
    else if (key === 46 || key === 8) {
      // When an inline sub-item of an InteractivePlugin box is selected, Delete/Backspace
      // must remove ONLY that sub-item — not the parent box and its sibling items.
      //
      // Root cause this branch fixes (was: guard never fired when an item button had
      // focus): the outer `notText` heuristic returns FALSE whenever
      // `document.activeElement.type` is truthy — and item kinds like TrueFalse render
      // `<button type="button">`, MultipleChoice/MultipleAnswer render option buttons,
      // etc. Clicking any of those focuses the button, so `notText` is false and the
      // previous `if (notText)` wrapper short-circuited the guard. The fall-through
      // DELETE_BOX path was also gated on `notText`, so in production Backspace became
      // a no-op once the item button had focus — but the user expects the item to
      // delete.
      //
      // The sub-item guard uses its own stricter "is in a true text-edit context"
      // check (contentEditable / form-control / cke_editable / tituloCurso / actual
      // INPUT[type=text] | TEXTAREA), so it is safe to run regardless of `notText`.
      const activeEl = document.activeElement;
      const activeCls = (activeEl && activeEl.className) || "";
      const activeTag = activeEl && activeEl.tagName;
      const activeType = activeEl && activeEl.type;
      const isTextInput =
        activeTag === "TEXTAREA" ||
        (activeTag === "INPUT" &&
          (!activeType ||
            activeType === "text" ||
            activeType === "search" ||
            activeType === "email" ||
            activeType === "url" ||
            activeType === "password" ||
            activeType === "number" ||
            activeType === "tel"));
      const isContentEditableFocus =
        !!(activeEl && activeEl.isContentEditable) ||
        (typeof activeCls === "string" &&
          (activeCls.indexOf("cke_editable") !== -1 ||
            activeCls.indexOf("form-control") !== -1 ||
            activeCls.indexOf("tituloCurso") !== -1));
      const inTrueTextEdit = isTextInput || isContentEditableFocus;

      // EARLY RETURN: when focus is in a real text-edit context (contentEditable
      // span, INPUT[type=text], TEXTAREA, ...), Backspace/Delete must do nothing
      // at the canvas level — the browser handles per-character deletion. The
      // outer `notText` heuristic does NOT check `isContentEditable`, so without
      // this guard a Backspace inside an EditableOption span would fall through
      // to the DELETE_BOX fallthrough below and destroy the parent box.
      if (inTrueTextEdit) {
        return;
      }

      if (!inTrueTextEdit) {
        const interactivityStudio = this.props.store.getState().interactivityStudio;
        const selectedItemId = interactivityStudio && interactivityStudio.selectedItemId;
        // Fall back to the canvas-level boxSelected when the slice hasn't recorded
        // selectedBoxId (older selection paths, or sub-item selected via ItemFrame
        // before the parent reducer landed). Without this, a real failure mode is
        // "selectedItemId set, selectedBoxId undefined" → guard never fires and
        // Delete falls through to DELETE_BOX on the parent.
        const sliceBoxId = interactivityStudio && interactivityStudio.selectedBoxId;
        const parentBoxId =
          sliceBoxId || (this.props.boxSelected !== -1 ? this.props.boxSelected : null);
        if (selectedItemId && parentBoxId) {
          const parentToolbar = this.props.pluginToolbars[parentBoxId];
          if (parentToolbar && parentToolbar.pluginId === "InteractivePlugin") {
            e.preventDefault();
            e.stopPropagation();
            this.props.dispatch(removeInteractiveItem(parentBoxId, selectedItemId));
            return;
          }
        }
      }
      let boxSelectedAll = this.props.store.getState().undoGroup.present.boxSelectedAll;
      if (boxSelectedAll.length > 1) {
        boxSelectedAll.map((e) => {
          if (e !== -1 && !isSortableBox(e)) {
            // If it is not an input or any other kind of text edition AND there is a box selected, it deletes said box
            if (notText) {
              let box = this.props.boxes[e];
              let toolbar = this.props.pluginToolbars[e];
              if (!box || !toolbar) return;
              if (!toolbar.showTextEditor) {
                this.onBoxDeleted(
                  box.id,
                  box.parent,
                  box.container,
                  this.props.containedViewSelected && this.props.containedViewSelected !== 0
                    ? this.props.containedViewSelected
                    : this.props.navItemSelected
                );
              }
            }
          }
        });
      } else if (this.props.boxSelected !== -1 && !isSortableBox(this.props.boxSelected)) {
        // If it is not an input or any other kind of text edition AND there is a box selected, it deletes said box
        if (notText) {
          let box = this.props.boxes[this.props.boxSelected];
          let toolbar = this.props.pluginToolbars[this.props.boxSelected];
          // scene-audio layer seçiliyse soundList'ten sil
          if (!box || !toolbar) {
            const sceneId =
              this.props.containedViewSelected && this.props.containedViewSelected !== 0
                ? this.props.containedViewSelected
                : this.props.navItemSelected;
            const sounds = this.props.store.getState().undoGroup.present.soundList?.[sceneId] || [];
            const idx = sounds.findIndex((s) => s.id === this.props.boxSelected);
            if (idx !== -1) this.props.dispatch(deleteSound(sceneId, idx));
            return;
          }
          if (!toolbar.showTextEditor) {
            this.onBoxDeleted(
              box.id,
              box.parent,
              box.container,
              this.props.containedViewSelected && this.props.containedViewSelected !== 0
                ? this.props.containedViewSelected
                : this.props.navItemSelected
            );
          }
        }
      }
    } else if (key === 27) {
      const boxSelectedAll = this.props.store.getState().undoGroup.present.boxSelectedAll;
      if (Array.isArray(boxSelectedAll) && boxSelectedAll.length > 0) {
        this.props.dispatch(selectBoxAll(-1));
      }
    }

    if (key === 112) {
      e.preventDefault();
      this.setState({ showHelpButton: true });
    }
    if (key === 113) {
      e.preventDefault();
      this.remotionTimelineRef.current?.handleStop();
      this.setState({ visorVisible: true });
    }
  }
  onBoxDeleted(id, parent, container, page) {
    let bx = getDescendantBoxes(this.props.boxes[id], this.props.boxes);
    let cvs = [...this.props.boxes[id].containedViews];
    bx.map((box) => {
      cvs = [...cvs, ...this.props.boxes[box].containedViews];
    });
    this.props.dispatch(deleteBox(id, parent, container, bx, cvs, page));
  }

  // Single add-box handler for the library/upload paths. Routes through
  // addBoxThunk so a newly-added video's endFrame is persisted from its media
  // duration (see addBoxThunk in common/actions.es6).
  handleBoxAdded = (ids, draggable, resizable, content, style, state, structure, initialParams) => {
    const dispatch = this.props.dispatch || (this.props.store && this.props.store.dispatch);
    dispatch(
      addBoxThunk(ids, draggable, resizable, content, style, state, structure, initialParams)
    );
  };

  // Crop → new object. Clones the selected image box with the cropped image
  // (uploaded to the training as a new file) as a new independent box,
  // sizes/positions it to the crop rect, deletes the original (the library
  // asset is untouched), and selects the new box. Returns the new box id.
  handleCropToNewBox = (croppedUrl, layout) => {
    const dispatch = this.props.dispatch || (this.props.store && this.props.store.dispatch);
    // Tag every dispatch below with one group id so redux-undo folds the crop
    // (PASTE_BOX + DELETE_BOX + resize) into a single undo step — one Ctrl+Z
    // restores the original photo. See groupBy in reducers/reducers.jsx.
    window.cropUndoGroup = "crop_" + Date.now() + "_" + Math.random().toString(36).slice(2);
    try {
      const newId = this.clipboardRef.current && this.clipboardRef.current.cropToNewBox(croppedUrl);
      if (!newId) return null;
      if (layout) {
        const r = (n) => Math.round(n * 100) / 100;
        const { xPct, yPct, wPct, hPct } = layout;
        if ([xPct, yPct, wPct, hPct].every((n) => Number.isFinite(n))) {
          dispatch(
            resizeBox(newId, {
              x: `${r(xPct)}%`,
              y: `${r(yPct)}%`,
              width: r(wPct),
              widthUnit: "%",
              height: r(hPct),
              heightUnit: "%",
            })
          );
        }
      }
      const present = this.props.store && this.props.store.getState().undoGroup.present;
      const box = present && present.boxesById && present.boxesById[newId];
      dispatch(selectBox(newId, box));
      return newId;
    } finally {
      window.cropUndoGroup = null;
    }
  };

  uploadTemplate(id, templateName) {
    // Şablonun statei oluşturulur ve ana statete aktarılır.

    if (id && this.props.navItems[id]) {
      let boxes = [
        ...(Object.keys(this.props.boxes)
          .map((key) => this.props.boxes[key])
          .filter((r) => r.parent == id) || []),
      ];

      boxes.forEach((box, index) => {
        box.pluginToolbar = this.props.pluginToolbars[box.id];
        box.marks =
          Object.keys(this.props.marks)
            .map((key) => this.props.marks[key])
            .filter((r) => r.origin == box.id) || [];

        if (box.sortableContainers) {
          Object.keys(box.sortableContainers)
            .map((key) => box.sortableContainers[key])
            .forEach((sortable) => {
              boxes.push({
                ...this.props.boxes[sortable.children],
                pluginToolbar: this.props.pluginToolbars[sortable.children],
              });
            });
        }
      });

      let exercises = this.props.exercises[id];

      let navItems = this.props.navItems[id];

      let viewToolbar = this.props.viewToolbars[id];

      let soundList = this.props.store.getState().undoGroup.present.soundList[id] || [];

      let animationList = Object.keys(this.props.boxes)
        .map((key) => this.props.boxes[key])
        .filter(
          (r) =>
            r.parent == id &&
            this.props.store.getState().undoGroup.present.animationsById[r.id] !== undefined
        )
        .map((box) => {
          return {
            id: box.id,
            animations: this.props.store.getState().undoGroup.present.animationsById[box.id],
          };
        });

      this.props.dispatch(
        uploadTemplate(
          id,
          templateName,
          JSON.stringify(boxes).replaceAll('"', "<!>"),
          JSON.stringify(exercises).replaceAll('"', "<!>"),
          JSON.stringify(navItems).replaceAll('"', "<!>"),
          JSON.stringify(viewToolbar).replaceAll('"', "<!>"),
          JSON.stringify(soundList).replaceAll('"', "<!>"),
          JSON.stringify(animationList).replaceAll('"', "<!>")
        )
      );
    }
  }

  duplicateNavItem(id) {
    // Sahne duplicate edilir.

    if (id && this.props.navItems[id]) {
      let newBoxes = [];
      let navItem = this.props.navItems[id];
      let linkedCVs = {};
      if (navItem.boxes) {
        newBoxes = newBoxes.concat(navItem.boxes);
        navItem.boxes.forEach((b) => {
          let box = this.props.boxes[b];
          if (box.sortableContainers) {
            for (let sc in box.sortableContainers) {
              if (box.sortableContainers[sc].children) {
                newBoxes = newBoxes.concat(box.sortableContainers[sc].children);
                box.sortableContainers[sc].children.forEach((bo) => {
                  let bx = this.props.boxes[bo];
                  if (bx.sortableContainers) {
                    for (let scc in bx.sortableContainers) {
                      if (bx.sortableContainers[scc].children) {
                        newBoxes = newBoxes.concat(bx.sortableContainers[scc].children);
                      }
                    }
                  }
                });
              }
            }
          }
        });
      }
      let newBoxesMap = {};
      newBoxes.map((box, index) => {
        linkedCVs[box] = [...this.props.boxes[box].containedViews];
        newBoxesMap[box] = box.split("-")[0] + "-" + Date.now() + index;
      });

      this.props.dispatch(
        duplicateNavItem(
          id,
          id.split("-")[0] + "-" + Date.now(),
          newBoxesMap,
          Date.now(),
          linkedCVs,
          withFreshSoundIds((this.props.soundList || {})[id] || [])
        )
      );
    }
  }

  duplicateNavItemByPayload(index) {
    // Şablon stateinin yardımı ile yeni sahne oluşturulur.

    let template = this.props.store.getState().undoGroup.present.uploadedTemplates[index];

    let boxes = JSON.parse(template.boxes.replaceAll("<!>", '"'));

    let navItems = JSON.parse(template.navItems.replaceAll("<!>", '"'));

    let exercises = JSON.parse(template.exercises.replaceAll("<!>", '"'));

    let viewToolbar = JSON.parse(template.viewToolbar.replaceAll("<!>", '"'));

    let soundList = withFreshSoundIds(JSON.parse(template.soundList.replaceAll("<!>", '"')));

    let animationList = JSON.parse(template.animationList.replaceAll("<!>", '"'));

    let newId = ID_PREFIX_PAGE + Date.now();

    if (boxes) {
      boxes.forEach((box, index) => {
        if (box.parent.includes(ID_PREFIX_PAGE)) {
          box.cloneId = box.id;
          box.id = ID_PREFIX_BOX + Date.now() + index;
          box.parent = newId;
          if (box.sortableContainers) {
            Object.keys(box.sortableContainers).map((key, index) => {
              let sortable = box.sortableContainers[key];
              let sortableBox = boxes.find((r) => r.id == sortable.children);
              sortableBox.cloneId = sortableBox.id;
              sortableBox.id = box.id + "_" + index;
              sortableBox.parent = box.id;
              sortable.children = [box.id + "_" + index];
            });
          }
        }
      });
    }

    this.props.dispatch(
      duplicateNavItemByPayload(
        newId,
        boxes,
        Date.now(),
        exercises,
        navItems,
        viewToolbar,
        soundList,
        animationList
      )
    );
  }

  // Add an answer/option to an assessment box — powers the in-question
  // "+ Add answer" button (mirrors EditorShortcuts.addAnswer's basic case).
  addAnswerToBox(boxId) {
    const toolbar = this.props.pluginToolbars?.[boxId];
    if (!toolbar || !toolbar.state) return;
    this.toolbarUpdated(boxId, "main", "state", "nBoxes", toolbar.state.nBoxes + 1);
  }

  // Inline "+ area" from the assessment question editor: persist the question
  // text (with its new {{#N}} / #----…----# marker) WITHOUT leaving edit mode,
  // then insert the matching answer at the SAME reading position as the new
  // blank (index `insertIndex`) so nothing shifts and the new answer is empty.
  // `questionBoxId` is the BasicText question box; the assessment root (where
  // nBoxes / correctAnswer live) is its parent.
  //  - DragDrop: answer containers are created by the template on the nBoxes
  //    bump (async), so we append one now and finish the reorder+clear in
  //    componentDidUpdate once the new child box exists (see reconcile below).
  //  - FillInBlank: blanks are inline (no containers); the per-blank correct
  //    answers are a plain array — splice an empty entry in at insertIndex.
  addAssessmentArea(questionBoxId, html, insertIndex = -1) {
    const qBox = this.props.boxes?.[questionBoxId];
    if (!qBox) return;
    const encoded = encodeURI(html);
    this.onTextEditorToggled(questionBoxId, false, encoded, html2json(encoded));
    const rootId = qBox.parent;
    const rootTb = this.props.pluginToolbars?.[rootId];
    if (!rootTb) return;
    if (rootTb.pluginId === "DragDrop") {
      const origN = (rootTb.state && rootTb.state.nBoxes) || 0;
      this.addAnswerToBox(rootId);
      this.pendingDndInsert = {
        rootId,
        insertIndex: insertIndex < 0 ? origN : insertIndex,
        targetN: origN + 1,
      };
    } else if (rootTb.pluginId === "FillInBlank") {
      // nBoxes is synced to the marker count by onTextEditorToggled above (called
      // at the top of this method), so no manual bump here — that would double it.
      // exercises is the page→box tree; the correct answers live at
      // exercises[page].exercises[rootId].correctAnswer. Reading the flat rootId
      // key returned undefined and wiped every existing answer — splice into the
      // real array so only the new blank is empty. page = the assessment root's
      // parent (the nav item / contained view), NOT the question box's parent.
      const root = this.props.boxes?.[rootId];
      const page = root ? root.parent : undefined;
      const pageEx = page != null ? this.props.exercises?.[page] : null;
      const entry = pageEx && pageEx.exercises ? pageEx.exercises[rootId] : null;
      const arr = entry && Array.isArray(entry.correctAnswer) ? entry.correctAnswer.slice() : [];
      const at = insertIndex < 0 || insertIndex > arr.length ? arr.length : insertIndex;
      arr.splice(at, 0, "");
      this.props.dispatch(setCorrectAnswer(rootId, arr, page));
    }
  }

  // Finish a pending DragDrop "+ area": once the template has created the new
  // answer child (appended at the end), move it to the reading position of the
  // new slot and blank it out, so the answer order matches the blank order and
  // the new answer starts empty.
  reconcilePendingDndInsert() {
    const p = this.pendingDndInsert;
    if (!p) return;
    const root = this.props.boxes?.[p.rootId];
    const tb = this.props.pluginToolbars?.[p.rootId];
    if (!root || !tb || !root.sortableContainers) return;
    if (!tb.state || tb.state.nBoxes !== p.targetN) return;
    const childIds = [];
    for (let i = 0; i < p.targetN; i++) {
      const c = root.sortableContainers["sc-Answer" + i];
      const id = c && c.children && c.children[0];
      if (!id) return; // new child not mounted yet — wait for the next update
      childIds[i] = id;
    }
    this.pendingDndInsert = null;
    const fromIndex = p.targetN - 1;
    const to = Math.min(Math.max(p.insertIndex, 0), fromIndex);
    const ops = this.assessmentReflowOps();
    if (to !== fromIndex) {
      applyAnswerMove(this.assessmentReflowState(), p.rootId, fromIndex, to, ops);
    }
    // The moved-in answer (now at `to`) carries the template's default text —
    // blank it so the author fills it in.
    ops.setText(childIds[to], "");
  }

  // The redux "present" slices the shared answerReflow helpers read.
  assessmentReflowState() {
    return {
      boxes: this.props.boxes,
      pluginToolbars: this.props.pluginToolbars,
      exercises: this.props.exercises,
    };
  }

  // The editor operations the answerReflow helpers call back into. Same wiring as
  // EditorShortcuts.removeAnswerLineIfApplicable so the inline ×/▲▼ and the
  // keyboard trash share one tested path. setCorrectAnswer dispatches the plain
  // action (not the DnD-flavoured canvas prop, which would array-wrap).
  assessmentReflowOps() {
    return {
      setText: (id, text) => this.onTextEditorToggled(id, false, text, id),
      setQuestionText: (id, text) => this.onTextEditorToggled(id, false, text, id),
      // Reorder writes __text AND the box-level format verbatim in one dispatch.
      // Unlike setText (which re-derives format from the HTML and so loses the
      // pill-only props — font size, B/I/U — that never live in the markup),
      // this carries the moved answer's format as-is and clears any format key
      // the incoming answer doesn't have, so no stale style leaks into the slot.
      setAnswerContent: (id, text, fmt) => {
        const tb = this.props.pluginToolbars[id];
        if (!tb || tb.pluginId === "sortable_container") return;
        const nextState = { ...tb.state, __text: text };
        if (nextState.__i18nKey) {
          delete nextState.__i18nKey;
          delete nextState.__suffix;
        }
        TEXT_FORMAT_KEYS.forEach((k) => {
          if (fmt && fmt[k] !== undefined) nextState[k] = fmt[k];
          else delete nextState[k];
        });
        const toolbar = IdealStudio.Plugins.get(tb.pluginId).getToolbar(nextState);
        this.props.dispatch(updateBox(id, html2json(nextState.__text), toolbar, nextState));
      },
      setCorrectAnswer: (id, ca, page) => this.props.dispatch(setCorrectAnswer(id, ca, page)),
      setNBoxes: (id, n) => this.toolbarUpdated(id, "main", "state", "nBoxes", n),
    };
  }

  // Remove an answer/option row from an assessment box — powers the per-row "×".
  // Delegates to the shared, unit-tested reflow helpers so text-shift, correct-
  // answer remap (scalar/array/positional shapes), DragDrop {{#N}} slot renumber
  // and the nBoxes shrink are each handled per plugin shape.
  removeAnswerFromBox(boxId, removeIndex) {
    const toolbar = this.props.pluginToolbars?.[boxId];
    const box = this.props.boxes?.[boxId];
    // Son (tek kalan) seçeneğin × düğmesine basılırsa satırı değil, tüm soruyu
    // sil. Diğer durumlarda normal satır reflow'u çalışır.
    if (box && toolbar?.state && toolbar.state.nBoxes <= 1) {
      this.onBoxDeleted(
        box.id,
        box.parent,
        box.container,
        this.props.containedViewSelected && this.props.containedViewSelected !== 0
          ? this.props.containedViewSelected
          : this.props.navItemSelected
      );
      return;
    }
    const pluginId = toolbar?.pluginId;
    const state = this.assessmentReflowState();
    const ops = this.assessmentReflowOps();
    if (pluginId === "DragDrop") {
      applyDragDropAnswerRemoval(state, boxId, removeIndex, ops);
    } else if (pluginId === "Matching") {
      applyMatchingAnswerRemoval(state, boxId, removeIndex, ops);
    } else {
      applyAnswerRemoval(state, boxId, removeIndex, ops);
    }
  }

  // Reorder answers via the per-row ▲▼ buttons. Matching swaps right-column cells
  // (re-pairing); every other type moves the answer row (text + correctAnswer) to
  // its new position. `from`/`to` are 0-based answer indices.
  reorderAnswersForBox(boxId, from, to) {
    const pluginId = this.props.pluginToolbars?.[boxId]?.pluginId;
    const state = this.assessmentReflowState();
    const ops = this.assessmentReflowOps();
    if (pluginId === "Matching") {
      applyMatchingRightSwap(state, boxId, from, to, ops);
    } else {
      applyAnswerMove(state, boxId, from, to, ops);
    }
  }

  // --- CanvasAlignToolbar multi-select text formatting ----------------------
  // Only active when EVERY selected box is a text plugin (BasicText/RichText);
  // mirrors EditorShortcuts.jsx's single-box BasicText pill, one dispatch per
  // selected id instead of one.
  getMultiTextBoxIds() {
    const state = this.props.store.getState().undoGroup.present;
    const ids = state.boxSelectedAll;
    if (!Array.isArray(ids) || ids.length < 2) return [];
    const eligible = ids.filter((id) => {
      const tb = state.pluginToolbarsById[id];
      return tb && (tb.pluginId === "BasicText" || tb.pluginId === "RichText");
    });
    return eligible.length === ids.length ? eligible : [];
  }

  // Applies one text-format key/value to one box: updates the box-state
  // property (as before) AND, when the box has rich __text content (RichText,
  // or older BasicText content from before its native toolbar was hidden),
  // forces the matching CSS property onto every element of that stored HTML
  // too — otherwise a per-span style CKEditor applied earlier keeps winning
  // over the new wrapper-level value and the change looks like it did nothing.
  applyMultiTextValue(id, key, value) {
    const state = this.props.store.getState().undoGroup.present;
    const tb = state.pluginToolbarsById[id];
    this.toolbarUpdated(id, "main", "state", key, value);
    if (!tb.state.__text) return;
    // Font size is em-based: forcing it onto content elements MULTIPLIES with
    // the wrapper's own em (1.29em × 1.29em ≈ +29%) — strip it from content
    // instead, so the wrapper is the single owner and per-span sizes still
    // can't shadow the new value.
    if (key === "textFontSize") {
      this.toolbarUpdated(
        id,
        "main",
        "state",
        "__text",
        stripHtmlCssProperty(tb.state.__text, "font-size")
      );
      return;
    }
    const mapping = TEXT_FORMAT_CSS_PROP[key];
    if (mapping) {
      const [cssProp, toCssValue] = mapping;
      const nextHtml = (
        TEXT_TOGGLE_KEYS.includes(key) ? toggleHtmlCssProperty : forceHtmlCssProperty
      )(tb.state.__text, cssProp, toCssValue(value));
      this.toolbarUpdated(id, "main", "state", "__text", nextHtml);
    }
  }

  setMultiTextProperty(key, value) {
    this.getMultiTextBoxIds().forEach((id) => this.applyMultiTextValue(id, key, value));
  }

  // Mixed-state toggle: if every selected box already has `key` on, turn all
  // off; otherwise turn all on. Resolved ONCE up front so every box lands on
  // the same value (not recomputed per box mid-loop).
  toggleMultiTextFormat(key) {
    const state = this.props.store.getState().undoGroup.present;
    const ids = this.getMultiTextBoxIds();
    if (!ids.length) return;
    const allOn = ids.every((id) => !!state.pluginToolbarsById[id].state[key]);
    this.setMultiTextProperty(key, !allOn);
  }

  // Writes `textFontSize` (px) — the same property the gear popover's font-size
  // stepper writes (see getMultiTextFormatProps' onSetFontSize below). They
  // used to be split across `fontScale` (%) and `textFontSize` (px), which
  // both set the same rendered CSS fontSize with `textFontSize` always
  // winning once set, so this button silently stopped doing anything visible
  // after the stepper had been used once.
  setMultiTextFontScale(delta) {
    const state = this.props.store.getState().undoGroup.present;
    this.getMultiTextBoxIds().forEach((id) => {
      const tb = state.pluginToolbarsById[id];
      const cur = tb.state.textFontSize || 16;
      const next = Math.min(200, Math.max(6, Math.round(cur * (delta > 0 ? 1.15 : 1 / 1.15))));
      this.applyMultiTextValue(id, "textFontSize", next);
    });
  }

  // Builds CanvasAlignToolbar's `textFormat` prop — null hides the text
  // controls entirely (mixed selection, or fewer than 2 text boxes).
  getMultiTextFormatProps() {
    const ids = this.getMultiTextBoxIds();
    if (!ids.length) return null;
    const state = this.props.store.getState().undoGroup.present;
    const states = ids.map((id) => state.pluginToolbarsById[id].state || {});
    const allBool = (key) => states.every((s) => !!s[key]);
    const common = (key) =>
      states.every((s) => s[key] === states[0][key]) ? states[0][key] : undefined;
    return {
      bold: allBool("bold"),
      italic: allBool("italic"),
      underline: allBool("underline"),
      textAlign: common("textAlign"),
      textFontFamily: common("textFontFamily"),
      textFontSize: common("textFontSize"),
      textColor: common("textColor"),
      highlightColor: common("highlightColor"),
      onToggle: (key) => this.toggleMultiTextFormat(key),
      onSetAlign: (align) => this.setMultiTextProperty("textAlign", align),
      onFontScale: (delta) => this.setMultiTextFontScale(delta),
      // Live preview while browsing the inline font list: applies the hovered
      // font to each selected box's DOM node AND every descendant (not a
      // Redux dispatch, so hovering every row doesn't spam undo history) —
      // touching every descendant matters once a PREVIOUS commit has forced a
      // font onto each element of a box's __text (see applyMultiTextValue
      // above), since those per-element inline styles would otherwise keep
      // out-ranking a preview that only touched the box's wrapper. `value:
      // null` (mouse/focus leaves a row) restores each element's exact prior
      // value via the snapshots previewCssOnBox returned from the last call.
      onPreviewFontFamily: (value) => {
        if (!this._multiFontPreviewSnapshots) this._multiFontPreviewSnapshots = {};
        ids.forEach((id) => {
          this._multiFontPreviewSnapshots[id] = previewCssOnBox(
            getBoxContentEl(id),
            "fontFamily",
            value,
            this._multiFontPreviewSnapshots[id]
          );
        });
        if (value == null) this._multiFontPreviewSnapshots = null;
      },
      onSetFontFamily: (value) => this.setMultiTextProperty("textFontFamily", value),
      onSetFontSize: (value) => this.setMultiTextProperty("textFontSize", value),
      onSetColor: (value) => this.setMultiTextProperty("textColor", value),
      onSetHighlight: (value) => this.setMultiTextProperty("highlightColor", value),
    };
  }

  // --- CanvasTopToolbar font button ----------------------------------------
  // Every box of the view currently on the canvas (contained view when one is
  // open, otherwise the scene), nested boxes included. The reducer picks the
  // BasicText/RichText entries out of this list itself, so no filtering here.
  getCurrentViewBoxIds() {
    const state = this.props.store.getState().undoGroup.present;
    const view =
      state.containedViewSelected !== 0
        ? state.containedViewsById[state.containedViewSelected]
        : state.navItemsById[state.navItemSelected];
    if (!view || !Array.isArray(view.boxes)) return [];
    let ids = [];
    view.boxes.forEach((boxId) => {
      ids.push(boxId);
      ids = ids.concat(getDescendantBoxes(state.boxesById[boxId], state.boxesById));
    });
    return ids;
  }

  // `allScenes` = the whole training (also becomes the course default font);
  // otherwise only the view on screen. Defaults to the narrow scope in the
  // button itself — a stray click must not retypeset the entire training.
  applyCanvasFont(fontFamily, allScenes) {
    if (!fontFamily) return;
    // The commit re-renders from state, so the hover snapshots are stale.
    this._canvasFontPreviewSnapshots = null;
    if (allScenes) {
      this.props.dispatch(batchSetSceneFont(fontFamily));
      return;
    }
    const state = this.props.store.getState().undoGroup.present;
    const navItemId =
      state.containedViewSelected !== 0 ? state.containedViewSelected : state.navItemSelected;
    this.props.dispatch(
      batchSetSceneFont(fontFamily, { boxIds: this.getCurrentViewBoxIds(), navItemId })
    );
  }

  // Live preview while browsing the font list — DOM only, no dispatch, so
  // hovering every row doesn't spam undo history. Always previews the view on
  // screen (the only thing the user can see) whatever the chosen scope is.
  // Same snapshot/restore contract as the multi-select bar above.
  previewCanvasFont(value) {
    if (!this._canvasFontPreviewSnapshots) this._canvasFontPreviewSnapshots = {};
    const toolbars = this.props.store.getState().undoGroup.present.pluginToolbarsById;
    this.getCurrentViewBoxIds().forEach((id) => {
      const tb = toolbars[id];
      if (!tb || (tb.pluginId !== "BasicText" && tb.pluginId !== "RichText")) return;
      this._canvasFontPreviewSnapshots[id] = previewCssOnBox(
        getBoxContentEl(id),
        "fontFamily",
        value,
        this._canvasFontPreviewSnapshots[id]
      );
    });
    if (value == null) this._canvasFontPreviewSnapshots = null;
  }

  toolbarUpdated(id, tab, accordion, name, value) {
    if (isBox(id) || isSortableBox(id)) {
      let toolbar = this.props.pluginToolbars[id];
      let pluginAPI = IdealStudio.Plugins.get(toolbar.pluginId);
      let config = pluginAPI.getConfig();
      let deletedBoxes = [];

      if (config.isComplex && accordion === "state") {
        let newPluginState = JSON.parse(JSON.stringify(toolbar.state));
        newPluginState[name] = value;
        let pluginContainerIds = {}; // newPluginState.__pluginContainerIds;
        let defaultBoxes = {};
        if (config.flavor !== "react") {
          let content = pluginAPI.getRenderTemplate(newPluginState);
          parsePluginContainers(content, pluginContainerIds);
        } else {
          let content = pluginAPI.getRenderTemplate(newPluginState, {
            exercises: { correctAnswer: true },
          });
          parsePluginContainersReact(
            content,
            pluginContainerIds,
            defaultBoxes,
            this.props.boxes,
            id
          );
        }
        // Source of truth for "which containers exist right now" is the box's
        // ACTUAL sortableContainers — not toolbar.state.__pluginContainerIds,
        // which freshly-inserted questions never had tracked. When it was
        // missing we defaulted to {} (count 0), so a *decrement* (e.g. the
        // per-row × / applyAnswerRemoval) was misread as an ADD: the removed
        // answer's container was never deleted, leaving an orphaned answer box
        // plus a desynced nBoxes/correctAnswer ("bozulma"). It only self-healed
        // after an unrelated stepper +/- populated __pluginContainerIds. Trusting
        // sortableContainers classifies add vs remove correctly from the start
        // and still writes __pluginContainerIds below so it self-heals.
        const existingContainerIds =
          (this.props.boxes[id] && this.props.boxes[id].sortableContainers) ||
          toolbar.state.__pluginContainerIds ||
          {};
        if (Object.keys(existingContainerIds).length < Object.keys(pluginContainerIds).length) {
          for (let s in pluginContainerIds) {
            if (!existingContainerIds[s]) {
              if (defaultBoxes[s]) {
                let page =
                  this.props.containedViewSelected && this.props.containedViewSelected !== 0
                    ? this.props.containedViewSelected
                    : this.props.navItemSelected;
                this.props.dispatch(
                  updatePluginToolbar(
                    id,
                    tab,
                    accordion,
                    [name, "__pluginContainerIds"],
                    [value, pluginContainerIds],
                    [],
                    page
                  )
                );
                defaultBoxes[s].map((newBox, ind) => {
                  createBox(
                    {
                      parent: id,
                      page,
                      container: s,
                      isDefaultPlugin: true,
                      initialState: newBox.initialState,
                      id: ID_PREFIX_BOX + Date.now() + "_" + ind,
                      draggable: true,
                      resizable: this.props.boxes[id].resizable,
                    },
                    newBox.type,
                    false,
                    (
                      ids,
                      draggable,
                      resizable,
                      content,
                      style,
                      state,
                      structure,
                      initialParams
                    ) => {
                      this.props.dispatch(
                        addBoxThunk(
                          ids,
                          draggable,
                          resizable,
                          content,
                          style,
                          state,
                          structure,
                          initialParams
                        )
                      );
                    },
                    this.props.boxes
                  );
                });
              }
            }
          }
          return;
        } else if (
          Object.keys(existingContainerIds).length > Object.keys(pluginContainerIds).length
        ) {
          for (let s in existingContainerIds) {
            if (!pluginContainerIds[s]) {
              if (
                this.props.boxes[id].sortableContainers[s] &&
                this.props.boxes[id].sortableContainers[s].children
              ) {
                deletedBoxes = deletedBoxes.concat(
                  this.props.boxes[id].sortableContainers[s].children
                );
              }
            }
          }
        }
        let page =
          this.props.containedViewSelected && this.props.containedViewSelected !== 0
            ? this.props.containedViewSelected
            : this.props.navItemSelected;

        this.props.dispatch(
          updatePluginToolbar(
            id,
            tab,
            accordion,
            [name, "__pluginContainerIds"],
            [value, pluginContainerIds],
            deletedBoxes,
            page
          )
        );
        return;
      }

      let page =
        this.props.containedViewSelected && this.props.containedViewSelected !== 0
          ? this.props.containedViewSelected
          : this.props.navItemSelected;

      this.props.dispatch(updatePluginToolbar(id, tab, accordion, name, value, deletedBoxes, page));

      // A plugin may patch other accordions on a state change (AudioCue's player view resizes its box).
      if (accordion === "state" && typeof pluginAPI.onStateUpdated === "function") {
        const patches = pluginAPI.onStateUpdated(name, value, toolbar) || {};
        Object.keys(patches).forEach((acc) => {
          const keys = Object.keys(patches[acc] || {});
          if (!keys.length) return;
          this.props.dispatch(
            updatePluginToolbar(
              id,
              tab,
              acc,
              keys,
              keys.map((k) => patches[acc][k]),
              [],
              page
            )
          );
        });
      }
    } else {
      this.props.dispatch(updateViewToolbar(id, tab, accordion, name, value));
    }
  }

  // Dispatches DELETE_NAV_ITEM for one nav item plus its descendant views, boxes
  // and linked marks. `navItems`/`boxes` default to current props; bulk delete
  // passes a pre-delete snapshot so every dispatch sees a consistent tree.
  dispatchNavItemDelete(navsel, navItems = this.props.navItems, boxes = this.props.boxes) {
    let viewRemoving = [navsel].concat(this.getDescendantViews(navItems[navsel], navItems));
    let boxesRemoving = [];
    let containedRemoving = {};
    viewRemoving.map((id) => {
      navItems[id].boxes.map((boxId) => {
        boxesRemoving.push(boxId);
        boxesRemoving = boxesRemoving.concat(getDescendantBoxes(boxes[boxId], boxes));
      });
    });
    let marksRemoving = getDescendantLinkedBoxes(viewRemoving, navItems) || [];
    this.props.dispatch(
      deleteNavItem(
        viewRemoving,
        navItems[navsel].parent,
        boxesRemoving,
        containedRemoving,
        marksRemoving
      )
    );
  }

  // Scene index multi-select bulk delete. One DELETE_NAV_ITEM per scene (the
  // reducer only detaches payload.ids[0] from its parent), grouped into a single
  // undo step via the shared window.cropUndoGroup groupBy hook.
  deleteNavItemsBulk(ids) {
    const { navItems, boxes, navItemsIds, navItemSelected, dispatch } = this.props;
    const toDelete = ids.filter((id) => navItems[id]);
    if (toDelete.length === 0) return;
    const remainingPages = navItemsIds.filter((id) => isPage(id) && !toDelete.includes(id));
    if (remainingPages.length === 0) return;

    this.setState({ timelineVisible: false });
    const previousGroup = window.cropUndoGroup;
    window.cropUndoGroup =
      "scene-bulk-delete_" + Date.now() + "_" + Math.random().toString(36).slice(2);
    try {
      toDelete.forEach((id) => this.dispatchNavItemDelete(id, navItems, boxes));
    } finally {
      window.cropUndoGroup = previousGroup;
    }

    if (toDelete.includes(navItemSelected)) {
      dispatch(selectNavItem(remainingPages[0]));
      dispatch(selectIndex(remainingPages[0]));
    }
  }

  getDescendantViews(view, navItems = this.props.navItems) {
    let selected = [];

    for (let i = 0; i < view.children.length; i++) {
      let vw = view.children[i];
      selected.push(vw);
      selected = selected.concat(this.getDescendantViews(navItems[vw], navItems));
    }

    return selected;
  }

  onRichMarkUpdated(mark, createNew) {
    let boxSelected = this.props.boxSelected;
    let mark_exist = this.props.marks[mark.id] !== undefined;
    if (mark_exist) {
    }

    let oldConnection = state.__marks[mark.id] ? state.__marks[mark.id].connection : 0;
    state.__marks[mark.id] = JSON.parse(JSON.stringify(mark));
    let newConnection = mark.connection;
    if (mark.connection.id) {
      newConnection = mark.connection.id;
      state.__marks[mark.id].connection = mark.connection.id;
    }

    this.props.dispatch(editRichMark(boxSelected, state, mark, oldConnection, newConnection));
  }

  playAnimation() {
    this.props.dispatch(selectBox(-1));

    if (this.animationScene != null) {
      this.animationScene.play();
      return;
    }

    this.loadAnimation();
    this.animationScene && this.animationScene.play();
  }

  loadAnimation() {
    this.animationScene = null;

    const boxes = this.props.store.getState().undoGroup.present.boxesById;
    const animationsById = this.props.store.getState().undoGroup.present.animationsById;

    const currentViewOrContained =
      this.props.containedViewSelected != 0
        ? this.props.containedViewSelected
        : this.props.navItemSelected;

    this.animationScene = createAnimationScene(boxes, animationsById, currentViewOrContained);
  }

  pauseAnimation() {
    if (this.animationScene != null) {
      this.animationScene.pause();
      this.resetPosition();
    }
  }

  resetPosition() {
    const currentViewOrContained =
      this.props.containedViewSelected != 0
        ? this.props.containedViewSelected
        : this.props.navItemSelected;

    const boxesById = this.props.store.getState().undoGroup.present.boxesById;
    const pluginToolbarsById = this.props.store.getState().undoGroup.present.pluginToolbarsById;

    resetAnimationPositions({
      boxesById,
      pluginToolbarsById,
      currentViewOrContained,
    });
  }

  resetAnimation() {
    if (this.animationScene != null) {
      this.animationScene.end();
      this.resetPosition();
    }
    this.animationScene = null;
  }

  // Called from onTriggerLayerAnimation: if this is a time-update tick for a
  // box that needs a live per-box clock, update the per-box current time map
  // so editorLayerTimes consumers can scrub to the correct frame:
  // AtomicElementRenderer → AnimatedField for AtomicBoxPlugin field-level
  // animations, and HotspotImages' editor Image.jsx for frame-accurate
  // animated-WebP/GIF canvas rendering (see RecorderCanvasImage). Despite the
  // name, this context is no longer AtomicBoxPlugin-exclusive.
  updateAtomicLayerCurrentTime(layerId, animationInfo) {
    if (!animationInfo || !animationInfo.isTimeUpdate) return;
    const present = this.props.store.getState().undoGroup.present;
    const toolbar = present.pluginToolbarsById?.[layerId];
    const isAtomic = toolbar?.pluginId === "AtomicBoxPlugin";
    const isAnimatedImage =
      toolbar?.pluginId === "HotspotImages" &&
      typeof toolbar?.state?.url === "string" &&
      /(\.webp|\.gif|\.apng|\.avif)(\?|#|$)/i.test(toolbar.state.url);
    if (!isAtomic && !isAnimatedImage) return;

    // Per-box store: only this box re-renders, not EditorApp.
    if (animationInfo.inRange === false) editorLayerTimes.clear(layerId, this._layerSession);
    else {
      const t =
        typeof animationInfo.layerRelativeTime === "number" ? animationInfo.layerRelativeTime : 0;
      editorLayerTimes.set(layerId, t, this._layerSession);
    }
  }

  // One-shot apply-preview for a sub-field animation: scrub the box's context
  // clock across the animation's window (same clock timeline play uses), then
  // drop the entry so every sub-field settles back to the plain visible
  // editor state — parity with the box-level previewBoxAnimation flow.
  _previewAtomicFieldAnim(boxId, startSec, durationSec) {
    if (this._atomicPreviewRaf) cancelAnimationFrame(this._atomicPreviewRaf);
    clearTimeout(this._atomicPreviewClear);
    const durMs = Math.max(1, (durationSec || 0.5) * 1000);
    let t0 = null;
    const tick = (ts) => {
      if (t0 == null) t0 = ts;
      const p = Math.min(1, (ts - t0) / durMs);
      const t = startSec + p * (durationSec || 0.5);
      editorLayerTimes.set(boxId, t, this._layerSession);
      if (p < 1) {
        this._atomicPreviewRaf = requestAnimationFrame(tick);
      } else {
        this._atomicPreviewRaf = null;
        this._atomicPreviewClear = setTimeout(() => this._clearAtomicLayerTime(boxId), 60);
      }
    };
    this._atomicPreviewRaf = requestAnimationFrame(tick);
  }

  _clearAtomicLayerTime(boxId) {
    editorLayerTimes.clear(boxId, this._layerSession);
  }

  // Deleted boxes drop their entry; no out-of-range report comes for them.
  _pruneLayerTimes() {
    editorLayerTimes.prune((id) => !!this.props.boxes?.[id], this._layerSession);
  }

  // A closed editor leaves no layer time or pending preview behind.
  _endLayerSession() {
    if (this._atomicPreviewRaf) cancelAnimationFrame(this._atomicPreviewRaf);
    this._atomicPreviewRaf = null;
    clearTimeout(this._atomicPreviewClear);
    editorLayerTimes.endSession(this._layerSession);
  }

  _readAtomicElementData(boxId) {
    const toolbar = this.props.pluginToolbars?.[boxId];
    if (!toolbar || toolbar.pluginId !== "AtomicBoxPlugin") return null;
    const raw = toolbar.state?.__text;
    if (typeof raw !== "string") return null;
    const decoded = decodeAtomicText(raw);
    if (!decoded) return null;
    return decoded.elementData ?? (decoded.type ? decoded : null);
  }

  _readAtomicFieldAnim(elementData, path, type) {
    if (!elementData) return null;
    const tail = type === "entry" ? "boxAnimation" : "boxExitAnimation";
    const keys = (path || "").split(".").filter(Boolean);
    let node = elementData;
    for (const k of keys) {
      if (!node || typeof node !== "object") return null;
      node = node[k];
    }
    if (!node || typeof node !== "object") return null;
    return node[tail] || null;
  }

  // Drives AnimationPanel's text-only preset filter. When elementData is
  // provided uses the schema; otherwise falls back to numeric-tail heuristic.
  _isAtomicFieldText(path, elementData) {
    if (!path) return false;
    const type = elementData && typeof elementData === "object" ? elementData.type : null;
    if (type) {
      return isTextLeafPath(type, path);
    }
    const last = path.split(".").filter(Boolean).pop();
    if (!last) return false;
    if (/^\d+$/.test(last)) return false;
    return true;
  }

  // Parent atomic box's effective lifetime in seconds. Atomic boxes span the
  // full scene, so we use the active scene's duration as the parent.
  _getAtomicParentDurationSec(/* boxId */) {
    const state = this.props.store?.getState()?.undoGroup?.present || {};
    const sceneId =
      this.props.containedViewSelected && this.props.containedViewSelected !== 0
        ? this.props.containedViewSelected
        : this.props.navItemSelected;
    const navItem = state.navItemsById?.[sceneId];
    const sceneDurationFrames = navItem?.duration || 1800;
    const FPS = 30;
    return sceneDurationFrames / FPS;
  }

  // Write field-level boxAnimation/boxExitAnimation. Payload shape mirrors
  // the box-level UPDATE_BOX_ANIMATION reducer.
  //   entry: preserves existing delay across duration changes.
  //   exit:  auto-adjusts delay so the exit's END time stays put — so the
  //          sub-row bar doesn't shrink when an exit is first added or its
  //          duration changes.
  //   paths: one path or an array — a timeline multi-selection writes the
  //          same preset/duration to every field in a single toolbar update
  //          (each field keeps its own delay).
  writeAtomicFieldAnim(boxId, paths, type, animName, duration) {
    let elementData = this._readAtomicElementData(boxId);
    if (!elementData) return;
    const pathList = (Array.isArray(paths) ? paths : [paths]).filter(Boolean);
    if (!pathList.length) return;
    const specs = [];
    for (const path of pathList) {
      const spec = this._buildAtomicFieldAnimSpec(
        boxId,
        elementData,
        path,
        type,
        animName,
        duration
      );
      elementData = setNestedAnimation(elementData, path, type, spec);
      if (spec) specs.push(spec);
    }
    const toolbar = this.props.pluginToolbars[boxId];
    const decoded = decodeAtomicText(toolbar.state.__text || "{}");
    if (!decoded) return;
    const newDecoded = decoded.elementData ? { ...decoded, elementData } : elementData;
    const newText = encodeURIComponent(JSON.stringify(newDecoded));
    this.toolbarUpdated(boxId, "main", "state", "__text", newText);
    // Apply-preview parity with box-level animations: play the new animation
    // once on canvas, then settle back to the visible resting state. On
    // removal just drop the clock so the field renders plain again. A bulk
    // apply previews the window covering every written field.
    if (specs.length) {
      const start = Math.min(...specs.map((sp) => sp.delay));
      const end = Math.max(...specs.map((sp) => sp.delay + sp.duration));
      this._previewAtomicFieldAnim(boxId, start, end - start);
    } else {
      this._clearAtomicLayerTime(boxId);
    }
  }

  // One field's { animation, duration, delay } spec, or null on removal.
  _buildAtomicFieldAnimSpec(boxId, elementData, path, type, animName, duration) {
    let spec = null;
    if (animName) {
      const existing = this._readAtomicFieldAnim(elementData, path, type);
      const existingDelay = existing && typeof existing.delay === "number" ? existing.delay : 0;
      const existingDuration =
        existing && typeof existing.duration === "number" ? existing.duration : null;
      const newDuration = typeof duration === "number" ? duration : 0.5;
      let newDelay;
      if (type === "exit") {
        if (existing && existingDuration != null) {
          // Preserve the existing exit-end time so the duration slider grows
          // the segment leftward without shifting the bar's right edge.
          newDelay = Math.max(0, existingDelay + existingDuration - newDuration);
        } else {
          // First-time exit add: land at the parent's end so the sub-row
          // bar doesn't suddenly collapse to [entry-start, 0.5s].
          const parentDurSec = this._getAtomicParentDurationSec(boxId);
          newDelay = Math.max(0, parentDurSec - newDuration);
        }
      } else {
        newDelay = existingDelay;
      }
      const presets = type === "entry" ? getBoxAnimationPresets() : getBoxExitAnimationPresets();
      const preset = presets.find((p) => p.name === animName);
      const animPayload = preset ?? { name: animName };
      spec = {
        animation: animPayload,
        duration: newDuration,
        delay: newDelay,
      };
    }
    return spec;
  }

  // Sub-clip drag/resize handler: adjusts entry.delay / exit.delay (in
  // seconds) without touching preset or duration.
  updateAtomicFieldTimings = (payload) => {
    if (!payload) return;
    const { boxId, path, entryDelay, exitDelay } = payload;
    if (!boxId || !path) return;
    let elementData = this._readAtomicElementData(boxId);
    if (!elementData) return;
    if (typeof entryDelay === "number") {
      const existing = this._readAtomicFieldAnim(elementData, path, "entry");
      if (existing) {
        elementData = setNestedAnimation(elementData, path, "entry", {
          ...existing,
          delay: Math.max(0, entryDelay),
        });
      }
    }
    if (typeof exitDelay === "number") {
      const existing = this._readAtomicFieldAnim(elementData, path, "exit");
      if (existing) {
        elementData = setNestedAnimation(elementData, path, "exit", {
          ...existing,
          delay: Math.max(0, exitDelay),
        });
      }
    }
    const toolbar = this.props.pluginToolbars[boxId];
    const decoded = decodeAtomicText(toolbar.state.__text || "{}");
    if (!decoded) return;
    const newDecoded = decoded.elementData ? { ...decoded, elementData } : elementData;
    const newText = encodeURIComponent(JSON.stringify(newDecoded));
    this.toolbarUpdated(boxId, "main", "state", "__text", newText);
  };

  onSortableContainerDeleted(id, parent) {
    let boxes = this.props.boxes;
    let containedViews = this.props.containedViews;
    let page =
      this.props.containedViewSelected && this.props.containedViewSelected !== 0
        ? this.props.containedViewSelected
        : this.props.navItemSelected;
    let descBoxes = getDescendantBoxesFromContainer(
      boxes[parent],
      id,
      this.props.boxes,
      this.props.containedViews
    );
    let cvs = {};
    for (let b in descBoxes) {
      let box = boxes[descBoxes[b]];
      for (let cv in box.containedViews) {
        if (!cvs[box.containedViews[cv]]) {
          cvs[box.containedViews[cv]] = [box.id];
        } else if (cvs[containedViews[cv]].indexOf(box.id) === -1) {
          cvs[box.containedViews[cv]].push(box.id);
        }
      }
    }
    this.props.dispatch(deleteSortableContainer(id, parent, descBoxes, cvs, page));
  }

  onTextEditorToggled(caller, value, text, content) {
    let pluginToolbar = this.props.pluginToolbars[caller];
    if (pluginToolbar && pluginToolbar.pluginId !== "sortable_container") {
      let state = Object.assign({}, pluginToolbar.state, { __text: text });
      if (state.__i18nKey) {
        delete state.__i18nKey;
        delete state.__suffix;
      }
      let toolbar = IdealStudio.Plugins.get(pluginToolbar.pluginId).getToolbar(state);

      // Opening the full CKEditor: convert box-level B/I/U (pill toggles —
      // state flags + per-element forced css) into real <strong>/<em>/<u>
      // markup and clear the flags. CKEditor's own commands only manage those
      // tags, so a pill-applied bold was otherwise impossible to remove per
      // selection inside the editor (the css always won). Looks identical;
      // ownership of the formatting just moves into the content.
      if (value) {
        const cur = pluginToolbar.state;
        const materialized = materializeTextDecorations(cur.__text, cur);
        if (materialized !== null) {
          const openState = {
            ...cur,
            __text: materialized,
            bold: false,
            italic: false,
            underline: false,
          };
          if (openState.__i18nKey) {
            delete openState.__i18nKey;
            delete openState.__suffix;
          }
          const openToolbar = IdealStudio.Plugins.get(pluginToolbar.pluginId).getToolbar(openState);
          this.props.dispatch(updateBox(caller, html2json(materialized), openToolbar, openState));
        }
      }

      this.props.dispatch(toggleTextEditor(caller, value));
      this.setState({ openTextEditor: true });
      if (!value && text && content) {
        // Committing text: re-derive the box-level format state from the
        // edited content so the pill stays in sync with what CKEditor did —
        // bold/italic/underline follow an all-text rule ("hepsi bold değilse
        // bold kalkmalı"); font family/size/color adopt a value the whole text
        // explicitly shares. Mixed or absent values leave the box-level prop
        // untouched — the wrapper still styles the parts content doesn't.
        const derived = deriveTextFormatState(text);
        if (derived) {
          state.bold = derived.bold;
          state.italic = derived.italic;
          state.underline = derived.underline;
          if (derived.fontFamily) state.textFontFamily = derived.fontFamily;
          if (derived.fontSize) {
            const m = /^([\d.]+)(px|em)$/.exec(derived.fontSize.trim());
            if (m) {
              // Uniform size moves OWNERSHIP to the box level: content keeps
              // no font-size (em there would multiply with the wrapper's em
              // and render ~29% oversized — the "sizes don't match" bug).
              // Lossless for every box now: the wrapper renders textFontSize
              // in the same em reference CKEditor uses (standalone px is gone).
              state.textFontSize = Math.round(parseFloat(m[1]) * (m[2] === "em" ? 14 : 1));
              state.__text = stripHtmlCssProperty(text, "font-size");
              content = html2json(state.__text);
            }
          } else if (derived.fontSize === null) {
            // Explicitly mixed sizes on every text node (the editor seeds the
            // box size into the content, so post-edit content is fully
            // self-sized): content owns sizing, the wrapper must not add a
            // second em layer on top.
            state.textFontSize = null;
          }
          if (derived.color) state.textColor = derived.color;
          toolbar = IdealStudio.Plugins.get(pluginToolbar.pluginId).getToolbar(state);
        }
        this.props.dispatch(updateBox(caller, content, toolbar, state));
        this.setState({ openTextEditor: false });
        // Keep the FillInBlank config counter (nBoxes) in sync with the actual
        // #----…----# markers in the committed question text, so deleting a blank
        // by hand also lowers "Number of blanks". The markers' "#----"/"----#"
        // delimiters survive encodeURI, so we can count them on the encoded text.
        const parentId = this.props.boxes?.[caller]?.parent;
        const parentTb = parentId ? this.props.pluginToolbars[parentId] : null;
        if (parentTb && parentTb.pluginId === "FillInBlank" && parentTb.state) {
          const nMarkers = (text.match(/#----[\s\S]*?----#/g) || []).length;
          if (nMarkers > 0 && nMarkers !== parentTb.state.nBoxes) {
            this.toolbarUpdated(parentId, "main", "state", "nBoxes", nMarkers);
          }
        }
      }
    }
  }
}

function mapStateToProps(state) {
  const soundListFromState = state.undoGroup.present.soundList;

  return {
    version: state.undoGroup.present.version,
    status: state.status,
    everPublished: state.everPublished,
    globalConfig: state.undoGroup.present.globalConfig,
    filesUploaded: state.filesUploaded,
    uploadedTemplates: state.uploadedTemplates,
    boxes: state.undoGroup.present.boxesById,
    boxSelected: state.undoGroup.present.boxSelected,
    boxSelectedAll: state.undoGroup.present.boxSelectedAll,
    boxLevelSelected: state.undoGroup.present.boxLevelSelected,
    indexSelected: state.undoGroup.present.indexSelected,
    navItemsIds: state.undoGroup.present.navItemsIds,
    navItems: state.undoGroup.present.navItemsById,
    navItemSelected: state.undoGroup.present.navItemSelected,
    containedViews: state.undoGroup.present.containedViewsById,
    containedViewSelected: state.undoGroup.present.containedViewSelected,
    undoDisabled: !state.undoGroup.past || state.undoGroup.past.length === 0,
    redoDisabled: !state.undoGroup.future || state.undoGroup.future.length === 0,
    displayMode: state.undoGroup.present.displayMode,
    marks: state.undoGroup.present.marksById,
    pluginToolbars: state.undoGroup.present.pluginToolbarsById,
    viewToolbars: state.undoGroup.present.viewToolbarsById,
    exercises: state.undoGroup.present.exercises,
    isBusy: state.undoGroup.present.isBusy,
    lastActionDispatched: state.undoGroup.present.lastActionDispatched || "",
    animationsById: state.undoGroup.present.animationsById,
    soundList: soundListFromState,
    // The InteractivePlugin "Öğeler" right panel reads selection state
    // (selectedSceneId / selectedElementId) from interactivityStudio via
    // getState() inside render. That slice lives OUTSIDE undoGroup, so without
    // subscribing here connect() would shallow-equal-skip re-render on a pure
    // selectScenarioElement / selectScene dispatch — leaving the property
    // editor stuck on the previously rendered element.
    interactivityStudio: state.interactivityStudio,
  };
}

// EditorApp = DragDropContext(HTML5Backend)(EditorApp);
export default connect(mapStateToProps)(EditorApp);

// export default DragDropContext(HTML5Backend)(connect(mapStateToProps)(EditorApp));

EditorApp.propTypes = {
  globalConfig: PropTypes.object.isRequired,
  filesUploaded: PropTypes.any,
  boxes: PropTypes.object.isRequired,
  boxSelected: PropTypes.any,
  boxLevelSelected: PropTypes.any,
  indexSelected: PropTypes.any,
  marks: PropTypes.object,
  navItemsIds: PropTypes.array.isRequired,
  navItems: PropTypes.object.isRequired,
  navItemSelected: PropTypes.any,
  containedViews: PropTypes.object.isRequired,
  containedViewSelected: PropTypes.any,
  pluginToolbars: PropTypes.object,
  undoDisabled: PropTypes.bool,
  redoDisabled: PropTypes.bool,
  displayMode: PropTypes.string,
  viewToolbars: PropTypes.object.isRequired,
  exercises: PropTypes.object,
  isBusy: PropTypes.any,
  dispatch: PropTypes.func.isRequired,
  store: PropTypes.any,
  lastActionDispatched: PropTypes.string,
  status: PropTypes.string,
  everPublished: PropTypes.bool,
};
